// src/Badge/Badge.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  bottom: ",
        ";\n  left: ",
        ";\n  z-index: 1;\n  pointer-events: ",
        ";\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: ",
        ";\n  min-width: ",
        ";\n  height: ",
        ";\n  border-radius: 999px;\n\n  color: ",
        ";\n  background: ",
        ";\n  box-shadow: ",
        ";\n\n  border: ",
        ";\n\n  font-size: ",
        ";\n\n  span {\n    user-select: none;\n    transform: translate(\n      ",
        ",\n      ",
        "\n    );\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      transform: translate(\n        ",
        ",\n        ",
        "\n      );\n    "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin: ",
        ";\n  color: ",
        ";\n  opacity: ",
        ";\n  font-size: ",
        ";\n  cursor: ",
        ";\n\n  ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    opacity: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  cursor: ",
        ";\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n\n  width: ",
        ";\n  height: ",
        ";\n  padding: 0;\n\n  border: none;\n  border-radius: ",
        ";\n\n  cursor: pointer;\n  user-select: none;\n  color: ",
        ";\n  background: ",
        ";\n  font-size: ",
        ";\n\n  &:focus {\n    outline: none;\n    filter: brightness(1.1);\n  }\n  &:active {\n    filter: brightness(1.2);\n  }\n  &:disabled {\n    cursor: default;\n    opacity: 0.5;\n\n    &:focus,\n    &:active {\n      filter: none;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: ",
        ";\n  align-items: center;\n  width: 100%;\n\n  text-transform: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ",
        ";\n  min-width: ",
        "px;\n  width: ",
        "px;\n  max-width: ",
        "px;\n  background: ",
        ";\n\n  border: none;\n  border-radius: ",
        ";\n  border-width: ",
        ";\n\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: ",
        ";\n  right: ",
        ";\n  bottom: ",
        ";\n  left: ",
        ";\n  z-index: ",
        ";\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n\n  color: ",
        ";\n  background: ",
        ";\n  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.2);\n\n  transition: all 0.2s ease;\n  i {\n    transform: translateY(1px);\n  }\n\n  ",
        " {\n    &:hover {\n      transform: rotate(90deg);\n      box-shadow: 1px 1px 6px 1px rgba(0, 0, 0, 0.3);\n\n      i {\n        transform: translateY(1px);\n      }\n\n      ",
        ";\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n      box-shadow: ",
        ";\n    "
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n        color: ",
        ";\n      "
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n        background: ",
        ";\n      "
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n          color: ",
        ";\n        "
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n          background: ",
        ";\n        "
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  ",
        ";\n\n  overflow: hidden;\n  cursor: ",
        ";\n\n  &:hover {\n    ",
        ";\n    ",
        ";\n\n    .--card-content {\n      ",
        ";\n      ",
        ";\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n\n  font-size: ",
        ";\n  text-align: ",
        ";\n  text-transform: ",
        ";\n\n  color: ",
        ";\n  background: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  font-size: ",
        ";\n  text-align: ",
        ";\n  text-transform: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  display: ",
        ";\n  align-items: center;\n  justify-content: center;\n\n  ",
        "\n\n  cursor: ",
        ";\n\n  label {\n    cursor: ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n\n  width: ",
        ";\n  height: ",
        ";\n\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n\n  background-color: ",
        ";\n\n  i {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  width: ",
        ";\n  height: ",
        ";\n\n  input {\n    width: ",
        ";\n    height: 100%;\n    padding-left: 4px;\n\n    color: ",
        ";\n    background: ",
        ";\n    border: solid ",
        ";\n    ",
        "\n    border-left-width: 0px;\n    border-radius: 0 ",
        "\n      ",
        " 0;\n\n    font-size: 0.8rem;\n\n    &:focus {\n      outline: none;\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 42px;\n  height: 100%;\n\n  ",
        "\n  border-right-width: 0px;\n  border-radius: ",
        " 0 0\n    ",
        ";\n\n  cursor: pointer;\n\n  &::after {\n    content: '",
        "';\n    font-family: 'Font Awesome 6 Pro';\n    color: ",
        ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background-color: ",
        ";\n    border-radius: ",
        " 0 0\n      ",
        ";\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(",
        "px, 0);\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0);\n  }\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        ".6s"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n\n  div {\n    position: absolute;\n    top: ",
        "px;\n    width: ",
        "px;\n    height: ",
        "px;\n    border-radius: 50%;\n    background: ",
        ";\n    animation-timing-function: cubic-bezier(0, 1, 1, 0);\n  }\n  div:nth-child(1) {\n    left: ",
        "px;\n    animation: ",
        " 0.6s infinite;\n  }\n  div:nth-child(2) {\n    left: ",
        "px;\n    animation: ",
        "",
        " infinite;\n  }\n  div:nth-child(3) {\n    left: ",
        "px;\n    animation: ",
        " 0.6s infinite;\n  }\n  div:nth-child(4) {\n    left: ",
        "px;\n    animation: ",
        " 0.6s infinite;\n  }\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  border-radius: 50%;\n  width: ",
        "px;\n  height: ",
        "px;\n\n  &::after {\n    border-radius: 50%;\n    width: ",
        "px;\n    height: ",
        "px;\n  }\n\n  text-indent: -9999em;\n  border-top: ",
        "px solid\n    ",
        ";\n  border-right: ",
        "px solid\n    ",
        ";\n  border-bottom: ",
        "px solid\n    ",
        ";\n  border-left: ",
        "px solid\n    ",
        ";\n  transform: translateZ(0);\n  animation: ",
        " ",
        "s infinite linear;\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  0% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n  5%,\n  95% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n  10%,\n  59% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;\n  }\n  20% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;\n  }\n  38% {\n    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;\n  }\n  100% {\n    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;\n  }\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n\n  width: ",
        "px;\n  height: ",
        "px;\n  margin-top: 8px;\n  border-radius: 50%;\n\n  color: ",
        ";\n  font-size: ",
        "px;\n  text-indent: -9999em;\n  overflow: hidden;\n\n  transform: translateZ(0);\n  animation: ",
        " ",
        "s infinite ease,\n    ",
        " ",
        "s infinite ease;\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    border-radius: 50%;\n  }\n\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n  position: relative;\n  border-radius: 50%;\n  color: ",
        ";\n  box-shadow: inset 0 0 0 ",
        "px;\n  transform: translateZ(0);\n\n  &::before {\n    width: ",
        "px;\n    height: ",
        "px;\n    background: ",
        ";\n    border-radius: ",
        "px 0 0\n      ",
        "px;\n    top: -",
        "px;\n    left: -",
        "px;\n    transform-origin: ",
        "px\n      ",
        "px;\n    animation: ",
        " ",
        "s infinite ease\n      ",
        "s;\n  }\n  &::after {\n    width: ",
        "px;\n    height: ",
        "px;\n    background: ",
        ";\n    border-radius: 0 ",
        "px\n      ",
        "px 0;\n    top: -",
        "px;\n    left: ",
        "px;\n    transform-origin: ",
        "px\n      ",
        "px;\n    animation: ",
        " ",
        "s infinite ease;\n  }\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n  "
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n\n  transform-origin: 50% 0;\n  transform: scale(",
        ");\n\n  div {\n    animation: ",
        " ",
        "s linear infinite;\n    transform-origin: 40px 40px;\n\n    &::after {\n      content: ' ';\n      display: block;\n      position: absolute;\n      top: 3px;\n      left: 37px;\n      width: 6px;\n      height: 18px;\n      border-radius: 20%;\n      background: ",
        ";\n    }\n    ",
        "\n  }\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  will-change: transform;\n\n  color: ",
        ";\n  font-size: 0.7rem;\n  white-space: nowrap;\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: 6px;\n\n  color: ",
        ";\n  background: ",
        ";\n  font-size: ",
        ";\n  text-align: ",
        ";\n\n  ",
        ";\n\n  border-radius: ",
        ";\n\n  transition: border-color 0.1s linear;\n\n  &:focus {\n    outline: 0;\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n        i {\n          color: ",
        " !important;\n        }\n      "
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-width: ",
        "px;\n  width: ",
        "px;\n  max-width: ",
        "px;\n  background: ",
        ";\n\n  ",
        ";\n\n  border-radius: ",
        ";\n  border-width: ",
        ";\n\n  color: ",
        ";\n\n  cursor: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  top: 1px;\n  right: 16px;\n  height: 100%;\n  transition: color 0.2s linear;\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  right: 6px;\n  transform: translateY(-50%);\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 100%;\n  z-index: ",
        ";\n  max-height: 250px;\n  overflow: hidden;\n\n  ",
        "\n\n  color: ",
        ";\n  background-color: ",
        ";\n  border: solid ",
        ";\n  border-width: 0 1px 1px 1px;\n\n  border-top-left-radius: 0;\n  border-top-left-radius: 0;\n  border-top-left-radius: 0;\n  border-top-left-radius: 0;\n\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n\n  box-shadow: 0 4px 4px -4px rgba(0, 0, 0, 0.2);\n\n  div.--input-autocomplete-inner {\n    width: 100%;\n    max-height: 250px;\n    overflow-y: auto;\n  }\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n      background-color: ",
        ";\n\n      &::before {\n        content: '\\f0da';\n        font-family: 'Font Awesome 6 Pro';\n        font-size: 0.8rem;\n        font-weight: 900;\n        margin-right: 2px;\n        transform: translateY(1px);\n      }\n    "
    ], [
        "\n      background-color: ",
        ";\n\n      &::before {\n        content: '\\\\f0da';\n        font-family: 'Font Awesome 6 Pro';\n        font-size: 0.8rem;\n        font-weight: 900;\n        margin-right: 2px;\n        transform: translateY(1px);\n      }\n    "
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  padding: 4px;\n  font-size: 0.8em;\n  user-select: none;\n  text-align: left;\n\n  &:hover {\n    background-color: ",
        ";\n\n    &::before {\n      content: '\\f0da';\n      font-family: 'Font Awesome 6 Pro';\n      font-size: 0.8rem;\n      font-weight: 900;\n      margin-right: 2px;\n      transform: translateY(1px);\n    }\n  }\n\n  ",
        "\n"
    ], [
        "\n  padding: 4px;\n  font-size: 0.8em;\n  user-select: none;\n  text-align: left;\n\n  &:hover {\n    background-color: ",
        ";\n\n    &::before {\n      content: '\\\\f0da';\n      font-family: 'Font Awesome 6 Pro';\n      font-size: 0.8rem;\n      font-weight: 900;\n      margin-right: 2px;\n      transform: translateY(1px);\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  place-self: center;\n  right: 10px;\n  color: ",
        ";\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: ",
        ";\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n      input {\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    "
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n\n  & > div:first-child input {\n    border-right: 0;\n  }\n  & > div:last-child input {\n    border-left: 0;\n  }\n  .--input-icon-right {\n    border-radius: 0 ",
        "\n      ",
        " 0;\n  }\n  .sep {\n    width: 1px;\n    height: 100%;\n    background-color: ",
        ";\n  }\n  &:focus-within .sep {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);\n  pointer-events: none;\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n      position: absolute;\n      top: calc(100% + 4px);\n      left: 0;\n      z-index: 1;\n      will-change: transform, opacity;\n    "
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n      border-radius: 0 0 ",
        "\n        ",
        ";\n      border-top: 0;\n    "
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  width: 100%;\n  padding: 8px 6px 6px;\n  background-color: ",
        ";\n  ",
        "\n  border-radius: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n      position: absolute;\n      top: calc(100% + 4px);\n      left: 0;\n      z-index: 1;\n      will-change: transform, opacity;\n    "
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n      border-radius: 0 0 ",
        "\n        ",
        ";\n      border-top: 0;\n    "
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  width: 100%;\n  padding: 8px 6px 6px;\n\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 8px;\n\n  background-color: ",
        ";\n  ",
        "\n  border-radius: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-size: 0.8rem;\n  text-transform: capitalize;\n\n  span {\n    cursor: pointer;\n\n    &:hover {\n      color: ",
        ";\n    }\n    &:not(:last-of-type) {\n      margin-right: 0.6ch;\n    }\n  }\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  margin-top: 8px;\n\n  display: grid;\n  grid-template-columns: repeat(\n    ",
        ",\n    1fr\n  );\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 0;\n\n  font-size: 0.8rem;\n  ",
        "\n  user-select: none;\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n        &:hover {\n          background: ",
        ";\n        }\n      "
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n      background: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n        background: ",
        ";\n        color: ",
        ";\n\n        &:hover {\n          background: ",
        ";\n        }\n      "
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  opacity: ",
        ";\n  border: 1px solid rgba(0, 0, 0, 0);\n\n  border-radius: ",
        ";\n\n  ",
        "\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  opacity: 0.7;\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(3, auto);\n  gap: 6px;\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 36px;\n\n  border: 1px solid\n    ",
        ";\n  border-radius: 6px;\n  font-size: 0.7rem;\n  text-transform: capitalize;\n  user-select: none;\n  cursor: pointer;\n\n  &:hover {\n    background: linear-gradient(10deg, #9dbccf, #b5d3e6);\n  }\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  padding: 0 6px;\n  user-select: none;\n\n  div.--date-range-picker-curtain-month-name {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n      pointer-events: none;\n      touch-action: none;\n      visibility: hidden;\n    "
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-block;\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  padding: ",
        ";\n\n  color: ",
        ";\n  background: ",
        ";\n\n  font-size: ",
        ";\n  text-transform: ",
        ";\n  user-select: ",
        ";\n  cursor: ",
        ";\n\n  ",
        "\n  border-radius: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  width: 100%;\n  height: ",
        ";\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n      top: 0;\n      ",
        ";\n      transform: translateX(",
        ");\n    "
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n        top: -",
        ";\n        transform: translateY(-100%);\n      "
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n        top: calc(100% + ",
        ");\n      "
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n        top: 0;\n        left: -",
        ";\n        transform: translateX(-100%);\n      "
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n        top: 0;\n        left: calc(100% + ",
        ");\n      "
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: ",
        ";\n\n  width: ",
        ";\n  min-width: ",
        ";\n\n  color: ",
        ";\n  background: ",
        ";\n\n  ",
        "\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n\n  ",
        " {\n    padding: ",
        ";\n\n    font-size: ",
        ";\n    text-transform: ",
        ";\n    user-select: ",
        ";\n    white-space: ",
        ";\n    cursor: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n      background: ",
        ";\n    }\n\n    &:first-of-type {\n      border-top-left-radius: ",
        ";\n      border-top-right-radius: ",
        ";\n    }\n    &:last-of-type {\n      border-bottom-left-radius: ",
        ";\n      border-bottom-right-radius: ",
        ";\n    }\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject87 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _tagged_template_literal([
        "\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100vw;\n      height: 100vh;\n\n      display: ",
        ";\n    "
    ]);
    _templateObject88 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _tagged_template_literal([
        "\n  box-sizing: border-box;\n  position: relative;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ",
        ";\n  height: ",
        ";\n  z-index: ",
        ";\n\n  overflow: hidden;\n  background: ",
        ";\n\n  ",
        "\n\n  img {\n    position: absolute;\n    max-width: 100vw;\n    max-height: 100%;\n    object-fit: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject89 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: ",
        ";\n  margin: 0 auto;\n  margin-bottom: ",
        ";\n  padding: 12px 0;\n\n  color: ",
        ";\n  background-color: ",
        ";\n\n  opacity: ",
        ";\n  transition: opacity 0.2s linear;\n\n  p {\n    margin: 4px 0 0 0;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject90 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: ",
        ";\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  touch-action: none;\n\n  div {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n\n    padding: 1rem 1rem 0.8rem;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 8px;\n\n    cursor: pointer;\n    pointer-events: auto;\n    touch-action: auto;\n    transition: background-color 0.2s ease-out;\n\n    i {\n      font-size: 4rem;\n      color: rgba(255, 255, 255, 0.4);\n      transition: color 0.2s ease-out;\n    }\n    &:hover {\n      background-color: black;\n\n      i {\n        color: rgba(255, 255, 255, 0.8);\n      }\n    }\n    &.--image-viewer-nav-arrows-left {\n      left: 20px;\n      display: ",
        ";\n    }\n    &.--image-viewer-nav-arrows-right {\n      right: 20px;\n      display: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject91 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: 10;\n  bottom: 10px;\n  right: 0;\n  padding: 6px 8px 6px 10px;\n\n  user-select: none;\n  pointer-events: none;\n  touch-action: none;\n\n  border-radius: 8px 0 0 8px;\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  font-size: 0.8rem;\n\n  opacity: ",
        ";\n  transition: opacity 0.2s linear;\n\n  span {\n    color: #777;\n  }\n"
    ]);
    _templateObject92 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: ",
        ";\n  top: 16px;\n  left: 16px;\n"
    ]);
    _templateObject93 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: ",
        ";\n"
    ]);
    _templateObject94 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _tagged_template_literal([
        "\n  display: ",
        ";\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject95 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: ",
        ";\n  max-width: ",
        ";\n  padding: ",
        ";\n\n  display: grid;\n  grid-template-columns: auto auto;\n\n  font-size: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n\n  ",
        "\n  border-radius: ",
        ";\n  background-clip: padding-box;\n\n  i {\n    grid-column: 1;\n    align-self: center;\n  }\n  span {\n    grid-column: 2;\n  }\n"
    ]);
    _templateObject96 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  z-index: ",
        ";\n"
    ]);
    _templateObject97 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: ",
        ";\n  cursor: default;\n\n  background-color: ",
        ";\n"
    ]);
    _templateObject98 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  z-index: ",
        ";\n  cursor: default;\n\n  ",
        "\n"
    ]);
    _templateObject99 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n\n  div.buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 1rem;\n\n    text-transform: uppercase;\n    font-size: 0.8rem;\n\n    & > * + * {\n      margin-left: 1rem;\n    }\n  }\n"
    ]);
    _templateObject100 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n\n  color: ",
        ";\n  background: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n\n  cursor: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject101 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  flex-direction: ",
        ";\n  gap: ",
        ";\n\n  .--radio-group-checkbox {\n    justify-content: start;\n    align-items: center;\n\n    /* TODO remove this when flex gap support is widespread */\n    &:not(:last-of-type) {\n      margin: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject102 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _tagged_template_literal([
        "\n  display: inline-grid;\n  grid-auto-flow: ",
        ";\n  gap: ",
        ";\n\n  ",
        ";\n  ",
        ";\n  ",
        ";\n\n  & > * {\n    justify-self: start;\n    align-self: start;\n  }\n"
    ]);
    _templateObject103 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject104 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject105 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: ",
        ";\n\n  width: ",
        ";\n  min-width: ",
        ";\n  max-width: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject106 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _tagged_template_literal([
        "\n      border-radius: ",
        "\n        ",
        " 0 0;\n      border-width: 1px 1px 0 1px;\n    "
    ]);
    _templateObject107 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _tagged_template_literal([
        "\n      background-color: #f8f8f8;\n    "
    ]);
    _templateObject108 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _tagged_template_literal([
        "\n        border-color: ",
        ";\n      "
    ]);
    _templateObject109 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n\n  border: ",
        ";\n  border-radius: ",
        ";\n\n  color: ",
        ";\n  background: ",
        ";\n  user-select: none;\n\n  ",
        "\n\n  ",
        "\n\n  div.--select-display-inner {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    padding: 4px 4px 0;\n  }\n  span.--select-placeholder {\n    margin-left: 4px;\n    padding-bottom: 4px;\n    font-size: 0.8rem;\n    color: ",
        ";\n  }\n\n  &:focus {\n    outline: none;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject110 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 6px;\n  padding: 4px;\n  border-radius: 4px;\n\n  color: ",
        ";\n  background: ",
        ";\n  font-size: 0.8em;\n  cursor: pointer;\n\n  &:hover {\n    color: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject111 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _tagged_template_literal([
        "\n  height: ",
        ";\n\n  span.--select-display-selected {\n    margin-left: 4px;\n    padding-bottom: 4px;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject112 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _tagged_template_literal([
        "\n  min-height: ",
        ";\n"
    ]);
    _templateObject113 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _tagged_template_literal([
        "\n  text-align: center;\n  align-self: center;\n  width: 32px;\n  font-size: 0.8rem;\n"
    ]);
    _templateObject114 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _tagged_template_literal([
        "\n  box-sizing: border-box;\n  position: absolute;\n  z-index: 4000;\n  width: 100%;\n  max-height: 250px;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  border: ",
        ";\n  border-width: 0 1px 1px 1px;\n  border-radius: 0 0\n    ",
        ";\n  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.15);\n\n  color: ",
        ";\n  background: ",
        ";\n\n  &:focus {\n    outline: none;\n  }\n\n  div.--select-inner {\n    width: 100%;\n    max-height: 250px;\n  }\n"
    ]);
    _templateObject115 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _tagged_template_literal([
        "\n        background: ",
        ";\n      "
    ]);
    _templateObject116 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _tagged_template_literal([
        "\n      &:hover {\n        background: ",
        ";\n      }\n      ",
        "\n    "
    ]);
    _templateObject117 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _tagged_template_literal([
        "\n  padding: 6px;\n  font-size: 0.8rem;\n  user-select: none;\n  text-align: left;\n\n  ",
        "\n"
    ]);
    _templateObject118 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _tagged_template_literal([
        "\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n\n  font-size: 0.8rem;\n  padding: 4px 8px;\n  background: ",
        ";\n  border-radius: 8px;\n  color: ",
        ";\n  user-select: none;\n\n  &:not(:last-of-type) {\n    margin-right: 6px;\n  }\n  i {\n    transform: translateY(1px);\n    margin-left: 4px;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject119 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  padding: 4px 8px;\n\n  input {\n    width: 100%;\n    padding: 4px 4px 4px 22px;\n    border: 0;\n    border-radius: 2px;\n    background-color: #f6f6f9;\n    font-size: 0.8rem;\n\n    &:focus,\n    &:active {\n      outline: none;\n    }\n  }\n  &::before {\n    content: '\\f002';\n    font-family: 'Font Awesome 6 Pro';\n    font-size: 0.8rem;\n    color: #889;\n\n    position: absolute;\n    top: calc(50% + 2px);\n    left: 12px;\n    transform: translateY(-50%);\n  }\n"
    ], [
        "\n  position: relative;\n  padding: 4px 8px;\n\n  input {\n    width: 100%;\n    padding: 4px 4px 4px 22px;\n    border: 0;\n    border-radius: 2px;\n    background-color: #f6f6f9;\n    font-size: 0.8rem;\n\n    &:focus,\n    &:active {\n      outline: none;\n    }\n  }\n  &::before {\n    content: '\\\\f002';\n    font-family: 'Font Awesome 6 Pro';\n    font-size: 0.8rem;\n    color: #889;\n\n    position: absolute;\n    top: calc(50% + 2px);\n    left: 12px;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject120 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: ",
        ";\n"
    ]);
    _templateObject121 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: ",
        ";\n  padding: 6px;\n  padding-bottom: ",
        ";\n\n  resize: ",
        ";\n  outline: none;\n\n  font-size: ",
        ";\n  font-family: inherit;\n  color: ",
        ";\n  background: ",
        ";\n\n  ",
        "\n  border-radius: ",
        ";\n\n  transition: border 0.3s ease-in-out;\n\n  &:focus {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject122 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: 1;\n  left: 12px;\n  right: 12px;\n  bottom: 12px;\n\n  display: flex;\n  justify-content: space-between;\n\n  span {\n    color: ",
        ";\n    font-size: 0.8rem;\n    transform: translate(-7px, 6px);\n  }\n"
    ]);
    _templateObject123 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n\n  ",
        ";\n"
    ]);
    _templateObject124 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _tagged_template_literal([
        "\n  width: ",
        ";\n  height: ",
        ";\n  object-fit: ",
        ";\n  clip-path: ",
        ";\n\n  ",
        "\n  border-radius: ",
        ";\n  cursor: ",
        ";\n"
    ]);
    _templateObject125 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: ",
        ";\n"
    ]);
    _templateObject126 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _tagged_template_literal([
        "\n      transition: transform 0.2s ease;\n      will-change: transform;\n\n      &:hover {\n        transform: scale(",
        ");\n      }\n    "
    ]);
    _templateObject127 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _tagged_template_literal([
        "\n  margin-right: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject128 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _tagged_template_literal([
        "\n  padding: 0;\n  border: 0;\n  background: inherit;\n  text-align: center;\n\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject129 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: ",
        ";\n\n  ",
        " {\n    color: ",
        ";\n    font-size: ",
        ";\n  }\n\n  span.--time-picker-separator {\n    transform: translateY(-2px);\n    color: ",
        ";\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject130 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  width: ",
        ";\n  min-width: ",
        ";\n  max-width: ",
        ";\n  height: 100%;\n  padding: ",
        ";\n\n  background: ",
        ";\n\n  ",
        "\n  border-radius: ",
        ";\n\n  transition: border-color 0.1s linear;\n\n  &:focus-within {\n    outline: 0;\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject131 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = _tagged_template_literal([
        "\n        i {\n          color: ",
        " !important;\n        }\n      "
    ]);
    _templateObject132 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-width: ",
        "px;\n  width: ",
        "px;\n  max-width: ",
        "px;\n  background: ",
        ";\n\n  ",
        "\n  border-radius: ",
        ";\n  border-width: ",
        ";\n\n  color: ",
        ";\n\n  cursor: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject133 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  z-index: 11000;\n  width: ",
        "px;\n  height: ",
        ";\n\n  display: grid;\n  grid-template-columns:\n    ",
        "\n    1fr\n    ",
        ";\n\n  background: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  overflow: hidden;\n\n  div.icon {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    width: ",
        "px;\n    height: ",
        ";\n\n    font-size: 2rem;\n  }\n  div.content {\n    display: flex;\n    justify-content: ",
        ";\n    align-items: ",
        ";\n\n    height: ",
        ";\n    padding: ",
        ";\n\n    font-size: 0.8rem;\n    color: ",
        ";\n    user-select: none;\n  }\n  div.close-icon {\n    display: flex;\n    justify-content: center;\n    width: 32px;\n    padding-top: 0.5rem;\n  }\n\n  ",
        " {\n    width: calc(100vw - 1rem);\n    right: 0.5rem;\n    bottom: 0.5rem;\n  }\n"
    ]);
    _templateObject134 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = _tagged_template_literal([
        "\n  0% {\n    width: 0%;\n  }\n  100% {\n    width: 100%;\n  }\n"
    ]);
    _templateObject135 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: ",
        ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    background-color: ",
        ";\n    animation: ",
        " ",
        "ms;\n    animation-timing-function: linear;\n    animation-iteration-count: 1;\n    animation-fill-mode: forwards;\n  }\n"
    ]);
    _templateObject136 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = _tagged_template_literal([
        "\n      transition: background-color ",
        "ms\n        linear;\n    "
    ]);
    _templateObject137 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = _tagged_template_literal([
        "\n      cursor: not-allowed;\n    "
    ]);
    _templateObject138 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        ";\n\n  background: ",
        ";\n\n  ",
        "\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  cursor: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 1px 2px highlight;\n  }\n"
    ]);
    _templateObject139 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  width: ",
        ";\n  height: calc(100% - ",
        "px);\n  top: ",
        "px;\n\n  background: ",
        ";\n  border-radius: ",
        ";\n  background-clip: padding-box;\n  box-shadow: ",
        ";\n  cursor: ",
        ";\n"
    ]);
    _templateObject140 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = _tagged_template_literal([
        "\n  visibility: ",
        ";\n\n  position: absolute;\n  left: ",
        ";\n  top: ",
        ";\n  z-index: 1;\n\n  ",
        ";\n  pointer-events: none;\n\n  width: ",
        ";\n  height: ",
        ";\n  padding: ",
        ";\n\n  border: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n\n  color: ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject141 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = _tagged_template_literal([
        "\n  padding: 0;\n\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject142 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
// src/util/style.ts
import get from "lodash/get";
// src/themes/light.theme.ts
var theme = {
    colors: {
        urGreen: "#37DBD0",
        urBlue: "#0077C0",
        urShadow: "#005594",
        primary: "#0077c0",
        secondary: "#37dbd0",
        accent: "#005594",
        highlight: "#2881b8",
        placeholder: "#9d9ca6",
        error: "#dd2c00",
        success: "#4a934a",
        warning: "#b5af0e",
        info: "#2fa3bd",
        gray1: "#3C3D48",
        gray2: "#54555F",
        gray3: "#6B6C74",
        gray4: "#7A7A81",
        gray5: "#9798A1",
        gray6: "#ADAEB4",
        gray7: "#D5D5DC",
        gray8: "#E3E3E8",
        gray9: "#F3F3F3",
        blueGray: "#9dbccf",
        veryLightBlue: "#f2f7fa",
        lightBlue: "#dcecf5",
        text: {
            dark: "#17171a",
            light: "#f8f7fa",
            disabled: "#c6c4cf",
            gray: "#83868a"
        },
        border: {
            default: "#dadadd"
        }
    },
    sizes: {
        defaultBorderRadius: "4px"
    },
    layout: {
        defaultShadow: "0 0 6px 2px rgba(0, 0, 0, 0.2)",
        defaultBorder: "1px solid #dadadd"
    },
    media: {
        mobile: "@media screen and (max-width: 768px)",
        desktop: "@media screen and (min-width: 769px)"
    }
};
var light_theme_default = theme;
// src/util/common.ts
function getCurrentTheme() {
    return light_theme_default;
}
// src/util/style.ts
function overloadColor(color) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (typeof color === "undefined") return "";
    var theme2 = getCurrentTheme();
    return get(theme2.colors, color, fallback !== null && fallback !== void 0 ? fallback : color);
}
function validateHex(hex) {
    if (!hex) return null;
    if (hex.charAt(0) === "#") hex = hex.substring(1);
    if (hex.length !== 3 && hex.length !== 4 && hex.length !== 6 && hex.length !== 8) {
        return null;
    }
    if (hex.length < 6) hex = hex.split("").reduce(function(acc, cur) {
        return acc + cur + cur;
    }, "");
    if (!/^([a-f0-9]{2}){3,4}$/i.test(hex)) {
        return null;
    }
    return hex;
}
function rgbFromHex(hex) {
    var validated = validateHex(hex);
    if (!validated) return null;
    var red = parseInt(validated.substring(0, 2), 16);
    var green = parseInt(validated.substring(2, 4), 16);
    var blue = parseInt(validated.substring(4, 6), 16);
    return [
        red,
        green,
        blue
    ];
}
function contrastColor(hex) {
    var lightColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "white", darkColor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "#333333", fallback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "#333333";
    if (!hex) return overloadColor(fallback);
    var fromHex = rgbFromHex(overloadColor(hex));
    if (!fromHex) return overloadColor(fallback);
    var _fromHex = _sliced_to_array(fromHex, 3), r = _fromHex[0], g = _fromHex[1], b = _fromHex[2];
    var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    if (luminance > 0.5) return overloadColor(darkColor);
    else return overloadColor(lightColor);
}
// src/util/typechecks.ts
function isUndefined(arg) {
    return typeof arg === "undefined";
}
function isFunction(arg) {
    return typeof arg === "function";
}
// src/Badge/Badge.tsx
import { jsx } from "react/jsx-runtime";
var Wrapper = styled.div(_templateObject(), function(props) {
    return props.$top;
}, function(props) {
    return props.$right;
}, function(props) {
    return props.$bottom;
}, function(props) {
    return props.$left;
}, function(props) {
    return props.$pointerEvents;
}, function(props) {
    var _props_$width;
    return (_props_$width = props.$width) !== null && _props_$width !== void 0 ? _props_$width : "".concat(props.$size, "px");
}, function(props) {
    return props.$minWidth;
}, function(props) {
    var _props_$height;
    return (_props_$height = props.$height) !== null && _props_$height !== void 0 ? _props_$height : "".concat(props.$size, "px");
}, function(props) {
    return props.$color ? overloadColor(props.$color) : contrastColor(props.$background);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$boxShadow;
}, function(props) {
    return props.$border;
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return props.$translateTextX;
}, function(props) {
    return props.$translateTextY;
});
var Badge = function(param) {
    var className = param.className, id = param.id, text = param.text, top = param.top, right = param.right, bottom = param.bottom, left = param.left, width = param.width, minWidth = param.minWidth, height = param.height, _param_size = param.size, size = _param_size === void 0 ? 16 : _param_size, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? "0.6rem" : _param_fontSize, color = param.color, _param_background = param.background, background = _param_background === void 0 ? "primary" : _param_background, _param_boxShadow = param.boxShadow, boxShadow = _param_boxShadow === void 0 ? "0 0 2px 1px rgba(0, 0, 0, 0.3)" : _param_boxShadow, _param_noShadow = param.noShadow, noShadow = _param_noShadow === void 0 ? false : _param_noShadow, border = param.border, _param_enablePointerEvents = param.enablePointerEvents, enablePointerEvents = _param_enablePointerEvents === void 0 ? false : _param_enablePointerEvents, _param_translateTextX = param.translateTextX, translateTextX = _param_translateTextX === void 0 ? "0px" : _param_translateTextX, _param_translateTextY = param.translateTextY, translateTextY = _param_translateTextY === void 0 ? "0px" : _param_translateTextY;
    if (isUndefined(top) && isUndefined(right) && isUndefined(bottom) && isUndefined(left)) {
        top = "-6px";
        right = "-6px";
    }
    return /* @__PURE__ */ jsx(Wrapper, {
        className: className,
        id: id,
        $top: top,
        $right: right,
        $bottom: bottom,
        $left: left,
        $width: width,
        $minWidth: minWidth,
        $height: height,
        $size: size,
        $fontSize: fontSize,
        $color: color,
        $background: background,
        $boxShadow: noShadow ? void 0 : boxShadow,
        $border: border,
        $translateTextX: translateTextX,
        $translateTextY: translateTextY,
        $pointerEvents: enablePointerEvents ? "all" : "none",
        children: /* @__PURE__ */ jsx("span", {
            children: text
        })
    });
};
// src/Icon/Icon.tsx
import { useMemo } from "react";
import styled2, { css } from "styled-components";
// src/Icon/util.ts
var iconTypeClassNames = {
    thin: "fa-thin",
    light: "fa-light",
    regular: "fa-regular",
    solid: "fa-solid",
    brand: "fa-brands",
    duotone: "fa-duotone"
};
var getIconTypeClassName = function(type) {
    return iconTypeClassNames[type];
};
// src/Icon/Icon.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var I = styled2.i(_templateObject2(), function(props) {
    return props.$margin;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return props.$opacity;
}, function(props) {
    return props.$size;
}, function(props) {
    return props.$cursor;
}, function(props) {
    var _props_$translateX, _props_$translateY;
    return (props.$translateX || props.$translateY) && css(_templateObject1(), (_props_$translateX = props.$translateX) !== null && _props_$translateX !== void 0 ? _props_$translateX : "0", (_props_$translateY = props.$translateY) !== null && _props_$translateY !== void 0 ? _props_$translateY : "0");
}, function(props) {
    return props.$hoverColor && overloadColor(props.$hoverColor);
}, function(props) {
    var _props_$hoverOpacity;
    return (_props_$hoverOpacity = props.$hoverOpacity) !== null && _props_$hoverOpacity !== void 0 ? _props_$hoverOpacity : props.$opacity;
});
var Icon = function(param) {
    var className = param.className, icon = param.icon, _param_type = param.type, type = _param_type === void 0 ? "regular" : _param_type, _param_fixedWidth = param.fixedWidth, fixedWidth = _param_fixedWidth === void 0 ? false : _param_fixedWidth, _param_swapOpacity = param.swapOpacity, swapOpacity = _param_swapOpacity === void 0 ? false : _param_swapOpacity, title = param.title, _param_color = param.color, color = _param_color === void 0 ? "inherit" : _param_color, hoverColor = param.hoverColor, _param_opacity = param.opacity, opacity = _param_opacity === void 0 ? 1 : _param_opacity, hoverOpacity = param.hoverOpacity, _param_cursor = param.cursor, cursor = _param_cursor === void 0 ? "inherit" : _param_cursor, _param_size = param.size, size = _param_size === void 0 ? "1em" : _param_size, _param_margin = param.margin, margin = _param_margin === void 0 ? "0" : _param_margin, translateX = param.translateX, translateY = param.translateY, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick;
    var iconClass = useMemo(function() {
        return "".concat(getIconTypeClassName(type), " fa-").concat(icon, " ").concat(fixedWidth ? "fa-fw" : "", " ").concat(swapOpacity ? "fa-swap-opacity" : "", " ").concat(className !== null && className !== void 0 ? className : "");
    }, [
        type,
        icon,
        fixedWidth,
        className,
        swapOpacity
    ]);
    return /* @__PURE__ */ jsx2(I, {
        className: iconClass,
        title: title,
        $color: color,
        $hoverColor: hoverColor,
        $opacity: opacity,
        $hoverOpacity: hoverOpacity,
        $cursor: cursor,
        $size: size,
        $margin: margin,
        $translateX: translateX,
        $translateY: translateY,
        onClick: onClick
    });
};
// src/Breadcrumbs/Breadcrumbs.tsx
import uniqueId from "lodash/uniqueId";
import React2, { useMemo as useMemo2 } from "react";
import { Link } from "react-router";
import styled3 from "styled-components";
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var Wrapper2 = styled3.div(_templateObject3());
var IconWrapper = styled3.div(_templateObject4(), function(props) {
    return props.$margin;
}, function(props) {
    return props.$margin;
});
var CrumbText = styled3.div(_templateObject5(), function(props) {
    return props.$fontSize;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return props.$hoverEffect ? "pointer" : "default";
});
var Breadcrumbs = React2.forwardRef(function(param, ref) {
    var className = param.className, id = param.id, crumbs = param.crumbs, _param_overrides = param.overrides, overrides = _param_overrides === void 0 ? {} : _param_overrides, tmp = param.$color, color = tmp === void 0 ? "inherit" : tmp, tmp1 = param.$fontSize, fontSize = tmp1 === void 0 ? "inherit" : tmp1, _param_iconProps = param.iconProps, iconProps = _param_iconProps === void 0 ? {} : _param_iconProps, _param_iconMargins = param.iconMargins, iconMargins = _param_iconMargins === void 0 ? "16px" : _param_iconMargins;
    var handleCrumbClick = function handleCrumbClick(crumb, evt) {
        var _crumb_onClick;
        var res = (_crumb_onClick = crumb.onClick) === null || _crumb_onClick === void 0 ? void 0 : _crumb_onClick.call(crumb, evt);
        if (evt.defaultPrevented) return false;
        return res;
    };
    var linkWrap = function linkWrap(crumb) {
        if (isUndefined(crumb.href)) return /* @__PURE__ */ jsx3("span", {
            onClick: function(e) {
                return handleCrumbClick(crumb, e);
            },
            children: crumb.text
        });
        return /* @__PURE__ */ jsx3(Link, {
            to: crumb.href,
            onClick: function(e) {
                return handleCrumbClick(crumb, e);
            },
            children: crumb.text
        });
    };
    var overriddenCrumbs = useMemo2(function() {
        return crumbs.reduce(function(acc, crumb) {
            var override = overrides[crumb.text];
            if (override === null) return acc;
            var _crumb_id;
            return _to_consumable_array(acc).concat([
                _object_spread_props(_object_spread({}, crumb), {
                    id: (_crumb_id = crumb.id) !== null && _crumb_id !== void 0 ? _crumb_id : uniqueId("crumb"),
                    text: override !== null && override !== void 0 ? override : crumb.text
                })
            ]);
        }, []);
    }, [
        crumbs,
        overrides
    ]);
    return /* @__PURE__ */ jsx3(Wrapper2, {
        ref: ref,
        className: className,
        id: id,
        children: overriddenCrumbs.map(function(crumb, index) {
            var _crumb_color;
            return /* @__PURE__ */ jsxs(React2.Fragment, {
                children: [
                    !!index && /* @__PURE__ */ jsx3(IconWrapper, {
                        $margin: iconMargins,
                        children: /* @__PURE__ */ jsx3(Icon, _object_spread({
                            icon: "chevron-right"
                        }, iconProps))
                    }),
                    /* @__PURE__ */ jsx3(CrumbText, {
                        className: crumb.className,
                        $hoverEffect: !isUndefined(crumb.onClick) || !isUndefined(crumb.href),
                        $color: (_crumb_color = crumb.color) !== null && _crumb_color !== void 0 ? _crumb_color : color,
                        $fontSize: fontSize,
                        onClick: function(evt) {
                            return handleCrumbClick(crumb, evt);
                        },
                        children: linkWrap(crumb)
                    })
                ]
            }, crumb.id);
        })
    });
});
// src/Breadcrumbs/RouteBreadcrumbs.tsx
import React3, { useCallback as useCallback2, useState } from "react";
// src/util/hooks/useClickOutside.ts
import { useCallback, useEffect } from "react";
function useClickOutside(ref, callback) {
    var detectEscape = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    for(var _len = arguments.length, include = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        include[_key - 3] = arguments[_key];
    }
    var handleMouseDown = useCallback(function(evt) {
        if (!ref.current) return;
        var clicked = evt.target;
        if (ref.current.contains(clicked)) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = include[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var other = _step.value;
                if (!other.current) continue;
                if (other.current.contains(clicked)) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callback(evt);
    }, [
        ref,
        callback,
        include
    ]);
    var handleKeyDown = useCallback(function(evt) {
        if (!detectEscape || !_instanceof(evt, KeyboardEvent) || evt.key !== "Escape") return;
        callback(evt);
    }, [
        detectEscape,
        callback
    ]);
    useEffect(function() {
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("touchstart", handleMouseDown);
        if (detectEscape) document.addEventListener("keydown", handleKeyDown);
        return function() {
            document.removeEventListener("mousedown", handleMouseDown);
            document.removeEventListener("touchstart", handleMouseDown);
            if (detectEscape) document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        detectEscape,
        handleMouseDown,
        handleKeyDown
    ]);
}
// src/util/hooks/useLocationEffect.ts
import { useEffect as useEffect2 } from "react";
import { useLocation, useNavigationType } from "react-router";
function useLocationEffect(callback) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var location = useLocation();
    var navType = useNavigationType();
    useEffect2(function() {
        if (!enabled) return;
        callback(location, navType);
    }, [
        callback,
        enabled,
        location,
        navType
    ]);
}
// src/Breadcrumbs/RouteBreadcrumbs.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var RouteBreadcrumbs = React3.forwardRef(function(_param, ref) {
    var mainPageTitle = _param.mainPageTitle, overrideCrumb = _param.overrideCrumb, _param_inserts = _param.inserts, inserts = _param_inserts === void 0 ? [] : _param_inserts, otherProps = _object_without_properties(_param, [
        "mainPageTitle",
        "overrideCrumb",
        "inserts"
    ]);
    var landingTitle = mainPageTitle !== null && mainPageTitle !== void 0 ? mainPageTitle : "Dashboard";
    var _useState = _sliced_to_array(useState([]), 2), crumbs = _useState[0], setCrumbs = _useState[1];
    var updateCrumbs = useCallback2(function(pathname) {
        var subpaths = pathname.split("/").filter(function(x) {
            return x !== "";
        });
        var subpathURLs = [
            "/"
        ];
        subpaths.forEach(function(path, index) {
            return subpathURLs.push(subpathURLs[index].concat(path, "/"));
        });
        var routeCrumbs = [
            {
                text: landingTitle,
                href: "/"
            }
        ];
        subpaths.forEach(function(path, index) {
            var _routeCrumbs;
            var overridden = null;
            if (typeof overrideCrumb !== "undefined") {
                overridden = overrideCrumb(path, index, subpaths.length);
                if (overridden === null) return;
            }
            routeCrumbs.push(_object_spread({
                text: path,
                href: subpathURLs[index + 1]
            }, overridden));
            var insertHere = inserts.filter(function(insert) {
                return insert.index === index;
            });
            if (!insertHere.length) return;
            (_routeCrumbs = routeCrumbs).push.apply(_routeCrumbs, _to_consumable_array(insertHere.map(function(param) {
                var crumb = param.crumb;
                return crumb;
            })));
        });
        setCrumbs(routeCrumbs);
    }, [
        inserts,
        landingTitle,
        overrideCrumb
    ]);
    useLocationEffect(useCallback2(function(location) {
        updateCrumbs(location.pathname);
    }, [
        updateCrumbs
    ]));
    return /* @__PURE__ */ jsx4(Breadcrumbs, _object_spread({
        ref: ref,
        crumbs: crumbs
    }, otherProps));
});
// src/Breadcrumbs/index.ts
Breadcrumbs.Route = RouteBreadcrumbs;
var Breadcrumbs2 = Breadcrumbs;
// src/Button/Button.tsx
import React4, { useCallback as useCallback3 } from "react";
import styled4, { useTheme } from "styled-components";
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var ButtonWrapper = styled4.button(_templateObject6(), function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$fontSize;
});
var Content = styled4.div(_templateObject7(), function(props) {
    return props.$center ? "center" : "flex-start";
}, function(props) {
    return props.$textTransform;
}, function(props) {
    return props.$padding;
});
var ICON_WIDTH = 42;
var IconWrapper2 = styled4.div(_templateObject8(), function(props) {
    return props.$height;
}, ICON_WIDTH, ICON_WIDTH, ICON_WIDTH, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$position === "left" ? "".concat(props.$borderRadius, " 0 0 ").concat(props.$borderRadius) : "0 ".concat(props.$borderRadius, " ").concat(props.$borderRadius, " 0");
}, function(props) {
    return props.$position === "left" ? "1px 0 1px 1px" : "1px 1px 1px 0";
}, function(props) {
    return contrastColor(overloadColor(props.$buttonBackground), "#dde", "#557", "#dde");
});
var Button = React4.forwardRef(function(param, ref) {
    var className = param.className, id = param.id, children = param.children, _param_type = param.type, type = _param_type === void 0 ? "submit" : _param_type, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, autoFocus = param.autoFocus, iconLeftProps = param.iconLeftProps, iconRightProps = param.iconRightProps, _param_width = param.width, width = _param_width === void 0 ? "auto" : _param_width, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, _param_height = param.height, height = _param_height === void 0 ? "32px" : _param_height, _param_padding = param.padding, padding = _param_padding === void 0 ? "0 1rem" : _param_padding, borderRadius = param.borderRadius, _param_color = param.color, color = _param_color === void 0 ? "text.light" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "primary" : _param_background, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? "1em" : _param_fontSize, _param_textTransform = param.textTransform, textTransform = _param_textTransform === void 0 ? "none" : _param_textTransform, _param_centerContent = param.centerContent, centerContent = _param_centerContent === void 0 ? false : _param_centerContent, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick;
    var theme2 = useTheme();
    var overrideIconClick = useCallback3(function(position, evt) {
        if (position === "left" && !isUndefined(iconLeftProps) && isFunction(iconLeftProps.onClick)) iconLeftProps.onClick(evt);
        else if (position === "right" && !isUndefined(iconRightProps) && isFunction(iconRightProps.onClick)) iconRightProps.onClick(evt);
    }, [
        iconLeftProps,
        iconRightProps
    ]);
    var parsedBorderRadius = borderRadius !== null && borderRadius !== void 0 ? borderRadius : theme2.sizes.defaultBorderRadius;
    var _iconLeftProps_background;
    var iconLeftBackground = (_iconLeftProps_background = iconLeftProps === null || iconLeftProps === void 0 ? void 0 : iconLeftProps.background) !== null && _iconLeftProps_background !== void 0 ? _iconLeftProps_background : "urShadow";
    var _iconRightProps_background;
    var iconRightBackground = (_iconRightProps_background = iconRightProps === null || iconRightProps === void 0 ? void 0 : iconRightProps.background) !== null && _iconRightProps_background !== void 0 ? _iconRightProps_background : "urShadow";
    return /* @__PURE__ */ jsxs2(ButtonWrapper, {
        ref: ref,
        className: className,
        id: id,
        type: type,
        tabIndex: tabIndex,
        disabled: disabled,
        autoFocus: autoFocus,
        $width: fullWidth ? "100%" : width,
        $height: height,
        $borderRadius: parsedBorderRadius,
        $color: color,
        $background: background,
        $fontSize: fontSize,
        onClick: onClick,
        children: [
            iconLeftProps && /* @__PURE__ */ jsx5(IconWrapper2, {
                className: "--button-icon-left",
                $position: "left",
                color: color,
                $background: iconLeftBackground,
                $height: height,
                $buttonBackground: background,
                $borderRadius: parsedBorderRadius,
                onClick: function(e) {
                    return overrideIconClick("left", e);
                },
                children: /* @__PURE__ */ jsx5(Icon, _object_spread_props(_object_spread({}, iconLeftProps), {
                    onClick: void 0
                }))
            }),
            /* @__PURE__ */ jsx5(Content, {
                $textTransform: textTransform,
                className: "--button-content",
                $padding: padding,
                $center: centerContent,
                children: children
            }),
            iconRightProps && /* @__PURE__ */ jsx5(IconWrapper2, {
                className: "--button-icon-right",
                $position: "right",
                color: color,
                $background: iconRightBackground,
                $height: height,
                $buttonBackground: background,
                $borderRadius: parsedBorderRadius,
                onClick: function(e) {
                    return overrideIconClick("right", e);
                },
                children: /* @__PURE__ */ jsx5(Icon, _object_spread_props(_object_spread({}, iconRightProps), {
                    onClick: void 0
                }))
            })
        ]
    });
});
// src/Button/ActionButton.tsx
import React5 from "react";
import { useNavigate } from "react-router";
import styled5 from "styled-components";
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var StyledButton = styled5(Button)(_templateObject9(), function(props) {
    return props.$top;
}, function(props) {
    return props.$right;
}, function(props) {
    return props.$bottom;
}, function(props) {
    return props.$left;
}, function(props) {
    return props.$zIndex;
}, function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.theme.media.desktop;
}, function(props) {
    return props.$hoverBackground && "\n        background: ".concat(overloadColor(props.$hoverBackground), ";\n      ");
});
var ActionButton = React5.forwardRef(function(param, ref) {
    var children = param.children, className = param.className, to = param.to, role = param.role, _param_top = param.top, top = _param_top === void 0 ? "auto" : _param_top, _param_right = param.right, right = _param_right === void 0 ? "auto" : _param_right, _param_bottom = param.bottom, bottom = _param_bottom === void 0 ? "auto" : _param_bottom, _param_left = param.left, left = _param_left === void 0 ? "auto" : _param_left, _param_zIndex = param.zIndex, zIndex = _param_zIndex === void 0 ? 3e3 /* Loaders */  : _param_zIndex, _param_size = param.size, size = _param_size === void 0 ? "48px" : _param_size, _param_iconProps = param.iconProps, iconProps = _param_iconProps === void 0 ? {} : _param_iconProps, _param_noIcon = param.noIcon, noIcon = _param_noIcon === void 0 ? false : _param_noIcon, _param_color = param.color, color = _param_color === void 0 ? "white" : _param_color, hoverColor = param.hoverColor, _param_background = param.background, background = _param_background === void 0 ? "primary" : _param_background, hoverBackground = param.hoverBackground, onClick = param.onClick;
    var handleClick = function handleClick(evt) {
        onClick === null || onClick === void 0 ? void 0 : onClick(evt);
        if (evt.defaultPrevented || !to) return;
        navigate(to);
    };
    var navigate = useNavigate();
    var overloadedIconProps = _object_spread({
        icon: "plus"
    }, iconProps);
    return /* @__PURE__ */ jsxs3(StyledButton, {
        ref: ref,
        className: className,
        role: role !== null && role !== void 0 ? role : !!to ? "link" : void 0,
        $top: top,
        $right: right,
        $bottom: bottom,
        $left: left,
        $zIndex: zIndex,
        $size: size,
        $color: color,
        $hoverColor: hoverColor,
        $background: background,
        $hoverBackground: hoverBackground,
        onClick: handleClick,
        children: [
            !noIcon && /* @__PURE__ */ jsx6(Icon, _object_spread({}, overloadedIconProps)),
            children
        ]
    });
});
// src/Card/Card.tsx
import { useCallback as useCallback4 } from "react";
import { useNavigate as useNavigate2 } from "react-router";
import styled6, { css as css2, useTheme as useTheme2 } from "styled-components";
// src/util/props/border.ts
function borderStyle(border, width, style, color) {
    var ret = "";
    if (!isUndefined(border)) ret += "border: ".concat(border, ";");
    if (!isUndefined(width)) ret += "border-width: ".concat(width, ";");
    if (!isUndefined(style)) ret += "border-style: ".concat(style, ";");
    if (!isUndefined(color)) ret += "border-color: ".concat(overloadColor(color), ";");
    return ret;
}
function getBorderStyle(props) {
    return borderStyle(props.$border, props.$borderWidth, props.$borderStyle, props.$borderColor);
}
// src/Card/Card.tsx
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var Wrapper3 = styled6.section(_templateObject15(), function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    var _props_$shadow;
    return !props.$noShadow && css2(_templateObject10(), (_props_$shadow = props.$shadow) !== null && _props_$shadow !== void 0 ? _props_$shadow : props.theme.layout.defaultShadow);
}, function(props) {
    return props.$cursor;
}, function(props) {
    return props.$hoverColor && css2(_templateObject11(), overloadColor(props.$hoverColor));
}, function(props) {
    return props.$hoverBackground && css2(_templateObject12(), overloadColor(props.$hoverBackground));
}, function(props) {
    return props.$hoverColor && css2(_templateObject13(), overloadColor(props.$hoverColor));
}, function(props) {
    return props.$hoverBackground && css2(_templateObject14(), overloadColor(props.$hoverBackground));
});
var Header = styled6.header(_templateObject16(), function(props) {
    return props.$padding;
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return props.$textAlign;
}, function(props) {
    return props.$textTransform;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle);
var Content2 = styled6.div(_templateObject17(), function(props) {
    return props.$padding;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return props.$textAlign;
}, function(props) {
    return props.$textTransform;
});
var Card = function(param) {
    var className = param.className, children = param.children, ref = param.ref, shadow = param.shadow, _param_noShadow = param.noShadow, noShadow = _param_noShadow === void 0 ? false : _param_noShadow, _param_borderRadius = param.borderRadius, borderRadius = _param_borderRadius === void 0 ? "8px" : _param_borderRadius, _param_cursor = param.cursor, cursor = _param_cursor === void 0 ? "auto" : _param_cursor, href = param.href, hrefState = param.hrefState, title = param.title, _param_headerProps = param.headerProps, headerProps = _param_headerProps === void 0 ? {} : _param_headerProps, _param_contentProps = param.contentProps, contentProps = _param_contentProps === void 0 ? {} : _param_contentProps, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick;
    var theme2 = useTheme2();
    var navigate = useNavigate2();
    var defaultedHeaderProps = _object_spread({
        $padding: "8px 12px",
        $textAlign: "left",
        $textTransform: "none",
        $fontSize: "1em",
        $color: "text.dark",
        $background: "veryLightBlue",
        $border: "1px solid ".concat(theme2.colors.gray8),
        $borderWidth: "0 0 1px 0"
    }, headerProps);
    var defaultedContentProps = _object_spread({
        $padding: "8px 12px",
        $textAlign: "left",
        $textTransform: "none",
        $fontSize: "1em",
        $color: "text.dark",
        $background: "white"
    }, contentProps);
    var handleClick = useCallback4(function(evt) {
        if (!isUndefined(href)) navigate(href, !hrefState ? void 0 : {
            state: hrefState
        });
        onClick(evt);
    }, [
        href,
        hrefState,
        navigate,
        onClick
    ]);
    return /* @__PURE__ */ jsxs4(Wrapper3, {
        className: className,
        ref: ref,
        $shadow: shadow,
        $noShadow: noShadow,
        $borderRadius: borderRadius,
        $cursor: cursor,
        role: isUndefined(href) ? void 0 : "link",
        $background: defaultedContentProps.$background,
        $hoverColor: defaultedContentProps.$hoverColor,
        $hoverBackground: defaultedContentProps.$hoverBackground,
        onClick: handleClick,
        children: [
            !isUndefined(title) && /* @__PURE__ */ jsx7(Header, _object_spread_props(_object_spread({
                className: "--card-header"
            }, defaultedHeaderProps), {
                children: title
            })),
            /* @__PURE__ */ jsx7(Content2, _object_spread_props(_object_spread({
                className: "--card-content"
            }, defaultedContentProps), {
                children: children
            }))
        ]
    });
};
// src/Checkbox/Checkbox.tsx
import React7, { useLayoutEffect, useRef } from "react";
import styled7 from "styled-components";
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var Wrapper4 = styled7.div(_templateObject18(), function(props) {
    return props.$inline ? "inline-flex" : "flex";
}, function(props) {
    return props.$vertical && "flex-direction: column;";
}, function(props) {
    return props.$cursor;
}, function(props) {
    return props.$cursor;
});
var Box = styled7.div(_templateObject19(), function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return props.$checked || props.$indeterminate ? overloadColor(props.$color) : overloadColor(props.$background);
});
function getLabelPositionCSS(position, margin) {
    switch(position){
        case "right":
            return "\n        margin-left: ".concat(margin, ";\n      ");
        case "left":
            return "\n        order: -1;\n        margin-right: ".concat(margin, ";\n      ");
        case "above":
            return "\n        order: -1;\n        margin-bottom: ".concat(margin, ";\n      ");
        case "below":
            return "\n        margin-top: ".concat(margin, ";\n      ");
    }
}
var Label = styled7.label(_templateObject20(), function(props) {
    return getLabelPositionCSS(props.$position, props.$margin);
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return overloadColor(props.$color);
});
var Checkbox = React7.forwardRef(function(param, ref) {
    var className = param.className, id = param.id, checked = param.checked, _param_indeterminate = param.indeterminate, indeterminate = _param_indeterminate === void 0 ? false : _param_indeterminate, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_inline = param.inline, inline = _param_inline === void 0 ? true : _param_inline, label = param.label, _param_labelPosition = param.labelPosition, labelPosition = _param_labelPosition === void 0 ? "right" : _param_labelPosition, _param_labelMargin = param.labelMargin, labelMargin = _param_labelMargin === void 0 ? "6px" : _param_labelMargin, _param_indeterminateIconProps = param.indeterminateIconProps, indeterminateIconProps = _param_indeterminateIconProps === void 0 ? {} : _param_indeterminateIconProps, _param_checkedIconProps = param.checkedIconProps, checkedIconProps = _param_checkedIconProps === void 0 ? {} : _param_checkedIconProps, cursor = param.cursor, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? "1em" : _param_fontSize, _param_color = param.color, color = _param_color === void 0 ? "text.dark" : _param_color, _param_boxSize = param.boxSize, boxSize = _param_boxSize === void 0 ? "22px" : _param_boxSize, boxWidth = param.boxWidth, boxHeight = param.boxHeight, _param_boxColor = param.boxColor, boxColor = _param_boxColor === void 0 ? "primary" : _param_boxColor, _param_boxBackground = param.boxBackground, boxBackground = _param_boxBackground === void 0 ? "white" : _param_boxBackground, _param_boxBorderRadius = param.boxBorderRadius, boxBorderRadius = _param_boxBorderRadius === void 0 ? "4px" : _param_boxBorderRadius, onKeyDown = param.onKeyDown, onClick = param.onClick, onChange = param.onChange;
    var emitChange = function emitChange(value) {
        if (disabled) return;
        onChange(value);
    };
    var handleKeyDown = function handleKeyDown(evt) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(evt);
        if (evt.defaultPrevented) return;
        if (evt.key === "Enter" || evt.key === " ") emitChange(!checked);
    };
    var handleClick = function handleClick(evt) {
        onClick === null || onClick === void 0 ? void 0 : onClick(evt);
        if (evt.defaultPrevented) return;
        emitChange(!checked);
    };
    var checkboxRef = useRef(null);
    useLayoutEffect(function() {
        if (!checkboxRef.current) return;
        checkboxRef.current.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    var iconProps = indeterminate ? indeterminateIconProps : checkedIconProps;
    return /* @__PURE__ */ jsxs5(Wrapper4, {
        ref: ref,
        className: className,
        id: id,
        tabIndex: disabled ? void 0 : tabIndex,
        $inline: inline,
        $vertical: labelPosition === "above" || labelPosition === "below",
        $cursor: cursor !== null && cursor !== void 0 ? cursor : disabled ? "default" : "pointer",
        onKeyDown: handleKeyDown,
        onClick: handleClick,
        children: [
            /* @__PURE__ */ jsx8("input", {
                ref: checkboxRef,
                hidden: true,
                type: "checkbox",
                checked: checked,
                disabled: disabled,
                onChange: function() {
                    return void 0;
                }
            }),
            /* @__PURE__ */ jsx8(Box, {
                className: "--checkbox-box" + (checked ? " --checkbox-box-checked" : ""),
                $checked: checked,
                $indeterminate: indeterminate,
                $width: boxWidth !== null && boxWidth !== void 0 ? boxWidth : boxSize,
                $height: boxHeight !== null && boxHeight !== void 0 ? boxHeight : boxSize,
                $color: boxColor,
                $background: boxBackground,
                $borderRadius: boxBorderRadius,
                children: checked || indeterminate ? /* @__PURE__ */ jsx8(Icon, _object_spread({
                    className: "--checkbox-box-icon",
                    icon: indeterminate ? "minus" : "check",
                    size: "0.8rem",
                    translateY: "1px",
                    color: "white"
                }, iconProps)) : /* @__PURE__ */ jsx8("i", {})
            }),
            label && /* @__PURE__ */ jsx8(Label, {
                className: "--checkbox-label",
                $position: labelPosition,
                $fontSize: fontSize,
                $color: color,
                $margin: labelMargin,
                children: label
            })
        ]
    });
});
// src/ColorPicker/ColorPicker.tsx
import { useRef as useRef2, useState as useState2, useMemo as useMemo3, useCallback as useCallback5 } from "react";
import styled8, { useTheme as useTheme3 } from "styled-components";
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var Wrapper5 = styled8.div(_templateObject21(), function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
}, function(props) {
    return props.$width;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return overloadColor(props.$borderColor);
}, getBorderStyle, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.theme.sizes.defaultBorderRadius;
});
var ColorBox = styled8.div(_templateObject22(), getBorderStyle, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.$valid ? "" : "\f00d";
}, function(props) {
    return props.theme.colors.error;
}, function(props) {
    return props.$valid ? props.$color : "inherit";
}, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.theme.sizes.defaultBorderRadius;
});
var ColorPicker = function(param) {
    var className = param.className, id = param.id, value = param.value, _param_width = param.width, width = _param_width === void 0 ? "auto" : _param_width, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, _param_height = param.height, height = _param_height === void 0 ? "32px" : _param_height, _param_color = param.color, color = _param_color === void 0 ? "text.dark" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background, border = param.$border, borderWidth = param.$borderWidth, borderStyle2 = param.$borderStyle, borderColor = param.$borderColor, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick, _param_onColorBoxClick = param.onColorBoxClick, onColorBoxClick = _param_onColorBoxClick === void 0 ? function() {
        return void 0;
    } : _param_onColorBoxClick, onChange = param.onChange;
    var pickerRef = useRef2(null);
    var theme2 = useTheme3();
    var _useState2 = _sliced_to_array(useState2(validateHex(value) !== null), 2), valid = _useState2[0], setValid = _useState2[1];
    var withHex = function(clr) {
        return "#" + clr.split("#").pop();
    };
    var handleColorBoxClick = useCallback5(function(evt) {
        if (!pickerRef.current) return;
        onColorBoxClick(evt);
        if (evt.defaultPrevented) return;
        pickerRef.current.click();
    }, [
        onColorBoxClick
    ]);
    var handleChange = useCallback5(function(evt) {
        var clr = withHex(evt.target.value);
        if (!/^#[a-f0-9]*$/i.test(clr)) return;
        setValid(validateHex(clr) !== null);
        onChange(clr);
    }, [
        onChange
    ]);
    var parsedBorder = useMemo3(function() {
        return border !== null && border !== void 0 ? border : theme2.layout.defaultBorder;
    }, [
        border,
        theme2.layout.defaultBorder
    ]);
    return /* @__PURE__ */ jsxs6(Wrapper5, {
        className: className,
        id: id,
        $width: fullWidth ? "100%" : width,
        $height: height,
        $border: parsedBorder,
        $borderWidth: borderWidth,
        $borderStyle: borderStyle2,
        $borderColor: borderColor,
        $color: color,
        $background: background,
        onClick: onClick,
        children: [
            /* @__PURE__ */ jsx9(ColorBox, {
                $color: value,
                $valid: valid,
                $border: parsedBorder,
                $borderWidth: borderWidth,
                $borderStyle: borderStyle2,
                $borderColor: borderColor,
                onClick: handleColorBoxClick
            }),
            /* @__PURE__ */ jsx9("input", {
                value: value,
                maxLength: 9,
                onChange: handleChange
            }),
            /* @__PURE__ */ jsx9("input", {
                ref: pickerRef,
                hidden: true,
                type: "color",
                value: value,
                onChange: handleChange
            })
        ]
    });
};
// src/ComponentSwitch/ComponentSwitch.tsx
import React9, { useCallback as useCallback6 } from "react";
// src/ComponentSwitch/ComponentSwitchCase.tsx
import { Fragment, jsx as jsx10 } from "react/jsx-runtime";
var ComponentSwitchCase = function(param) {
    var children = param.children;
    return /* @__PURE__ */ jsx10(Fragment, {
        children: children
    });
};
// src/ComponentSwitch/ComponentSwitch.tsx
import { Fragment as Fragment2, jsx as jsx11 } from "react/jsx-runtime";
var ComponentSwitch = function(param) {
    var children = param.children;
    var getValidChildren = useCallback6(function() {
        var returnChildren = [];
        React9.Children.forEach(children, function(child) {
            if (!React9.isValidElement(child)) return;
            if (typeof child.props.case === "undefined" && typeof child.props.default === "undefined") return;
            if (typeof child.props.case !== "undefined" && typeof child.props.case !== "boolean") return;
            if (typeof child.props.default !== "undefined" && typeof child.props.default !== "boolean") return;
            returnChildren.push(child);
        });
        return returnChildren;
    }, [
        children
    ]);
    var getDefaultChild = useCallback6(function(validChildren) {
        var _validChildren_find;
        return (_validChildren_find = validChildren.find(function(c) {
            return typeof c.props.default === "boolean";
        })) !== null && _validChildren_find !== void 0 ? _validChildren_find : /* @__PURE__ */ jsx11(Fragment2, {
            children: null
        });
    }, []);
    var renderCase = useCallback6(function() {
        var validChildren = getValidChildren();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = validChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (child.props.case) return child;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var defaultChild = getDefaultChild(validChildren);
        return React9.cloneElement(defaultChild);
    }, [
        getValidChildren,
        getDefaultChild
    ]);
    return /* @__PURE__ */ jsx11(Fragment2, {
        children: renderCase()
    });
};
ComponentSwitch.Case = ComponentSwitchCase;
var ComponentSwitchWithCase = ComponentSwitch;
// src/DatePicker/DatePicker.tsx
import { setMonth, setYear } from "date-fns";
import { AnimatePresence as AnimatePresence2 } from "framer-motion";
import range2 from "lodash/range";
import React14, { useCallback as useCallback8, useEffect as useEffect6, useImperativeHandle, useMemo as useMemo6, useRef as useRef6, useState as useState6 } from "react";
import { useTheme as useTheme5 } from "styled-components";
// src/Input/Input.tsx
import FuzzySearch from "fuzzy-search";
import React11, { useCallback as useCallback7, useEffect as useEffect4, useMemo as useMemo4, useRef as useRef4, useState as useState4 } from "react";
import styled15, { css as css5, useTheme as useTheme4 } from "styled-components";
// src/Loader/dots/ellipsis.ts
import styled9, { css as css3, keyframes } from "styled-components";
var ellipsis1 = keyframes(_templateObject23());
var ellipsis2 = function(size) {
    return keyframes(_templateObject24(), size);
};
var ellipsis3 = keyframes(_templateObject25());
var DotsEllipsis = styled9.div(_templateObject27(), function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
}, function(props) {
    return props.$size * 0.4;
}, function(props) {
    return props.$size * 0.1625;
}, function(props) {
    return props.$size * 0.1625;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return props.$size * 0.1;
}, ellipsis1, function(props) {
    return props.$size * 0.1;
}, function(props) {
    return ellipsis2(props.$size * 0.3);
}, css3(_templateObject26()), function(props) {
    return props.$size * 0.4;
}, function(props) {
    return ellipsis2(props.$size * 0.3);
}, function(props) {
    return props.$size * 0.7;
}, ellipsis3);
// src/Loader/DotsLoader.tsx
import { jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var DotsLoader = function(param) {
    var _param_type = param.type, type = _param_type === void 0 ? "ellipsis" : _param_type, _param_size = param.size, size = _param_size === void 0 ? 46 : _param_size, _param_colorPrimary = param.colorPrimary, colorPrimary = _param_colorPrimary === void 0 ? "primary" : _param_colorPrimary;
    switch(type){
        case "ellipsis":
            return /* @__PURE__ */ jsxs7(DotsEllipsis, {
                $color: colorPrimary,
                $size: size,
                children: [
                    /* @__PURE__ */ jsx12("div", {}),
                    /* @__PURE__ */ jsx12("div", {}),
                    /* @__PURE__ */ jsx12("div", {}),
                    /* @__PURE__ */ jsx12("div", {})
                ]
            });
    }
};
// src/Loader/SpinnerLoader.tsx
import { useState as useState3 } from "react";
// src/Loader/spinner/stroke.ts
import styled10, { keyframes as keyframes2 } from "styled-components";
var rotateAnimation = keyframes2(_templateObject28());
var SpinnerStroke = styled10.div(_templateObject29(), function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
}, function(props) {
    return props.$thickness;
}, function(props) {
    return overloadColor(props.$colorSecondary);
}, function(props) {
    return props.$thickness;
}, function(props) {
    return overloadColor(props.$colorSecondary);
}, function(props) {
    return props.$thickness;
}, function(props) {
    return overloadColor(props.$colorSecondary);
}, function(props) {
    return props.$thickness;
}, function(props) {
    return overloadColor(props.$colorPrimary);
}, rotateAnimation, function(props) {
    return props.$duration;
});
// src/Loader/spinner/tail.ts
import styled11, { keyframes as keyframes3 } from "styled-components";
var rotateAnimation2 = keyframes3(_templateObject30());
var tailAnimation = keyframes3(_templateObject31());
var SpinnerTail = styled11.div(_templateObject32(), function(props) {
    return props.$size / 1.65;
}, function(props) {
    return props.$size / 1.65;
}, function(props) {
    return overloadColor(props.$colorPrimary);
}, function(props) {
    return props.$size / 1.65;
}, tailAnimation, function(props) {
    return props.$duration;
}, rotateAnimation2, function(props) {
    return props.$duration;
});
// src/Loader/spinner/throbbing.ts
import styled12, { keyframes as keyframes4 } from "styled-components";
var rotateAnimation3 = keyframes4(_templateObject33());
var SpinnerThrobbing = styled12.div(_templateObject34(), function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
}, function(props) {
    return overloadColor(props.$colorPrimary);
}, function(props) {
    return props.$thickness;
}, function(props) {
    return props.$size * 0.6;
}, function(props) {
    return props.$size * 1.1;
}, function(props) {
    return props.$background;
}, function(props) {
    return props.$size * 1.02;
}, function(props) {
    return props.$size * 1.02;
}, function(props) {
    return props.$size * 0.03;
}, function(props) {
    return props.$size * 0.05;
}, function(props) {
    return props.$size * 0.51;
}, function(props) {
    return props.$size * 0.51;
}, rotateAnimation3, function(props) {
    return props.$duration;
}, function(props) {
    return props.$duration * 0.75;
}, function(props) {
    return props.$size * 0.6;
}, function(props) {
    return props.$size * 1.1;
}, function(props) {
    return props.$background;
}, function(props) {
    return props.$size * 1.02;
}, function(props) {
    return props.$size * 1.02;
}, function(props) {
    return props.$size * 0.05;
}, function(props) {
    return props.$size * 0.49;
}, function(props) {
    return props.$size * 0.01;
}, function(props) {
    return props.$size * 0.51;
}, rotateAnimation3, function(props) {
    return props.$duration;
});
// src/Loader/spinner/wheel.ts
import styled13, { css as css4, keyframes as keyframes5 } from "styled-components";
var opacityAnimation = keyframes5(_templateObject35());
function createSpokes(duration) {
    var step = duration / 12;
    var divs = "";
    for(var i = 0; i < 12; i++){
        var dur = -duration + step * (i + 1);
        divs += "\n      &:nth-child(".concat(i + 1, ") {\n        transform: rotate(").concat(i * 30, "deg);\n        animation-delay: ").concat(dur, "s;\n      }\n    ");
    }
    return css4(_templateObject36(), divs);
}
var SpinnerWheel = styled13.div(_templateObject37(), function(props) {
    return props.$size / 80;
}, opacityAnimation, function(props) {
    return props.$duration;
}, function(props) {
    return overloadColor(props.$colorPrimary);
}, function(props) {
    return createSpokes(props.$duration);
});
// src/Loader/SpinnerLoader.tsx
import { jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var SpinnerLoader = function(param) {
    var type = param.type, _param_size = param.size, size = _param_size === void 0 ? 46 : _param_size, _param_thickness = param.thickness, thickness = _param_thickness === void 0 ? 3 : _param_thickness, _param_colorPrimary = param.colorPrimary, colorPrimary = _param_colorPrimary === void 0 ? "primary" : _param_colorPrimary, _param_colorSecondary = param.colorSecondary, colorSecondary = _param_colorSecondary === void 0 ? "#0077c022" : _param_colorSecondary, _param_duration = param.duration, duration = _param_duration === void 0 ? 1.1 : _param_duration;
    var discoverBackgroundColor = function discoverBackgroundColor(node) {
        if (!node || !node.parentElement) return;
        var el = node.parentElement;
        var bg = "white";
        while(el !== null){
            var curBg = window.getComputedStyle(el, null).getPropertyValue("background-color");
            if (curBg !== "rgba(0, 0, 0, 0)" && curBg !== "transparent" && curBg !== "") {
                bg = curBg;
                break;
            }
            if (el.tagName === "BODY") break;
            el = el.parentElement;
        }
        setBackground(bg);
    };
    var _useState3 = _sliced_to_array(useState3("white"), 2), background = _useState3[0], setBackground = _useState3[1];
    switch(type){
        case "throbbing":
            return /* @__PURE__ */ jsx13(SpinnerThrobbing, {
                ref: function(node) {
                    return discoverBackgroundColor(node);
                },
                $size: size,
                $thickness: thickness,
                $colorPrimary: colorPrimary,
                $background: background,
                $duration: duration
            });
        case "tail":
            return /* @__PURE__ */ jsx13(SpinnerTail, {
                $size: size,
                $colorPrimary: colorPrimary,
                $duration: duration
            });
        case "wheel":
            return /* @__PURE__ */ jsxs8(SpinnerWheel, {
                $size: size,
                $colorPrimary: colorPrimary,
                $duration: duration,
                children: [
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {}),
                    /* @__PURE__ */ jsx13("div", {})
                ]
            });
        case "stroke":
        default:
            return /* @__PURE__ */ jsx13(SpinnerStroke, {
                $size: size,
                $thickness: thickness,
                $colorPrimary: colorPrimary,
                $colorSecondary: colorSecondary,
                $duration: duration
            });
    }
};
// src/Loader/index.ts
var Loader = {
    Dots: DotsLoader,
    Spinner: SpinnerLoader
};
// src/util/components/ComponentError.tsx
import { AnimatePresence, motion } from "framer-motion";
import styled14 from "styled-components";
// src/util/animation.ts
var ERROR_ANIMATION_VARIANTS = {
    visible: {
        opacity: 1,
        translateY: "-100%"
    },
    hidden: {
        opacity: 0,
        translateY: "-50%"
    }
};
// src/util/hooks/useSleep.ts
import { useRef as useRef3, useEffect as useEffect3 } from "react";
function useSleep() {
    var timerRef = useRef3([]);
    useEffect3(function() {
        return function() {
            return timerRef.current.forEach(window.clearTimeout);
        };
    }, []);
    return function(ms) {
        return new Promise(function(done) {
            timerRef.current.push(window.setTimeout(done, ms));
        });
    };
}
// src/util/components/ComponentError.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var Wrapper6 = styled14(motion.div)(_templateObject38(), function(props) {
    return props.$offsetY;
}, function(props) {
    return props.$offsetX;
}, function(props) {
    return props.theme.colors.error;
});
var ComponentError = function(param) {
    var className = param.className, error = param.error, _param_hide = param.hide, hide = _param_hide === void 0 ? false : _param_hide, _param_offsetX = param.offsetX, offsetX = _param_offsetX === void 0 ? "0" : _param_offsetX, _param_offsetY = param.offsetY, offsetY = _param_offsetY === void 0 ? "0" : _param_offsetY, timeout = param.timeout, onTimeout = param.onTimeout;
    var sleep = useSleep();
    return /* @__PURE__ */ jsx14(AnimatePresence, {
        children: !hide && !!error && /* @__PURE__ */ jsx14(Wrapper6, {
            className: className,
            variants: ERROR_ANIMATION_VARIANTS,
            initial: "hidden",
            animate: "visible",
            exit: "hidden",
            $offsetX: offsetX,
            $offsetY: offsetY,
            onAnimationComplete: function(def) {
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!timeout || !error || typeof def !== "string") return [
                                    2
                                ];
                                return [
                                    4,
                                    sleep(timeout)
                                ];
                            case 1:
                                _state.sent();
                                onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout(def);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            children: error
        })
    });
};
// src/Input/Input.tsx
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var Wrapper7 = styled15.div(_templateObject39(), function(props) {
    return props.$inline ? "inline-flex" : "flex";
}, function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
});
var StyledInput = styled15.input(_templateObject40(), function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return props.$textAlign;
}, getBorderStyle, function(props) {
    var open = props.$autoCompleteOpen;
    var radius = props.$borderRadius;
    switch(props.$iconSide){
        case "left":
            return "0 ".concat(radius, " ").concat(open ? "0" : radius, " 0;");
        case "right":
            return "".concat(radius, " 0 0 ").concat(open ? "0" : radius, ";");
        case "both":
            return "0;";
        case "none":
        default:
            return open ? "".concat(radius, " ").concat(radius, " 0 0;") : "".concat(radius, ";");
    }
}, function(props) {
    return overloadColor(props.$focusBorderColor);
});
var ICON_WIDTH2 = 42;
var IconWrapper3 = styled15.div(_templateObject42(), ICON_WIDTH2, ICON_WIDTH2, ICON_WIDTH2, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle, function(props) {
    return props.$position === "left" ? "".concat(props.$borderRadius, " 0 0 ").concat(props.$borderRadius) : "0 ".concat(props.$borderRadius, " ").concat(props.$borderRadius, " 0");
}, function(props) {
    return props.$position === "left" ? "1px 0 1px 1px" : "1px 1px 1px 0";
}, function(props) {
    return contrastColor(overloadColor(props.$background), "#eef", "#557", "#557");
}, function(props) {
    return props.$cursor;
}, function(props) {
    return overloadColor(props.$hoverBackground);
}, function(props) {
    return props.$hoverIconColor && css5(_templateObject41(), overloadColor(props.$hoverIconColor));
});
var ResetIcon = styled15(Icon)(_templateObject43());
var Loading = styled15.div(_templateObject44());
var AutoCompleteWrapper = styled15.div(_templateObject45(), 5e3 /* Dropdowns */ , function(props) {
    var nIcons = +props.$leftIcon + +props.$rightIcon;
    var width = "calc(100% - (".concat(nIcons, " * ").concat(ICON_WIDTH2, "px))");
    var left = props.$leftIcon ? "".concat(ICON_WIDTH2, "px") : "0";
    return "\n      left: ".concat(left, ";\n      width: ").concat(width, ";\n    ");
}, function(props) {
    return props.$color;
}, function(props) {
    return props.$background;
}, function(props) {
    return props.theme.colors.border.default;
}, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.theme.sizes.defaultBorderRadius;
});
var AutoCompleteItem = styled15.div(_templateObject47(), function(props) {
    return props.theme.colors.veryLightBlue;
}, function(props) {
    return props.$active && css5(_templateObject46(), props.theme.colors.veryLightBlue);
});
var Label2 = styled15.label(_templateObject48(), function(param) {
    var theme2 = param.theme;
    return theme2.colors.gray5;
});
var Input = React11.forwardRef(function(param, ref) {
    var className = param.className, id = param.id, value = param.value, name = param.name, error = param.error, errorTimeout = param.errorTimeout, _param_errorOffsetX = param.errorOffsetX, errorOffsetX = _param_errorOffsetX === void 0 ? "0px" : _param_errorOffsetX, _param_errorOffsetY = param.errorOffsetY, errorOffsetY = _param_errorOffsetY === void 0 ? "-2px" : _param_errorOffsetY, _param_hideErrorMessage = param.hideErrorMessage, hideErrorMessage = _param_hideErrorMessage === void 0 ? false : _param_hideErrorMessage, type = param.type, placeholder = param.placeholder, rightLabel = param.rightLabel, _param_autoFocus = param.autoFocus, autoFocus = _param_autoFocus === void 0 ? false : _param_autoFocus, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, autoComplete = param.autoComplete, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, inputMode = param.inputMode, maxLength = param.maxLength, iconLeftProps = param.iconLeftProps, iconRightProps = param.iconRightProps, autoCompleteSource = param.autoCompleteSource, _param_runAutoCompleteOnFocus = param.runAutoCompleteOnFocus, runAutoCompleteOnFocus = _param_runAutoCompleteOnFocus === void 0 ? false : _param_runAutoCompleteOnFocus, _param_runAutoCompleteWithNoInput = param.runAutoCompleteWithNoInput, runAutoCompleteWithNoInput = _param_runAutoCompleteWithNoInput === void 0 ? false : _param_runAutoCompleteWithNoInput, _param_selectOnFocus = param.selectOnFocus, selectOnFocus = _param_selectOnFocus === void 0 ? false : _param_selectOnFocus, _param_resetButton = param.resetButton, resetButton = _param_resetButton === void 0 ? false : _param_resetButton, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_inline = param.inline, inline = _param_inline === void 0 ? true : _param_inline, _param_width = param.width, width = _param_width === void 0 ? "auto" : _param_width, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, _param_height = param.height, height = _param_height === void 0 ? "32px" : _param_height, _param_color = param.color, color = _param_color === void 0 ? "text.dark" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? "1em" : _param_fontSize, _param_textAlign = param.textAlign, textAlign = _param_textAlign === void 0 ? "left" : _param_textAlign, border = param.$border, borderWidth = param.$borderWidth, borderStyle2 = param.$borderStyle, borderColor = param.$borderColor, borderRadius = param.borderRadius, _param_focusBorderColor = param.focusBorderColor, focusBorderColor = _param_focusBorderColor === void 0 ? "primary" : _param_focusBorderColor, _param_onErrorTimeout = param.onErrorTimeout, onErrorTimeout = _param_onErrorTimeout === void 0 ? function() {
        return void 0;
    } : _param_onErrorTimeout, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick, _param_onKeyDown = param.onKeyDown, onKeyDown = _param_onKeyDown === void 0 ? function() {
        return void 0;
    } : _param_onKeyDown, _param_onEnter = param.onEnter, onEnter = _param_onEnter === void 0 ? function() {
        return void 0;
    } : _param_onEnter, _param_onWheel = param.onWheel, onWheel = _param_onWheel === void 0 ? function() {
        return void 0;
    } : _param_onWheel, _param_onFocus = param.onFocus, onFocus = _param_onFocus === void 0 ? function() {
        return void 0;
    } : _param_onFocus, _param_onBlur = param.onBlur, onBlur = _param_onBlur === void 0 ? function() {
        return void 0;
    } : _param_onBlur, onAutoCompleteItemSelect = param.onAutoCompleteItemSelect, onChange = param.onChange;
    var handleErrorTimeout = function handleErrorTimeout() {
        setInternalError(null);
        onErrorTimeout();
    };
    var handleChange = function handleChange(arg) {
        var doAutoComplete = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var val = typeof arg === "string" ? arg : arg.target.value;
        if (doAutoComplete) updateAutoComplete(val);
        onChange(val, typeof arg === "string" ? void 0 : arg);
    };
    var handleFocus = function handleFocus(evt) {
        onFocus(evt);
        if (evt.defaultPrevented) return;
        if (runAutoCompleteOnFocus) updateAutoComplete(value);
        if (selectOnFocus) evt.target.select();
    };
    var wrapperRef = useRef4(null);
    var theme2 = useTheme4();
    var _useState4 = _sliced_to_array(useState4([]), 2), autoCompleteItems = _useState4[0], setAutoCompleteItems = _useState4[1];
    var _useState41 = _sliced_to_array(useState4(-1), 2), autoCompleteSelectedIndex = _useState41[0], setAutoCompleteSelectedIndex = _useState41[1];
    var _useState42 = _sliced_to_array(useState4(error), 2), internalError = _useState42[0], setInternalError = _useState42[1];
    useEffect4(function() {
        setInternalError(error);
    }, [
        error
    ]);
    useEffect4(function() {
        setAutoCompleteSelectedIndex(-1);
    }, [
        autoCompleteItems
    ]);
    useClickOutside(wrapperRef, function() {
        return setAutoCompleteItems([]);
    });
    var iconSide = useMemo4(function() {
        if (isUndefined(iconLeftProps) && isUndefined(iconRightProps)) return "none";
        else if (isUndefined(iconLeftProps) && !isUndefined(iconRightProps)) return "right";
        else if (!isUndefined(iconLeftProps) && isUndefined(iconRightProps)) return "left";
        else return "both";
    }, [
        iconLeftProps,
        iconRightProps
    ]);
    var parsedBorderRadius = borderRadius !== null && borderRadius !== void 0 ? borderRadius : theme2.sizes.defaultBorderRadius;
    var cycleAutoComplete = useCallback7(function(delta) {
        var clamp = function(n) {
            return Math.max(-1, Math.min(n, autoCompleteItems.length));
        };
        setAutoCompleteSelectedIndex(function() {
            return clamp(autoCompleteSelectedIndex + delta);
        });
    }, [
        autoCompleteItems.length,
        autoCompleteSelectedIndex
    ]);
    var updateAutoComplete = useCallback7(function(query) {
        if (isUndefined(autoCompleteSource) || !runAutoCompleteWithNoInput && query === "") {
            setAutoCompleteItems(function() {
                return [];
            });
            return;
        }
        if (isFunction(autoCompleteSource)) setAutoCompleteItems(function() {
            return autoCompleteSource(query);
        });
        else {
            var searcher = new FuzzySearch(autoCompleteSource, void 0, {
                sort: true
            });
            setAutoCompleteItems(function() {
                return searcher.search(query);
            });
        }
    }, [
        autoCompleteSource,
        runAutoCompleteWithNoInput
    ]);
    var handleAutoCompleteItemClick = useCallback7(function(item, evt) {
        onAutoCompleteItemSelect === null || onAutoCompleteItemSelect === void 0 ? void 0 : onAutoCompleteItemSelect(item, evt);
        if (evt.defaultPrevented) return;
        onChange(item);
        setAutoCompleteItems(function() {
            return [];
        });
    }, [
        onAutoCompleteItemSelect,
        onChange
    ]);
    var overrideIconClick = useCallback7(function(position, evt) {
        if (position === "left" && !isUndefined(iconLeftProps) && isFunction(iconLeftProps.onClick)) iconLeftProps.onClick(evt);
        else if (position === "right" && !isUndefined(iconRightProps) && isFunction(iconRightProps.onClick)) iconRightProps.onClick(evt);
    }, [
        iconLeftProps,
        iconRightProps
    ]);
    var handleKeyDown = useCallback7(function(evt) {
        onKeyDown(evt);
        if (evt.defaultPrevented) return;
        if (!isUndefined(autoCompleteSource)) {
            switch(evt.key){
                case "ArrowDown":
                    evt.preventDefault();
                    cycleAutoComplete(1);
                    break;
                case "ArrowUp":
                    evt.preventDefault();
                    cycleAutoComplete(-1);
                    break;
                case "Enter":
                    onEnter(evt);
                    if (evt.defaultPrevented) return;
                    if (autoCompleteSelectedIndex > -1 && autoCompleteSelectedIndex < autoCompleteItems.length) {
                        var item = autoCompleteItems[autoCompleteSelectedIndex];
                        onAutoCompleteItemSelect === null || onAutoCompleteItemSelect === void 0 ? void 0 : onAutoCompleteItemSelect(item, evt);
                        if (evt.defaultPrevented) return;
                        evt.preventDefault();
                        onChange(autoCompleteItems[autoCompleteSelectedIndex]);
                        setAutoCompleteItems(function() {
                            return [];
                        });
                    }
                    break;
            }
        } else if (evt.key === "Enter") {
            onEnter(evt);
        }
    }, [
        autoCompleteItems,
        autoCompleteSelectedIndex,
        autoCompleteSource,
        cycleAutoComplete,
        onAutoCompleteItemSelect,
        onChange,
        onEnter,
        onKeyDown
    ]);
    var parsedBorder = useMemo4(function() {
        return border !== null && border !== void 0 ? border : theme2.layout.defaultBorder;
    }, [
        border,
        theme2.layout.defaultBorder
    ]);
    var _iconLeftProps_boxBackground, _iconRightProps_boxBackground;
    return /* @__PURE__ */ jsxs9(Wrapper7, {
        ref: wrapperRef,
        className: className,
        id: id,
        $inline: inline,
        $width: fullWidth ? "100%" : width,
        $height: height,
        onClick: onClick,
        children: [
            /* @__PURE__ */ jsx15(ComponentError, {
                className: "--input-error",
                error: internalError,
                hide: hideErrorMessage,
                offsetX: errorOffsetX,
                offsetY: errorOffsetY,
                timeout: errorTimeout,
                onTimeout: handleErrorTimeout
            }),
            iconLeftProps && /* @__PURE__ */ jsx15(IconWrapper3, {
                className: "--input-icon-left",
                $position: "left",
                color: color,
                $background: (_iconLeftProps_boxBackground = iconLeftProps.boxBackground) !== null && _iconLeftProps_boxBackground !== void 0 ? _iconLeftProps_boxBackground : background,
                $hoverBackground: iconLeftProps.boxHoverBackground,
                $hoverIconColor: iconLeftProps.boxHoverIconColor,
                $cursor: iconLeftProps.boxCursor,
                $border: parsedBorder,
                $borderWidth: borderWidth,
                $borderStyle: borderStyle2,
                $borderColor: borderColor,
                $borderRadius: parsedBorderRadius,
                onClick: function(e) {
                    return overrideIconClick("left", e);
                },
                children: /* @__PURE__ */ jsx15(Icon, _object_spread_props(_object_spread({}, iconLeftProps), {
                    onClick: void 0
                }))
            }),
            /* @__PURE__ */ jsx15(StyledInput, {
                ref: ref,
                className: "--input-input",
                value: value,
                name: name,
                type: type,
                autoFocus: autoFocus,
                inputMode: inputMode,
                tabIndex: tabIndex,
                disabled: disabled,
                autoComplete: autoComplete,
                maxLength: maxLength,
                placeholder: placeholder,
                $color: color,
                $background: background,
                $fontSize: fontSize,
                $textAlign: textAlign,
                $border: parsedBorder,
                $borderWidth: borderWidth,
                $borderStyle: borderStyle2,
                $borderColor: borderColor,
                $borderRadius: parsedBorderRadius,
                $focusBorderColor: focusBorderColor,
                $iconSide: iconSide,
                $autoCompleteOpen: !!autoCompleteItems.length,
                onKeyDown: handleKeyDown,
                onWheel: onWheel,
                onFocus: handleFocus,
                onBlur: onBlur,
                onChange: handleChange
            }),
            rightLabel && /* @__PURE__ */ jsx15(Label2, {
                children: rightLabel
            }),
            iconRightProps && /* @__PURE__ */ jsx15(IconWrapper3, {
                className: "--input-icon-right",
                $position: "right",
                color: color,
                $background: (_iconRightProps_boxBackground = iconRightProps.boxBackground) !== null && _iconRightProps_boxBackground !== void 0 ? _iconRightProps_boxBackground : background,
                $hoverBackground: iconRightProps.boxHoverBackground,
                $hoverIconColor: iconRightProps.boxHoverIconColor,
                $cursor: iconRightProps.boxCursor,
                $border: parsedBorder,
                $borderWidth: borderWidth,
                $borderStyle: borderStyle2,
                $borderColor: borderColor,
                $borderRadius: parsedBorderRadius,
                onClick: function(e) {
                    return overrideIconClick("right", e);
                },
                children: /* @__PURE__ */ jsx15(Icon, _object_spread_props(_object_spread({}, iconRightProps), {
                    onClick: void 0
                }))
            }),
            resetButton && /* @__PURE__ */ jsx15(ResetIcon, {
                className: "--input-reset-icon",
                icon: "times",
                color: value === "" ? "gray6" : "primary",
                onClick: function() {
                    return handleChange("");
                }
            }),
            loading && /* @__PURE__ */ jsx15(Loading, {
                children: /* @__PURE__ */ jsx15(Loader.Spinner, {
                    size: 20,
                    thickness: 2
                })
            }),
            autoCompleteSource && !!autoCompleteItems.length && /* @__PURE__ */ jsx15(AutoCompleteWrapper, {
                className: "--input-autocomplete",
                $leftIcon: !!iconLeftProps,
                $rightIcon: !!iconRightProps,
                $color: color,
                $background: background,
                children: /* @__PURE__ */ jsx15("div", {
                    className: "--input-autocomplete-inner",
                    children: autoCompleteItems.map(function(item, index) {
                        return /* @__PURE__ */ jsx15(AutoCompleteItem, {
                            className: "--input-autocomplete-item",
                            $active: autoCompleteSelectedIndex === index,
                            onClick: function(evt) {
                                return handleAutoCompleteItemClick(item, evt);
                            },
                            children: item
                        }, index + item);
                    })
                })
            })
        ]
    });
});
// src/Input/NumberInput.tsx
import React12, { useEffect as useEffect5, useLayoutEffect as useLayoutEffect2, useRef as useRef5, useState as useState5 } from "react";
import styled16 from "styled-components";
import { jsx as jsx16 } from "react/jsx-runtime";
var Input2 = styled16(Input)(_templateObject49());
var NumberInput = React12.forwardRef(function(_param, ref) {
    var scrollValue = function scrollValue(decrease) {
        if (inputProps.disabled) return;
        if (decrease) {
            if (value - step < min) return;
            onChange(value - step);
        } else {
            if (value + step > max) return;
            onChange(value + step);
        }
    };
    var handleBlur = function handleBlur(evt) {
        var _inputProps_onBlur;
        if (value < min) {
            handleChange(min + "", evt);
            return;
        }
        if (value > max) {
            handleChange(max + "", evt);
            return;
        }
        if (inputValue === "-") {
            handleChange("0", evt);
            return;
        }
        (_inputProps_onBlur = inputProps.onBlur) === null || _inputProps_onBlur === void 0 ? void 0 : _inputProps_onBlur.call(inputProps, evt);
    };
    var handleWheel = function handleWheel(evt) {
        var _inputProps_onWheel;
        (_inputProps_onWheel = inputProps.onWheel) === null || _inputProps_onWheel === void 0 ? void 0 : _inputProps_onWheel.call(inputProps, evt);
        if (evt.deltaY === 0 || evt.defaultPrevented) return;
        scrollValue(evt.deltaY > 0);
    };
    var handleKeyDown = function handleKeyDown(evt) {
        var _inputProps_onKeyDown;
        (_inputProps_onKeyDown = inputProps.onKeyDown) === null || _inputProps_onKeyDown === void 0 ? void 0 : _inputProps_onKeyDown.call(inputProps, evt);
        if (evt.defaultPrevented) return;
        if (evt.key === "ArrowDown") scrollValue(true);
        else if (evt.key === "ArrowUp") scrollValue(false);
        else return;
        evt.preventDefault();
    };
    var value = _param.value, _param_min = _param.min, min = _param_min === void 0 ? -Infinity : _param_min, _param_max = _param.max, max = _param_max === void 0 ? Infinity : _param_max, _param_step = _param.step, step = _param_step === void 0 ? 1 : _param_step, _param_noDecimals = _param.noDecimals, noDecimals = _param_noDecimals === void 0 ? false : _param_noDecimals, _param_clearable = _param.clearable, clearable = _param_clearable === void 0 ? false : _param_clearable, onCleared = _param.onCleared, onChange = _param.onChange, inputProps = _object_without_properties(_param, [
        "value",
        "min",
        "max",
        "step",
        "noDecimals",
        "clearable",
        "onCleared",
        "onChange"
    ]);
    var selectTarget = useRef5(null);
    var _useState5 = _sliced_to_array(useState5(value + ""), 2), inputValue = _useState5[0], setInputValue = _useState5[1];
    var _useState51 = _sliced_to_array(useState5(false), 2), doSelect = _useState51[0], setDoSelect = _useState51[1];
    var validateNumber = function(value2) {
        return !isNaN(Number(value2));
    };
    function handleChange(val, evt) {
        if (noDecimals) val = val.replace(".", "");
        if (val === "") {
            var newVal = min === -Infinity ? 0 : min;
            onChange(newVal, evt);
            if (clearable) {
                onCleared === null || onCleared === void 0 ? void 0 : onCleared();
                setInputValue("");
                return;
            }
            var _evt_target;
            selectTarget.current = (_evt_target = evt === null || evt === void 0 ? void 0 : evt.target) !== null && _evt_target !== void 0 ? _evt_target : null;
            setDoSelect(true);
            setInputValue(newVal + "");
            return;
        }
        if (val === "-" || val === "-0") {
            if (min >= 0) return handleChange("", evt);
            setInputValue(val);
            onChange(0, evt);
            return;
        }
        if (!validateNumber(val)) return;
        setInputValue(val);
        var number = Number(val);
        onChange(number, evt);
    }
    useEffect5(function() {
        if (clearable && !inputValue) return;
        if (inputValue === "-" || /\.0*$/.test(inputValue) || /\.\d+0+$/.test(inputValue)) return;
        if (value + "" !== inputValue) setInputValue(value + "");
    }, [
        value,
        inputValue,
        clearable
    ]);
    useLayoutEffect2(function() {
        if (doSelect && !!selectTarget.current) {
            selectTarget.current.select();
            setDoSelect(false);
            selectTarget.current = null;
        }
    }, [
        value,
        doSelect
    ]);
    return /* @__PURE__ */ jsx16(Input2, _object_spread_props(_object_spread({
        ref: ref,
        value: inputValue,
        onChange: handleChange
    }, inputProps), {
        onBlur: handleBlur,
        onWheel: handleWheel,
        onKeyDown: handleKeyDown
    }));
});
// src/util/dates.ts
import format from "date-fns/format";
import * as locale from "date-fns/locale";
function localeFormat(date, formatString, localeCode) {
    var weekStartsOn = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    return format(date, formatString, {
        locale: locale[localeCode],
        weekStartsOn: weekStartsOn
    });
}
// src/util/helpers.ts
function ifKeyDown(keys, callback) {
    if (typeof keys === "string") keys = [
        keys
    ];
    return function(evt) {
        if (keys.includes(evt.key)) callback(evt);
    };
}
function isBetween(num, min, max) {
    if (min > num || max < num) return false;
    return true;
}
// src/DatePicker/components.tsx
import { isSameDay as isSameDay2 } from "date-fns";
import { motion as motion2 } from "framer-motion";
import React13, { useMemo as useMemo5 } from "react";
import styled17, { css as css6 } from "styled-components";
// src/DatePicker/util.ts
import { addDays, addMonths, addWeeks, getWeek, isSameDay, isSameMonth, isSameWeek, setDay, startOfMonth, startOfWeek, startOfYear } from "date-fns";
import getDaysInMonth from "date-fns/getDaysInMonth";
import isValid from "date-fns/isValid";
import range from "lodash/range";
var CURTAIN_VARIANTS = {
    visible: {
        opacity: 1,
        scaleY: 1,
        translateY: 0
    },
    hidden: function hidden(keepOpen) {
        return {
            opacity: keepOpen ? 1 : 0,
            scaleY: keepOpen ? 1 : 0.8,
            translateY: keepOpen ? 0 : -25
        };
    }
};
var numbersOnly = function(s) {
    return /^[0-9]+$/.test(s);
};
function dateFromYMD(year, month, day) {
    if (!isBetween(month, 0, 11)) return /* @__PURE__ */ new Date("");
    var date = new Date(year, month);
    var dim = getDaysInMonth(date);
    if (!isBetween(day, 1, dim)) return /* @__PURE__ */ new Date("");
    return new Date(year, month, day);
}
function validateDate(date) {
    return isValid(date) ? date : null;
}
function tryParseDate(input, fallback) {
    var parse = function() {
        var now = /* @__PURE__ */ new Date();
        if (numbersOnly(input)) {
            var parsed2 = parseInt(input, 10);
            if (input.length === 4) return [
                parsed2,
                0,
                1
            ];
            if (input.length === 2) {
                if (parsed2 <= parseInt(("" + now.getFullYear()).slice(-2), 10)) return [
                    2e3 + parsed2,
                    0,
                    1
                ];
                else return [
                    1900 + parsed2,
                    0,
                    1
                ];
            }
            if (input.length === 6) {
                {
                    var day = parseInt(input.substring(0, 2), 10);
                    var month = parseInt(input.substring(2, 4), 10) - 1;
                    var year = parseInt(input.substring(4), 10) + 1900;
                    var validated2 = validateDate(dateFromYMD(year, month, day));
                    if (validated2 !== null) return validated2;
                }
                {
                    var year1 = parseInt(input.substring(0, 2), 10) + 1900;
                    var month1 = parseInt(input.substring(2, 4), 10) - 1;
                    var day1 = parseInt(input.substring(4), 10);
                    return [
                        year1,
                        month1,
                        day1
                    ];
                }
            }
            if (input.length === 8) {
                {
                    var day2 = parseInt(input.substring(0, 2), 10);
                    var month2 = parseInt(input.substring(2, 4), 10) - 1;
                    var year2 = parseInt(input.substring(4), 10);
                    var validated21 = validateDate(dateFromYMD(year2, month2, day2));
                    if (validated21 !== null) return validated21;
                }
                {
                    var year3 = parseInt(input.substring(0, 4), 10);
                    var month3 = parseInt(input.substring(4, 6), 10) - 1;
                    var day3 = parseInt(input.substring(6), 10);
                    return [
                        year3,
                        month3,
                        day3
                    ];
                }
            }
        }
        var re = /(-|\/|\.|\s)/;
        var separated = [];
        var split = input.split(re);
        if (split.length > 1) {
            separated = split.reduce(function(acc, cur) {
                return numbersOnly(cur) ? _to_consumable_array(acc).concat([
                    cur
                ]) : acc;
            }, []);
        }
        if (separated.length !== 3) return null;
        if (separated[0].length === 4) {
            var _separated_map = _sliced_to_array(separated.map(function(s) {
                return parseInt(s, 10);
            }), 3), year4 = _separated_map[0], month4 = _separated_map[1], day4 = _separated_map[2];
            if (!isBetween(month4, 1, 12)) return null;
            if (!isBetween(day4, 1, 31)) return null;
            return [
                year4,
                month4 - 1,
                day4
            ];
        } else if (separated[2].length === 4) {
            var _separated_map1 = _sliced_to_array(separated.map(function(s) {
                return parseInt(s, 10);
            }), 3), day5 = _separated_map1[0], month5 = _separated_map1[1], year5 = _separated_map1[2];
            if (!isBetween(month5, 1, 12)) return null;
            if (!isBetween(day5, 1, 31)) return null;
            return [
                year5,
                month5 - 1,
                day5
            ];
        }
        return null;
    };
    var parsed = parse();
    var validated = null;
    if (parsed !== null) {
        if (_instanceof(parsed, Date)) validated = validateDate(parsed);
        else validated = validateDate(dateFromYMD.apply(void 0, _to_consumable_array(parsed)));
    }
    return [
        validated !== null && validated !== void 0 ? validated : fallback,
        validated !== null
    ];
}
function resolveWeek(date, formatter, weekStartsOn) {
    var now = /* @__PURE__ */ new Date();
    var firstDateInWeek = startOfWeek(date, {
        weekStartsOn: weekStartsOn
    });
    var returnData = {
        num: getWeek(firstDateInWeek),
        isThisWeek: isSameWeek(firstDateInWeek, now),
        days: range(7).map(function(i) {
            var day = addDays(firstDateInWeek, i);
            return {
                num: day.getDate(),
                initial: formatter(day, "ccccc" /* Initial */ ),
                veryShortName: formatter(day, "cccccc" /* VeryShort */ ),
                shortName: formatter(day, "ccc" /* Short */ ),
                longName: formatter(day, "cccc" /* Long */ ),
                isToday: isSameDay(day, now),
                date: day
            };
        })
    };
    return returnData;
}
function resolveMonth(date, formatter, weekStartsOn) {
    var now = /* @__PURE__ */ new Date();
    var firstDateInMonth = startOfMonth(date);
    var currentDate = setDay(firstDateInMonth, weekStartsOn, {
        weekStartsOn: weekStartsOn
    });
    var returnData = {
        num: firstDateInMonth.getMonth(),
        year: firstDateInMonth.getFullYear(),
        initial: formatter(firstDateInMonth, "LLLLL" /* Initial */ ),
        shortName: formatter(firstDateInMonth, "LLL" /* Short */ ),
        longName: formatter(firstDateInMonth, "LLLL" /* Long */ ),
        isThisMonth: isSameMonth(now, firstDateInMonth),
        weeks: []
    };
    do {
        returnData.weeks.push(resolveWeek(currentDate, formatter, weekStartsOn));
        currentDate = addWeeks(currentDate, 1);
    }while (currentDate.getMonth() === date.getMonth());
    return returnData;
}
function getDayNames(format2, formatter, weekStartsOn) {
    var firstDayOfWeek = startOfWeek(/* @__PURE__ */ new Date(), {
        weekStartsOn: weekStartsOn
    });
    return range(7).map(function(i) {
        return formatter(addDays(firstDayOfWeek, i), format2);
    });
}
function getMonthNames(format2, formatter) {
    var firstDayOfYear = startOfYear(/* @__PURE__ */ new Date());
    return range(12).map(function(i) {
        return formatter(addMonths(firstDayOfYear, i), format2);
    });
}
// src/DatePicker/components.tsx
import { jsx as jsx17, jsxs as jsxs10 } from "react/jsx-runtime";
var Wrapper8 = styled17.div(_templateObject50(), function(props) {
    return props.$width;
});
var Display = styled17.div(_templateObject52(), function(props) {
    return props.$keepOpen && css6(_templateObject51());
});
var RangeDisplay = styled17(Display)(_templateObject53(), function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return overloadColor(props.$separatorColor);
}, function(props) {
    return overloadColor(props.$focusBorderColor);
});
var CurtainShadow = styled17.div(_templateObject54());
var Curtain = styled17(motion2.div)(_templateObject57(), function(props) {
    return !props.$keepOpen && css6(_templateObject55());
}, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.$keepOpen && css6(_templateObject56(), function(props2) {
        return props2.theme.sizes.defaultBorderRadius;
    }, function(props2) {
        return props2.theme.sizes.defaultBorderRadius;
    });
});
var RangeCurtain = styled17(motion2.div)(_templateObject60(), function(props) {
    return !props.$keepOpen && css6(_templateObject58());
}, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.$keepOpen && css6(_templateObject59(), function(props2) {
        return props2.theme.sizes.defaultBorderRadius;
    }, function(props2) {
        return props2.theme.sizes.defaultBorderRadius;
    });
});
var MonthInfo = styled17.div(_templateObject61(), function(props) {
    return props.theme.colors.primary;
});
var MonthGrid = styled17.div(_templateObject62(), function(props) {
    return props.$noWeekNums ? "7" : "8";
});
var DateBox = styled17.div(_templateObject63(), function(props) {
    return props.$bold && "font-weight: bold;";
});
var DayBox = styled17(DateBox)(_templateObject68(), function(props) {
    return props.$isSameMonth ? "1" : "0.5";
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    if (!props.$highlight) return css6(_templateObject64(), function(props2) {
        return props2.theme.colors.lightBlue;
    });
    var bg = overloadColor(props.$highlight);
    return css6(_templateObject65(), bg, contrastColor(bg));
}, function(props) {
    if (props.$disableSelected) return null;
    var selColor = overloadColor(props.$selectedBackground);
    return props.$isSelected && css6(_templateObject66(), selColor, contrastColor(selColor), selColor);
}, function(props) {
    return props.$isToday && css6(_templateObject67(), props.theme.colors.blueGray);
});
var WeekBox = styled17(DateBox)(_templateObject69());
var Year = styled17.div(_templateObject70());
var MonthBox = styled17.div(_templateObject71(), function(props) {
    return props.$isCurrent ? props.theme.colors.primary : props.theme.colors.gray8;
});
var Duodecade = styled17(Year)(_templateObject72());
var YearBox = styled17(MonthBox)(_templateObject73());
var RangeMonthWrapper = styled17.div(_templateObject74());
var RangeMonthInfo = styled17.div(_templateObject75());
var NavArrowWrapper = styled17.div(_templateObject77(), function(props) {
    return props.$hide && css6(_templateObject76());
});
var NavArrow = function(param) {
    var dir = param.dir, hide = param.hide, onClick = param.onClick;
    return /* @__PURE__ */ jsx17(NavArrowWrapper, {
        $hide: hide,
        children: /* @__PURE__ */ jsx17(Icon, {
            icon: dir === "prev" ? "chevron-left" : "chevron-right",
            cursor: "pointer",
            size: "0.8rem",
            hoverColor: "primary",
            onClick: function() {
                return onClick(dir);
            }
        })
    });
};
var Month = function(param) {
    var value = param.value, secondValue = param.secondValue, month = param.month, weekStartsOn = param.weekStartsOn, noWeekNums = param.noWeekNums, highlight = param.highlight, selectedBackground = param.selectedBackground, disableSelected = param.disableSelected, dateFormatter = param.dateFormatter, onChange = param.onChange;
    var getBorderRadius = function getBorderRadius(date) {
        if (!secondValue) return;
        var side = isSameDay2(value, secondValue) && isSameDay2(value, date) ? "both" : isSameDay2(date, value) ? "left" : isSameDay2(date, secondValue) ? "right" : null;
        return side === "both" ? "4px" : side === "left" ? "4px 0 0 4px" : side === "right" ? "0 4px 4px 0" : "0";
    };
    var allDays = useMemo5(function() {
        return getDayNames("cccccc" /* VeryShort */ , dateFormatter, weekStartsOn);
    }, [
        dateFormatter,
        weekStartsOn
    ]);
    var currentMonth = useMemo5(function() {
        return resolveMonth(month !== null && month !== void 0 ? month : value, dateFormatter, weekStartsOn);
    }, [
        value,
        month,
        dateFormatter,
        weekStartsOn
    ]);
    return /* @__PURE__ */ jsxs10(MonthGrid, {
        $noWeekNums: noWeekNums,
        children: [
            !noWeekNums && /* @__PURE__ */ jsx17(DateBox, {}),
            allDays.map(function(dayName) {
                return /* @__PURE__ */ jsx17(DateBox, {
                    $bold: true,
                    children: dayName
                }, dayName);
            }),
            currentMonth.weeks.map(function(week) {
                return /* @__PURE__ */ jsxs10(React13.Fragment, {
                    children: [
                        !noWeekNums && /* @__PURE__ */ jsx17(WeekBox, {
                            children: week.num
                        }),
                        week.days.map(function(day) {
                            var _highlight;
                            var hlColor = (_highlight = highlight === null || highlight === void 0 ? void 0 : highlight(day)) !== null && _highlight !== void 0 ? _highlight : null;
                            var _getBorderRadius;
                            var borderRadius = (_getBorderRadius = getBorderRadius(day.date)) !== null && _getBorderRadius !== void 0 ? _getBorderRadius : null;
                            return /* @__PURE__ */ jsx17(DayBox, {
                                $isToday: day.isToday,
                                $isSelected: isSameDay2(day.date, value),
                                $isSameMonth: day.date.getMonth() === currentMonth.num,
                                $highlight: hlColor,
                                $borderRadius: borderRadius,
                                $selectedBackground: selectedBackground !== null && selectedBackground !== void 0 ? selectedBackground : "primary",
                                $disableSelected: !!disableSelected,
                                onClick: function() {
                                    return onChange(day.date);
                                },
                                children: day.num
                            }, day.date.getTime());
                        })
                    ]
                }, week.num);
            })
        ]
    });
};
// src/DatePicker/DatePicker.tsx
import { Fragment as Fragment3, jsx as jsx18, jsxs as jsxs11 } from "react/jsx-runtime";
var DatePicker = React14.forwardRef(function(param, ref) {
    var className = param.className, id = param.id, value = param.value, tmp = param.locale, locale2 = tmp === void 0 ? "enUS" : tmp, _param_weekStartsOn = param.weekStartsOn, weekStartsOn = _param_weekStartsOn === void 0 ? 1 : _param_weekStartsOn, _param_displayDateFormat = param.displayDateFormat, displayDateFormat = _param_displayDateFormat === void 0 ? "dd/MM/yyyy" : _param_displayDateFormat, _param_dateErrorText = param.dateErrorText, dateErrorText = _param_dateErrorText === void 0 ? "Invalid date" : _param_dateErrorText, _param_dateErrorTimeout = param.dateErrorTimeout, dateErrorTimeout = _param_dateErrorTimeout === void 0 ? 3e3 : _param_dateErrorTimeout, _param_noWeekNums = param.noWeekNums, noWeekNums = _param_noWeekNums === void 0 ? false : _param_noWeekNums, _param_keepOpen = param.keepOpen, keepOpen = _param_keepOpen === void 0 ? false : _param_keepOpen, _param_closeOnDateChange = param.closeOnDateChange, closeOnDateChange = _param_closeOnDateChange === void 0 ? false : _param_closeOnDateChange, _param_noAnimation = param.noAnimation, noAnimation = _param_noAnimation === void 0 ? false : _param_noAnimation, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, placeholder = param.placeholder, _param_clearable = param.clearable, clearable = _param_clearable === void 0 ? false : _param_clearable, _param_initCleared = param.initCleared, initCleared = _param_initCleared === void 0 ? false : _param_initCleared, _param_width = param.width, width = _param_width === void 0 ? "252px" : _param_width, height = param.height, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background, _param_selectedBackground = param.selectedBackground, selectedBackground = _param_selectedBackground === void 0 ? "primary" : _param_selectedBackground, border = param.$border, borderWidth = param.$borderWidth, borderStyle2 = param.$borderStyle, tmp1 = param.$borderColor, borderColor = tmp1 === void 0 ? "border.default" : tmp1, _param_borderRadius = param.borderRadius, borderRadius = _param_borderRadius === void 0 ? "4px" : _param_borderRadius, _param_focusBorderColor = param.focusBorderColor, focusBorderColor = _param_focusBorderColor === void 0 ? "primary" : _param_focusBorderColor, onChange = param.onChange, onCleared = param.onCleared;
    var wrapperRef = useRef6(null);
    var theme2 = useTheme5();
    var formatDate = useCallback8(function(date, format2) {
        return localeFormat(date, format2 !== null && format2 !== void 0 ? format2 : displayDateFormat, locale2, weekStartsOn);
    }, [
        displayDateFormat,
        locale2,
        weekStartsOn
    ]);
    var _useState6 = _sliced_to_array(useState6(function() {
        return formatDate(value);
    }), 2), dateInput = _useState6[0], setDateInput = _useState6[1];
    var _useState61 = _sliced_to_array(useState6(null), 2), dateError = _useState61[0], setDateError = _useState61[1];
    var _useState62 = _sliced_to_array(useState6(keepOpen || false), 2), open = _useState62[0], setOpen = _useState62[1];
    var _useState63 = _sliced_to_array(useState6("month"), 2), mode = _useState63[0], setMode = _useState63[1];
    var _useState64 = _sliced_to_array(useState6(clearable && initCleared), 2), cleared = _useState64[0], setCleared = _useState64[1];
    useImperativeHandle(ref, function() {
        return {
            clear: function() {
                var cleared2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                setCleared(cleared2);
                if (cleared2) {
                    setDateInput("");
                    onCleared === null || onCleared === void 0 ? void 0 : onCleared(cleared2);
                }
            }
        };
    });
    var toggleCurtain = useCallback8(function(doOpen) {
        var willOpen = keepOpen || (doOpen !== null && doOpen !== void 0 ? doOpen : !open);
        setOpen(willOpen);
    }, [
        open,
        keepOpen
    ]);
    useClickOutside(wrapperRef, function() {
        return toggleCurtain(false);
    });
    useEffect6(function() {
        setDateInput(formatDate(value));
    }, [
        value,
        formatDate
    ]);
    var emitChange = useCallback8(function(date) {
        var cleared2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        onChange(date, cleared2);
        if (cleared2) onCleared === null || onCleared === void 0 ? void 0 : onCleared(cleared2);
        if (closeOnDateChange && open && !keepOpen) setOpen(false);
    }, [
        onChange,
        onCleared,
        closeOnDateChange,
        open,
        keepOpen
    ]);
    var acceptInput = useCallback8(function() {
        if (dateInput === "" && clearable) {
            setCleared(true);
            emitChange(value, true);
            onCleared === null || onCleared === void 0 ? void 0 : onCleared(true);
            return;
        }
        var _tryParseDate = _sliced_to_array(tryParseDate(dateInput, value), 2), parsedDate = _tryParseDate[0], success = _tryParseDate[1];
        if (!success) {
            setDateInput(formatDate(value));
            setDateError(dateErrorText);
            return;
        }
        emitChange(parsedDate);
    }, [
        dateInput,
        clearable,
        value,
        emitChange,
        onCleared,
        formatDate,
        dateErrorText
    ]);
    var handleDateInput = useCallback8(function(value2) {
        setDateInput(value2);
        if (cleared && value2 !== "") setCleared(false);
    }, [
        cleared
    ]);
    var parsedBorder = useMemo6(function() {
        return border !== null && border !== void 0 ? border : theme2.layout.defaultBorder;
    }, [
        border,
        theme2.layout.defaultBorder
    ]);
    var allMonths = useMemo6(function() {
        return getMonthNames("LLLL" /* Long */ , formatDate);
    }, [
        formatDate
    ]);
    var allYears = useMemo6(function() {
        return range2(12).map(function(i) {
            return value.getFullYear() - 6 + i;
        });
    }, [
        value
    ]);
    var currentMonth = useMemo6(function() {
        return resolveMonth(value, formatDate, weekStartsOn);
    }, [
        value,
        formatDate,
        weekStartsOn
    ]);
    return /* @__PURE__ */ jsxs11(Wrapper8, {
        ref: wrapperRef,
        className: className,
        id: id,
        $width: fullWidth ? "100%" : width,
        children: [
            /* @__PURE__ */ jsx18(Display, {
                className: "--date-picker-display",
                $keepOpen: keepOpen,
                $focusBorderColor: focusBorderColor,
                children: /* @__PURE__ */ jsx18(Input, {
                    value: !cleared ? dateInput : "",
                    error: dateError,
                    errorTimeout: dateErrorTimeout,
                    placeholder: placeholder,
                    disabled: disabled,
                    iconRightProps: keepOpen ? void 0 : {
                        icon: "calendar",
                        boxCursor: disabled ? "default" : "pointer",
                        boxHoverIconColor: disabled ? void 0 : "primary",
                        onClick: function() {
                            return disabled ? void 0 : toggleCurtain();
                        }
                    },
                    fullWidth: true,
                    height: height,
                    background: background,
                    $border: parsedBorder,
                    $borderWidth: borderWidth,
                    $borderStyle: borderStyle2,
                    $borderColor: borderColor,
                    borderRadius: borderRadius,
                    focusBorderColor: focusBorderColor,
                    onErrorTimeout: function() {
                        return setDateError(null);
                    },
                    onBlur: acceptInput,
                    onKeyDown: ifKeyDown("Enter", acceptInput),
                    onChange: handleDateInput
                })
            }),
            /* @__PURE__ */ jsx18(AnimatePresence2, {
                initial: false,
                custom: keepOpen,
                children: open && /* @__PURE__ */ jsxs11(Curtain, {
                    className: "--date-picker-curtain",
                    variants: CURTAIN_VARIANTS,
                    custom: keepOpen,
                    initial: keepOpen ? "visible" : "hidden",
                    animate: "visible",
                    exit: "hidden",
                    transition: noAnimation ? {
                        duration: 0
                    } : void 0,
                    $background: background,
                    $border: parsedBorder,
                    $borderWidth: borderWidth,
                    $borderStyle: borderStyle2,
                    $borderColor: borderColor,
                    $keepOpen: keepOpen,
                    children: [
                        mode === "month" && /* @__PURE__ */ jsxs11(Fragment3, {
                            children: [
                                /* @__PURE__ */ jsxs11(MonthInfo, {
                                    className: "--date-picker-curtain-month-info",
                                    children: [
                                        /* @__PURE__ */ jsx18("span", {
                                            className: "--date-picker-curtain-month-info-month",
                                            onClick: function() {
                                                return setMode("year");
                                            },
                                            children: currentMonth.longName
                                        }),
                                        /* @__PURE__ */ jsx18("span", {
                                            className: "--date-picker-curtain-month-info-year",
                                            onClick: function() {
                                                return setMode("duodecade");
                                            },
                                            children: currentMonth.year
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ jsx18(Month, {
                                    value: value,
                                    weekStartsOn: weekStartsOn,
                                    noWeekNums: noWeekNums,
                                    selectedBackground: selectedBackground,
                                    dateFormatter: formatDate,
                                    onChange: emitChange
                                })
                            ]
                        }),
                        mode === "year" && /* @__PURE__ */ jsx18(Year, {
                            children: allMonths.map(function(monthName, idx) {
                                return /* @__PURE__ */ jsx18(MonthBox, {
                                    $isCurrent: value.getMonth() === idx,
                                    onClick: function() {
                                        emitChange(setMonth(value, idx));
                                        setMode("month");
                                    },
                                    children: monthName
                                }, monthName);
                            })
                        }),
                        mode === "duodecade" && /* @__PURE__ */ jsx18(Duodecade, {
                            children: allYears.map(function(yearName) {
                                return /* @__PURE__ */ jsx18(YearBox, {
                                    $isCurrent: value.getFullYear() === yearName,
                                    onClick: function() {
                                        emitChange(setYear(value, yearName));
                                        setMode("month");
                                    },
                                    children: yearName
                                }, yearName);
                            })
                        }),
                        !keepOpen && /* @__PURE__ */ jsx18(CurtainShadow, {})
                    ]
                })
            })
        ]
    });
});
// src/DatePicker/DateRangePicker.tsx
import { addMonths as addMonths2, isAfter, isBefore, isSameDay as isSameDay3, isSameMonth as isSameMonth2, isWithinInterval, startOfMonth as startOfMonth2 } from "date-fns";
import { AnimatePresence as AnimatePresence3 } from "framer-motion";
import { useCallback as useCallback9, useMemo as useMemo7, useRef as useRef7, useState as useState7 } from "react";
import { useTheme as useTheme6 } from "styled-components";
import { jsx as jsx19, jsxs as jsxs12 } from "react/jsx-runtime";
var DateRangePicker = function(param) {
    var className = param.className, id = param.id, value = param.value, tmp = param.locale, locale2 = tmp === void 0 ? "enUS" : tmp, _param_weekStartsOn = param.weekStartsOn, weekStartsOn = _param_weekStartsOn === void 0 ? 1 : _param_weekStartsOn, _param_displayDateFormat = param.displayDateFormat, displayDateFormat = _param_displayDateFormat === void 0 ? "dd/MM/yyyy" : _param_displayDateFormat, _param_dateErrorText = param.dateErrorText, dateErrorText = _param_dateErrorText === void 0 ? "Invalid date" : _param_dateErrorText, _param_dateErrorTimeout = param.dateErrorTimeout, dateErrorTimeout = _param_dateErrorTimeout === void 0 ? 3e3 : _param_dateErrorTimeout, _param_noWeekNums = param.noWeekNums, noWeekNums = _param_noWeekNums === void 0 ? false : _param_noWeekNums, _param_keepOpen = param.keepOpen, keepOpen = _param_keepOpen === void 0 ? false : _param_keepOpen, _param_noAnimation = param.noAnimation, noAnimation = _param_noAnimation === void 0 ? false : _param_noAnimation, _param_width = param.width, width = _param_width === void 0 ? "452px" : _param_width, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, height = param.height, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background, _param_selectedBackground = param.selectedBackground, selectedBackground = _param_selectedBackground === void 0 ? "primary" : _param_selectedBackground, _param_highlightBackground = param.highlightBackground, highlightBackground = _param_highlightBackground === void 0 ? "#dfe8f7" : _param_highlightBackground, border = param.$border, borderWidth = param.$borderWidth, borderStyle2 = param.$borderStyle, tmp1 = param.$borderColor, borderColor = tmp1 === void 0 ? "border.default" : tmp1, _param_borderRadius = param.borderRadius, borderRadius = _param_borderRadius === void 0 ? "4px" : _param_borderRadius, _param_focusBorderColor = param.focusBorderColor, focusBorderColor = _param_focusBorderColor === void 0 ? "primary" : _param_focusBorderColor, onChange = param.onChange;
    var handleMonthChange = function handleMonthChange(kind) {
        return function(dir) {
            var curtainValue = kind === "from" ? curtainFrom : curtainTo;
            var setCurtainValue = kind === "from" ? setCurtainFrom : setCurtainTo;
            var amount = dir === "prev" ? -1 : 1;
            setCurtainValue(addMonths2(curtainValue, amount));
        };
    };
    var checkHighlight = function checkHighlight(day) {
        try {
            if (temporaryValue !== null && typeof temporaryValue.from !== "undefined") return isSameDay3(day.date, temporaryValue.from) ? selectedBackground : null;
            if (isSameDay3(day.date, value.from) || isSameDay3(day.date, value.to)) return selectedBackground;
            return isWithinInterval(day.date, {
                start: value.from,
                end: value.to
            }) ? highlightBackground : null;
        } catch (e) {
            return null;
        }
    };
    var wrapperRef = useRef7(null);
    var theme2 = useTheme6();
    var formatDate = useCallback9(function(date, format2) {
        return localeFormat(date, format2 !== null && format2 !== void 0 ? format2 : displayDateFormat, locale2, weekStartsOn);
    }, [
        displayDateFormat,
        locale2,
        weekStartsOn
    ]);
    var _useState7 = _sliced_to_array(useState7(function() {
        return formatDate(value.from);
    }), 2), fromDateInput = _useState7[0], setFromDateInput = _useState7[1];
    var _useState71 = _sliced_to_array(useState7(function() {
        return formatDate(value.to);
    }), 2), toDateInput = _useState71[0], setToDateInput = _useState71[1];
    var _useState72 = _sliced_to_array(useState7(null), 2), dateError = _useState72[0], setDateError = _useState72[1];
    var _useState73 = _sliced_to_array(useState7(keepOpen || false), 2), open = _useState73[0], setOpen = _useState73[1];
    var _useState74 = _sliced_to_array(useState7(startOfMonth2(value.from)), 2), curtainFrom = _useState74[0], setCurtainFrom = _useState74[1];
    var _useState75 = _sliced_to_array(useState7(addMonths2(startOfMonth2(value.to), 1)), 2), curtainTo = _useState75[0], setCurtainTo = _useState75[1];
    var _useState76 = _sliced_to_array(useState7(null), 2), temporaryValue = _useState76[0], setTemporaryValue = _useState76[1];
    var toggleCurtain = useCallback9(function(doOpen) {
        var willOpen = keepOpen || (doOpen !== null && doOpen !== void 0 ? doOpen : !open);
        setOpen(willOpen);
    }, [
        open,
        keepOpen
    ]);
    useClickOutside(wrapperRef, function() {
        return toggleCurtain(false);
    });
    var emitChange = useCallback9(function(range3) {
        onChange(range3);
        setFromDateInput(formatDate(range3.from));
        setToDateInput(formatDate(range3.to));
    }, [
        onChange,
        formatDate
    ]);
    var handleDateClick = useCallback9(function(date) {
        if (temporaryValue === null) {
            setTemporaryValue({
                from: date,
                to: void 0
            });
            return true;
        }
        if (typeof temporaryValue.from !== "undefined" && typeof temporaryValue.to === "undefined") {
            if (isBefore(date, temporaryValue.from)) {
                setTemporaryValue({
                    from: date,
                    to: void 0
                });
                return true;
            }
            emitChange({
                from: temporaryValue.from,
                to: date
            });
            setTemporaryValue(null);
            return true;
        }
        return false;
    }, [
        emitChange,
        temporaryValue
    ]);
    var acceptInput = useCallback9(function(kind) {
        return function() {
            var dateInput = kind === "from" ? fromDateInput : toDateInput;
            var setDateInput = kind === "from" ? setFromDateInput : setToDateInput;
            var _tryParseDate = _sliced_to_array(tryParseDate(dateInput, value[kind]), 2), parsedDate = _tryParseDate[0], success = _tryParseDate[1];
            if (!success) {
                setDateInput(formatDate(value[kind]));
                setDateError(dateErrorText);
                return;
            }
            var newValue = _object_spread_props(_object_spread({}, value), _define_property({}, kind, parsedDate));
            if (!isSameDay3(newValue.from, newValue.to) && !isAfter(newValue.to, newValue.from)) {
                setDateInput(formatDate(value[kind]));
                setDateError(dateErrorText);
                return;
            }
            emitChange(newValue);
        };
    }, [
        fromDateInput,
        toDateInput,
        value,
        dateErrorText,
        formatDate,
        emitChange
    ]);
    var parsedBorder = useMemo7(function() {
        return border !== null && border !== void 0 ? border : theme2.layout.defaultBorder;
    }, [
        border,
        theme2.layout.defaultBorder
    ]);
    return /* @__PURE__ */ jsxs12(Wrapper8, {
        ref: wrapperRef,
        className: className,
        id: id,
        $width: fullWidth ? "100%" : width,
        children: [
            /* @__PURE__ */ jsxs12(RangeDisplay, {
                className: "--date-range-picker-display",
                $borderRadius: theme2.sizes.defaultBorderRadius,
                $focusBorderColor: focusBorderColor,
                $keepOpen: keepOpen,
                $separatorColor: borderColor,
                children: [
                    /* @__PURE__ */ jsx19(Input, {
                        value: fromDateInput,
                        fullWidth: true,
                        height: height,
                        background: background,
                        $border: parsedBorder,
                        $borderWidth: borderWidth,
                        $borderStyle: borderStyle2,
                        $borderColor: borderColor,
                        borderRadius: "".concat(borderRadius, " 0 0 ").concat(borderRadius),
                        focusBorderColor: focusBorderColor,
                        onErrorTimeout: function() {
                            return setDateError(null);
                        },
                        onBlur: acceptInput("from"),
                        onKeyDown: ifKeyDown("Enter", acceptInput("from")),
                        onChange: setFromDateInput
                    }),
                    /* @__PURE__ */ jsx19("div", {
                        className: "sep"
                    }),
                    /* @__PURE__ */ jsx19(Input, {
                        value: toDateInput,
                        error: dateError,
                        errorTimeout: dateErrorTimeout,
                        iconRightProps: keepOpen ? void 0 : {
                            icon: "calendar",
                            boxCursor: "pointer",
                            boxHoverIconColor: "primary",
                            onClick: function() {
                                return toggleCurtain();
                            }
                        },
                        fullWidth: true,
                        height: height,
                        background: background,
                        $border: parsedBorder,
                        $borderWidth: borderWidth,
                        $borderStyle: borderStyle2,
                        $borderColor: borderColor,
                        borderRadius: "0 ".concat(borderRadius, " ").concat(borderRadius, " 0"),
                        focusBorderColor: focusBorderColor,
                        onErrorTimeout: function() {
                            return setDateError(null);
                        },
                        onBlur: acceptInput("to"),
                        onKeyDown: ifKeyDown("Enter", acceptInput("to")),
                        onChange: setToDateInput
                    })
                ]
            }),
            /* @__PURE__ */ jsx19(AnimatePresence3, {
                initial: false,
                custom: keepOpen,
                children: open && /* @__PURE__ */ jsxs12(RangeCurtain, {
                    className: "--date-range-picker-curtain",
                    variants: CURTAIN_VARIANTS,
                    custom: keepOpen,
                    initial: keepOpen ? "visible" : "hidden",
                    animate: "visible",
                    exit: "hidden",
                    transition: noAnimation ? {
                        duration: 0
                    } : void 0,
                    $background: background,
                    $border: parsedBorder,
                    $borderWidth: borderWidth,
                    $borderStyle: borderStyle2,
                    $borderColor: borderColor,
                    $keepOpen: keepOpen,
                    children: [
                        /* @__PURE__ */ jsxs12(RangeMonthWrapper, {
                            children: [
                                /* @__PURE__ */ jsxs12(RangeMonthInfo, {
                                    children: [
                                        /* @__PURE__ */ jsx19(NavArrow, {
                                            dir: "prev",
                                            hide: false,
                                            onClick: handleMonthChange("from")
                                        }),
                                        /* @__PURE__ */ jsx19("div", {
                                            className: "--date-range-picker-curtain-month-name",
                                            children: formatDate(curtainFrom, "MMM yyyy")
                                        }),
                                        /* @__PURE__ */ jsx19(NavArrow, {
                                            dir: "next",
                                            hide: isSameMonth2(curtainTo, addMonths2(curtainFrom, 1)),
                                            onClick: handleMonthChange("from")
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ jsx19(Month, {
                                    value: value.from,
                                    secondValue: value.to,
                                    month: curtainFrom,
                                    weekStartsOn: weekStartsOn,
                                    noWeekNums: noWeekNums,
                                    disableSelected: true,
                                    highlight: checkHighlight,
                                    dateFormatter: formatDate,
                                    onChange: handleDateClick
                                })
                            ]
                        }),
                        /* @__PURE__ */ jsxs12(RangeMonthWrapper, {
                            children: [
                                /* @__PURE__ */ jsxs12(RangeMonthInfo, {
                                    children: [
                                        /* @__PURE__ */ jsx19(NavArrow, {
                                            dir: "prev",
                                            hide: isSameMonth2(curtainTo, addMonths2(curtainFrom, 1)),
                                            onClick: handleMonthChange("to")
                                        }),
                                        /* @__PURE__ */ jsx19("div", {
                                            className: "--date-range-picker-curtain-month-name",
                                            children: formatDate(curtainTo, "MMM yyyy")
                                        }),
                                        /* @__PURE__ */ jsx19(NavArrow, {
                                            dir: "next",
                                            hide: false,
                                            onClick: handleMonthChange("to")
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ jsx19(Month, {
                                    value: value.from,
                                    secondValue: value.to,
                                    month: curtainTo,
                                    weekStartsOn: weekStartsOn,
                                    noWeekNums: true,
                                    disableSelected: true,
                                    highlight: checkHighlight,
                                    dateFormatter: formatDate,
                                    onChange: handleDateClick
                                })
                            ]
                        }),
                        !keepOpen && /* @__PURE__ */ jsx19(CurtainShadow, {})
                    ]
                })
            })
        ]
    });
};
// src/DropdownMenu/DropdownMenu.tsx
import { useCallback as useCallback11, useRef as useRef8, useState as useState9 } from "react";
import { useNavigate as useNavigate3 } from "react-router";
// src/DropdownMenu/components.ts
import styled18, { css as css7 } from "styled-components";
var Wrapper9 = styled18.div(_templateObject78());
var Display2 = styled18.div(_templateObject79(), function(props) {
    return props.$justifyContent;
}, function(props) {
    return props.$alignItems;
}, function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
}, function(props) {
    return props.$padding;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return props.$textTransform;
}, function(props) {
    return props.$userSelect;
}, function(props) {
    return props.$cursor;
}, getBorderStyle, function(props) {
    return props.$borderRadius;
}, function(props) {
    return overloadColor(props.$hoverColor);
}, function(props) {
    return overloadColor(props.$hoverBackground);
});
var MenuItem = styled18.div(_templateObject80());
var CurtainSeparator = styled18.div(_templateObject81(), function(props) {
    return props.$height;
});
function getMenuPosition(props) {
    if (props.$isSubMenu) return css7(_templateObject82(), props.$side === "left" ? "left: 0" : "right: 0", props.$side === "left" ? "-100%" : "100%");
    switch(props.$side){
        case "top":
            return css7(_templateObject83(), props.$margin);
        case "bottom":
            return css7(_templateObject84(), props.$margin);
        case "left":
            return css7(_templateObject85(), props.$margin);
        case "right":
            return css7(_templateObject86(), props.$margin);
    }
}
var Curtain2 = styled18.div(_templateObject87(), function(props) {
    return 5e3 /* Dropdowns */  + props.$subMenuLevel;
}, function(props) {
    return props.$subMenuWidth;
}, function(props) {
    return props.$isSubMenu ? "0" : "100%";
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$shadow;
}, MenuItem, function(props) {
    return props.$items.$padding;
}, function(props) {
    return props.$items.$fontSize;
}, function(props) {
    return props.$items.$textTransform;
}, function(props) {
    return props.$items.$userSelect;
}, function(props) {
    return props.$items.$whiteSpace;
}, function(props) {
    return props.$items.$cursor;
}, function(props) {
    return overloadColor(props.$items.$hoverColor);
}, function(props) {
    return overloadColor(props.$items.$hoverBackground);
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return getMenuPosition(props);
});
// src/DropdownMenu/DropdownMenuCurtain.tsx
import uniqueId2 from "lodash/uniqueId";
import { useCallback as useCallback10, useMemo as useMemo8, useState as useState8 } from "react";
import { Fragment as Fragment4, jsx as jsx20, jsxs as jsxs13 } from "react/jsx-runtime";
var DropdownMenuCurtain = function(param) {
    var open = param.open, items = param.items, side = param.side, isSubMenu = param.isSubMenu, subMenuLevel = param.subMenuLevel, subMenuWidth = param.subMenuWidth, curtainStyle = param.curtainStyle, onItemClick = param.onItemClick;
    var _useState8 = _sliced_to_array(useState8(), 2), openSubMenu = _useState8[0], setOpenSubMenu = _useState8[1];
    var itemsWithIds = useMemo8(function() {
        return items.map(function(item) {
            var _item_id;
            return _object_spread({
                id: (_item_id = item.id) !== null && _item_id !== void 0 ? _item_id : uniqueId2("item")
            }, item);
        });
    }, [
        items
    ]);
    var toggleSubMenu = useCallback10(function(item) {
        var _item_subMenu_onOpen, _item_subMenu, _item_subMenu_onClose, _item_subMenu1;
        var willOpen = isUndefined(openSubMenu) ? true : false;
        var proceed = (willOpen ? (_item_subMenu = item.subMenu) === null || _item_subMenu === void 0 ? void 0 : (_item_subMenu_onOpen = _item_subMenu.onOpen) === null || _item_subMenu_onOpen === void 0 ? void 0 : _item_subMenu_onOpen.call(_item_subMenu) : (_item_subMenu1 = item.subMenu) === null || _item_subMenu1 === void 0 ? void 0 : (_item_subMenu_onClose = _item_subMenu1.onClose) === null || _item_subMenu_onClose === void 0 ? void 0 : _item_subMenu_onClose.call(_item_subMenu1)) !== false;
        if (!proceed) return;
        setOpenSubMenu(function(v) {
            return isUndefined(v) ? item.id : void 0;
        });
    }, [
        openSubMenu
    ]);
    var handleMenuItemMouseEnter = useCallback10(function(item) {
        if (isUndefined(item.subMenu) || item.subMenu.items.length === 0) return;
        if (item.subMenu.openOnHover !== false) toggleSubMenu(item);
    }, [
        toggleSubMenu
    ]);
    var handleMenuItemMouseLeave = useCallback10(function(item) {
        if (isUndefined(item.subMenu) || item.subMenu.items.length === 0) return;
        toggleSubMenu(item);
    }, [
        toggleSubMenu
    ]);
    var handleMenuItemClick = useCallback10(function(item, evt) {
        evt.stopPropagation();
        var id = item.id, rest = _object_without_properties(item, [
            "id"
        ]);
        onItemClick(rest, evt);
        setOpenSubMenu(function(id2) {
            return isUndefined(id2) ? item.id : void 0;
        });
    }, [
        onItemClick
    ]);
    return !open ? null : /* @__PURE__ */ jsxs13(Fragment4, {
        children: [
            !isSubMenu && /* This is here so that onMouseLeave won't fire when mouse is
     * between display and curtain.
     */ /* @__PURE__ */ jsx20(CurtainSeparator, {
                $height: curtainStyle.$margin
            }),
            /* @__PURE__ */ jsx20(Curtain2, _object_spread_props(_object_spread({}, curtainStyle), {
                $side: side !== null && side !== void 0 ? side : "right",
                $isSubMenu: isSubMenu,
                $subMenuLevel: subMenuLevel,
                $subMenuWidth: subMenuWidth,
                children: itemsWithIds.map(function(item) {
                    var _item_subMenu_width;
                    return /* @__PURE__ */ jsxs13(MenuItem, {
                        onMouseEnter: function() {
                            return handleMenuItemMouseEnter(item);
                        },
                        onMouseLeave: function() {
                            return handleMenuItemMouseLeave(item);
                        },
                        onClick: function(evt) {
                            return handleMenuItemClick(item, evt);
                        },
                        children: [
                            /* @__PURE__ */ jsx20("span", {
                                children: item.label
                            }),
                            item.subMenu && /* @__PURE__ */ jsx20(DropdownMenuCurtain, {
                                open: openSubMenu === item.id,
                                items: item.subMenu.items,
                                side: item.subMenu.side,
                                isSubMenu: true,
                                subMenuLevel: subMenuLevel + 1,
                                subMenuWidth: (_item_subMenu_width = item.subMenu.width) !== null && _item_subMenu_width !== void 0 ? _item_subMenu_width : "auto",
                                curtainStyle: curtainStyle,
                                onItemClick: handleMenuItemClick
                            })
                        ]
                    }, item.id);
                })
            }))
        ]
    });
};
var DropdownMenuCurtain_default = DropdownMenuCurtain;
// src/DropdownMenu/util.ts
function overloadDisplayStyle(partial) {
    return _object_spread({
        $width: "auto",
        $height: "auto",
        $justifyContent: "flex-start",
        $alignItems: "center",
        $padding: "6px",
        $color: "text.light",
        $background: "urBlue",
        $hoverColor: "text.light",
        $hoverBackground: "urBlue",
        $fontSize: "0.8em",
        $textTransform: "none",
        $userSelect: "none",
        $cursor: "pointer",
        $borderRadius: "0"
    }, partial);
}
function overloadCurtainStyle(partial) {
    return _object_spread({
        $margin: "0px",
        $color: "text.light",
        $background: "urBlue",
        $borderRadius: "0",
        $shadow: "0 4px 5px -3px rgba(0, 0, 0, 0.3)",
        $items: {
            $padding: "6px",
            $hoverColor: "text.light",
            $hoverBackground: "urShadow",
            $fontSize: "0.8rem",
            $textTransform: "none",
            $userSelect: "none",
            $whiteSpace: "nowrap",
            $cursor: "pointer"
        }
    }, partial);
}
// src/DropdownMenu/DropdownMenu.tsx
import { jsx as jsx21, jsxs as jsxs14 } from "react/jsx-runtime";
var DropdownMenu = function(param) {
    var displayText = param.displayText, items = param.items, _param_side = param.side, side = _param_side === void 0 ? "bottom" : _param_side, _param_openOnHover = param.openOnHover, openOnHover = _param_openOnHover === void 0 ? false : _param_openOnHover, _param_displayStyle = param.displayStyle, displayStyle = _param_displayStyle === void 0 ? {} : _param_displayStyle, _param_curtainStyle = param.curtainStyle, curtainStyle = _param_curtainStyle === void 0 ? {} : _param_curtainStyle, _param_onOpen = param.onOpen, onOpen = _param_onOpen === void 0 ? function() {
        return true;
    } : _param_onOpen, _param_onClose = param.onClose, onClose = _param_onClose === void 0 ? function() {
        return true;
    } : _param_onClose, _param_onMouseEnter = param.onMouseEnter, onMouseEnter = _param_onMouseEnter === void 0 ? function() {
        return void 0;
    } : _param_onMouseEnter, _param_onMouseLeave = param.onMouseLeave, onMouseLeave = _param_onMouseLeave === void 0 ? function() {
        return void 0;
    } : _param_onMouseLeave, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick;
    var overloadedDisplayStyle = overloadDisplayStyle(displayStyle);
    var overloadedCurtainStyle = overloadCurtainStyle(curtainStyle);
    var navigate = useNavigate3();
    var wrapperRef = useRef8(null);
    var _useState9 = _sliced_to_array(useState9(false), 2), open = _useState9[0], setOpen = _useState9[1];
    var toggle = useCallback11(function(doOpen) {
        var willOpen = doOpen !== null && doOpen !== void 0 ? doOpen : !open;
        var proceed = (willOpen ? onOpen() : onClose()) !== false;
        if (!proceed) return;
        setOpen(willOpen);
    }, [
        onClose,
        onOpen,
        open
    ]);
    var clickOutsideToggle = useCallback11(function() {
        if (open) toggle(false);
    }, [
        open,
        toggle
    ]);
    useClickOutside(wrapperRef, clickOutsideToggle);
    var handleDisplayClick = useCallback11(function() {
        toggle();
    }, [
        toggle
    ]);
    var handleMouseEnter = useCallback11(function(evt) {
        if (!openOnHover || open) return;
        onMouseEnter(evt);
        if (evt.defaultPrevented) return;
        toggle(true);
    }, [
        onMouseEnter,
        open,
        openOnHover,
        toggle
    ]);
    var handleMouseLeave = useCallback11(function(evt) {
        if (!openOnHover || !open) return;
        onMouseLeave(evt);
        if (evt.defaultPrevented) return;
        toggle(false);
    }, [
        onMouseLeave,
        open,
        openOnHover,
        toggle
    ]);
    var handleItemClick = useCallback11(function(item, evt) {
        var _item_onClick;
        (_item_onClick = item.onClick) === null || _item_onClick === void 0 ? void 0 : _item_onClick.call(item, evt);
        if (evt.defaultPrevented) return;
        if (!isUndefined(item.href)) {
            if (typeof item.href === "string") navigate(item.href);
            else navigate(item.href.path, {
                state: item.href.state
            });
        }
    }, [
        navigate
    ]);
    return /* @__PURE__ */ jsxs14(Wrapper9, {
        ref: wrapperRef,
        onMouseLeave: handleMouseLeave,
        onClick: onClick,
        children: [
            /* @__PURE__ */ jsx21(Display2, _object_spread_props(_object_spread({
                className: "--dropdown-menu-display"
            }, overloadedDisplayStyle), {
                onMouseEnter: handleMouseEnter,
                onClick: handleDisplayClick,
                children: displayText
            })),
            /* @__PURE__ */ jsx21(DropdownMenuCurtain_default, {
                open: open,
                items: items,
                side: side,
                isSubMenu: false,
                subMenuLevel: 0,
                subMenuWidth: "auto",
                curtainStyle: overloadedCurtainStyle,
                onItemClick: handleItemClick
            })
        ]
    });
};
// src/ImageViewer/ImageViewer.tsx
import { AnimatePresence as AnimatePresence4, motion as motion3 } from "framer-motion";
import isEqual from "lodash/isEqual";
import uniqueId3 from "lodash/uniqueId";
import React18, { useCallback as useCallback12, useEffect as useEffect7, useImperativeHandle as useImperativeHandle2, useMemo as useMemo9, useRef as useRef9, useState as useState10 } from "react";
// src/ImageViewer/components.ts
import styled19, { css as css8 } from "styled-components";
var Wrapper10 = styled19.div(_templateObject89(), function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
}, function(props) {
    return props.$zIndex;
}, function(props) {
    return props.$background && overloadColor(props.$background);
}, function(props) {
    return props.$popup && css8(_templateObject88(), props.$open ? "flex" : "none");
}, function(props) {
    return props.$imageSize;
}, function(props) {
    return overloadColor(props.$imageBackgroundColor);
});
var ImageDescription = styled19.div(_templateObject90(), function(props) {
    return props.$width;
}, function(props) {
    return props.$marginBottom;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$opacity;
});
var NavArrows = styled19.div(_templateObject91(), 4e3 /* Globals */ , function(props) {
    return !props.$leftVisible && "none";
}, function(props) {
    return !props.$rightVisible && "none";
});
var Counter = styled19.div(_templateObject92(), function(props) {
    return props.$opacity;
});
var DownloadButton = styled19.div.attrs({
    role: "button"
})(_templateObject93(), 4e3 /* Globals */  + 1);
var CloseButton = styled19.div(_templateObject94(), 4e3 /* Globals */  + 1);
// src/ImageViewer/util.ts
function wrap(min, max, v) {
    var rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
}
var SWIPE_CONFIDENCE_THRESHOLD = 1e4;
function swipePower(offset, velocity) {
    return Math.abs(offset) * velocity;
}
var VARIANTS = {
    enter: function enter(direction) {
        return {
            x: direction > 0 ? 1e3 : -1e3,
            opacity: 0
        };
    },
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    },
    exit: function exit(direction) {
        return {
            zIndex: 0,
            x: direction < 0 ? 1e3 : -1e3,
            opacity: 0
        };
    }
};
// src/ImageViewer/ImageViewer.tsx
import { jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var ImageViewer = React18.forwardRef(function(param, ref) {
    var className = param.className, id = param.id, images = param.images, _param_popup = param.popup, popup = _param_popup === void 0 ? false : _param_popup, open = param.open, _param_fadeInformation = param.fadeInformation, fadeInformation = _param_fadeInformation === void 0 ? false : _param_fadeInformation, _param_showArrows = param.showArrows, showArrows = _param_showArrows === void 0 ? false : _param_showArrows, _param_noArrowKeyNavigation = param.noArrowKeyNavigation, noArrowKeyNavigation = _param_noArrowKeyNavigation === void 0 ? false : _param_noArrowKeyNavigation, _param_showImageCounter = param.showImageCounter, showImageCounter = _param_showImageCounter === void 0 ? false : _param_showImageCounter, _param_fadeImageCounter = param.fadeImageCounter, fadeImageCounter = _param_fadeImageCounter === void 0 ? false : _param_fadeImageCounter, _param_showDownloadButton = param.showDownloadButton, showDownloadButton = _param_showDownloadButton === void 0 ? false : _param_showDownloadButton, _param_noCloseOnEscape = param.noCloseOnEscape, noCloseOnEscape = _param_noCloseOnEscape === void 0 ? false : _param_noCloseOnEscape, initialImage = param.initialImage, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, background = param.background, _param_imageSize = param.imageSize, imageSize = _param_imageSize === void 0 ? "cover" : _param_imageSize, _param_imageBackgroundColor = param.imageBackgroundColor, imageBackgroundColor = _param_imageBackgroundColor === void 0 ? "inherit" : _param_imageBackgroundColor, _param_width = param.width, width = _param_width === void 0 ? "800px" : _param_width, _param_height = param.height, height = _param_height === void 0 ? "600px" : _param_height, _param_zIndex = param.zIndex, zIndex = _param_zIndex === void 0 ? 1 : _param_zIndex, infoWidth = param.infoWidth, infoMarginBottom = param.infoMarginBottom, _param_infoColor = param.infoColor, infoColor = _param_infoColor === void 0 ? "white" : _param_infoColor, _param_infoBackground = param.infoBackground, infoBackground = _param_infoBackground === void 0 ? "rgba(0, 0, 0, 0.5)" : _param_infoBackground, onImageScroll = param.onImageScroll, onImageClick = param.onImageClick, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, /** Fired when closing of popup is requested */ onClose = param.onClose;
    if (popup) {
        if (typeof open === "undefined") throw new Error('ImageViewer: If prop "popup" is true, prop "open" must be defined.');
        width = "".concat(window.innerWidth, "px");
        height = "".concat(window.innerHeight, "px");
    }
    useImperativeHandle2(ref, function() {
        return {
            scrollViewer: scrollViewer
        };
    });
    var wrapperRef = useRef9(null);
    var prevLoadedImages = useRef9(null);
    var prevPage = useRef9(0);
    var _useState10 = _sliced_to_array(useState10([]), 2), loadedImages = _useState10[0], setLoadedImages = _useState10[1];
    var _useState101 = _sliced_to_array(useState10(false), 2), mouseIsOver = _useState101[0], setMouseIsOver = _useState101[1];
    var _useState102 = _sliced_to_array(useState10([
        0,
        0
    ]), 2), _useState10_ = _sliced_to_array(_useState102[0], 2), page = _useState10_[0], direction = _useState10_[1], setPage = _useState102[1];
    var imageIndex = useMemo9(function() {
        return wrap(0, loadedImages.length, page);
    }, [
        loadedImages.length,
        page
    ]);
    var image = useMemo9(function() {
        var _loadedImages_imageIndex;
        return (_loadedImages_imageIndex = loadedImages[imageIndex]) !== null && _loadedImages_imageIndex !== void 0 ? _loadedImages_imageIndex : null;
    }, [
        loadedImages,
        imageIndex
    ]);
    useEffect7(function() {
        var _loop = function(index) {
            var image2 = images[index];
            if (typeof image2.file === "string") {
                finishedImages.push(createImage(image2, image2.file, index));
            } else {
                fileReaderPromises.push(new Promise(function(resolve, reject) {
                    if (typeof image2.file === "string") {
                        reject();
                        return;
                    }
                    var fr = new FileReader();
                    fr.onload = function(e) {
                        var _e_target_result, _e_target;
                        var result = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_result = _e_target.result) === null || _e_target_result === void 0 ? void 0 : _e_target_result.toString();
                        if (!result) reject();
                        else resolve(createImage(image2, result, index));
                    };
                    fr.onerror = reject;
                    fr.readAsDataURL(image2.file);
                }));
            }
        };
        var fileReaderPromises = [];
        var finishedImages = [];
        var createImage = function(image2, url, index) {
            var _image2_id, _image2_imageSize, _image2_imageBackgroundColor;
            return {
                id: (_image2_id = image2.id) !== null && _image2_id !== void 0 ? _image2_id : uniqueId3("image"),
                url: url,
                name: image2.name,
                description: image2.description,
                imageSize: (_image2_imageSize = image2.imageSize) !== null && _image2_imageSize !== void 0 ? _image2_imageSize : imageSize,
                imageBackgroundColor: (_image2_imageBackgroundColor = image2.imageBackgroundColor) !== null && _image2_imageBackgroundColor !== void 0 ? _image2_imageBackgroundColor : imageBackgroundColor,
                index: index
            };
        };
        for(var index = 0; index < images.length; index++)_loop(index);
        Promise.all(fileReaderPromises).then(function(imgs) {
            var allImages = _to_consumable_array(finishedImages).concat(_to_consumable_array(imgs.filter(function(i) {
                return typeof i.url === "string";
            })));
            setLoadedImages(allImages.sort(function(a, b) {
                return a.index - b.index;
            }));
        });
    }, [
        imageBackgroundColor,
        imageSize,
        images
    ]);
    var scrollViewer = useCallback12(function(delta) {
        setPage(function(param) {
            var _param = _sliced_to_array(param, 1), page2 = _param[0];
            return [
                page2 + delta,
                delta < 0 ? -1 : 1
            ];
        });
    }, []);
    var handleMouseEnter = useCallback12(function(evt) {
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(evt);
        if (evt.defaultPrevented) return;
        setMouseIsOver(true);
    }, [
        onMouseEnter
    ]);
    var handleMouseLeave = useCallback12(function(evt) {
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(evt);
        if (evt.defaultPrevented) return;
        setMouseIsOver(false);
    }, [
        onMouseLeave
    ]);
    var handleDragEnd = useCallback12(function(offset, velocity) {
        var swipe = swipePower(offset.x, velocity.x);
        if (swipe < -SWIPE_CONFIDENCE_THRESHOLD) scrollViewer(1);
        else if (swipe > SWIPE_CONFIDENCE_THRESHOLD) scrollViewer(-1);
    }, [
        scrollViewer
    ]);
    var handleDownload = useCallback12(function() {
        return _async_to_generator(function() {
            var img, blob, url, a, _image_name;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!image) return [
                            2
                        ];
                        return [
                            4,
                            window.fetch(image.url)
                        ];
                    case 1:
                        img = _state.sent();
                        return [
                            4,
                            img.blob()
                        ];
                    case 2:
                        blob = _state.sent();
                        url = URL.createObjectURL(blob);
                        a = document.createElement("a");
                        a.href = url;
                        a.download = (_image_name = image.name) !== null && _image_name !== void 0 ? _image_name : "image";
                        a.click();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        image
    ]);
    useEffect7(function() {
        if (!image || page === prevPage.current) return;
        prevPage.current = page;
        onImageScroll === null || onImageScroll === void 0 ? void 0 : onImageScroll(image);
    }, [
        page,
        onImageScroll,
        image
    ]);
    useEffect7(function() {
        if (typeof initialImage === "undefined") return;
        if (popup && !open && prevLoadedImages.current !== null && isEqual(prevLoadedImages.current, loadedImages)) return;
        prevLoadedImages.current = loadedImages;
        var imageIdx = loadedImages.findIndex(function(img) {
            return img.id === initialImage;
        });
        if (imageIdx < 0) return;
        setPage([
            imageIdx,
            0
        ]);
    }, [
        initialImage,
        loadedImages,
        popup,
        open,
        scrollViewer
    ]);
    useEffect7(function() {
        var handler = function(param) {
            var key = param.key;
            switch(key){
                case "Escape":
                    if (!noCloseOnEscape && popup && open) onClose === null || onClose === void 0 ? void 0 : onClose();
                    break;
                case "ArrowLeft":
                    if (!noArrowKeyNavigation) scrollViewer(-1);
                    break;
                case "ArrowRight":
                    if (!noArrowKeyNavigation) scrollViewer(1);
                    break;
            }
        };
        document.addEventListener("keydown", handler);
        return function() {
            document.removeEventListener("keydown", handler);
        };
    }, [
        noCloseOnEscape,
        popup,
        open,
        noArrowKeyNavigation,
        onClose,
        scrollViewer
    ]);
    if (!image) return null;
    return /* @__PURE__ */ jsxs15(Wrapper10, {
        ref: wrapperRef,
        className: className,
        id: id,
        tabIndex: tabIndex,
        $popup: popup,
        $open: open,
        $width: width,
        $height: height,
        $background: background,
        $imageSize: image.imageSize,
        $imageBackgroundColor: image.imageBackgroundColor,
        $zIndex: zIndex,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            showArrows && /* @__PURE__ */ jsxs15(NavArrows, {
                className: "--image-viewer-nav-arrows",
                $leftVisible: mouseIsOver,
                $rightVisible: mouseIsOver,
                children: [
                    /* @__PURE__ */ jsx22("div", {
                        className: "--image-viewer-nav-arrows-left",
                        onClick: function() {
                            return scrollViewer(-1);
                        },
                        children: /* @__PURE__ */ jsx22(Icon, {
                            icon: "chevron-left"
                        })
                    }),
                    /* @__PURE__ */ jsx22("div", {
                        className: "--image-viewer-nav-arrows-right",
                        onClick: function() {
                            return scrollViewer(1);
                        },
                        children: /* @__PURE__ */ jsx22(Icon, {
                            icon: "chevron-right"
                        })
                    })
                ]
            }),
            /* @__PURE__ */ jsx22(AnimatePresence4, {
                initial: false,
                custom: direction,
                children: /* @__PURE__ */ jsx22(motion3.img, {
                    src: image.url,
                    custom: direction,
                    variants: VARIANTS,
                    initial: "enter",
                    animate: "center",
                    exit: "exit",
                    transition: {
                        x: {
                            type: "spring",
                            stiffness: 300,
                            damping: 30
                        },
                        opacity: {
                            duration: 0.2
                        }
                    },
                    drag: "x",
                    dragConstraints: {
                        left: 0,
                        right: 0
                    },
                    dragElastic: 1,
                    onDragEnd: function(_, param) {
                        var offset = param.offset, velocity = param.velocity;
                        return handleDragEnd(offset, velocity);
                    },
                    onClick: function() {
                        return onImageClick === null || onImageClick === void 0 ? void 0 : onImageClick(image);
                    }
                }, page)
            }),
            showImageCounter && /* @__PURE__ */ jsxs15(Counter, {
                className: "--image-viewer-counter",
                $opacity: !fadeImageCounter ? 1 : mouseIsOver ? 1 : 0,
                children: [
                    page % loadedImages.length + 1,
                    "\xA0",
                    /* @__PURE__ */ jsx22("span", {
                        children: "/"
                    }),
                    "\xA0",
                    loadedImages.length
                ]
            }),
            (image.name || image.description) && /* @__PURE__ */ jsxs15(ImageDescription, {
                className: "--image-viewer-description",
                $opacity: !fadeInformation ? 1 : mouseIsOver ? 1 : 0,
                $width: infoWidth,
                $marginBottom: infoMarginBottom,
                $color: infoColor,
                $background: infoBackground,
                children: [
                    /* @__PURE__ */ jsx22("span", {
                        className: "name",
                        children: image.name
                    }),
                    /* @__PURE__ */ jsx22("p", {
                        children: image.description
                    })
                ]
            }),
            showDownloadButton && /* @__PURE__ */ jsx22(DownloadButton, {
                className: "--image-viewer-download-button",
                children: /* @__PURE__ */ jsx22(Icon, {
                    icon: "download",
                    type: "solid",
                    size: "1.2rem",
                    color: "gray4",
                    hoverColor: "white",
                    cursor: "pointer",
                    onClick: handleDownload
                })
            }),
            popup && /* @__PURE__ */ jsx22(CloseButton, {
                className: "--image-viewer-close-button",
                onClick: function() {
                    return onClose === null || onClose === void 0 ? void 0 : onClose();
                },
                children: /* @__PURE__ */ jsx22(Icon, {
                    icon: "times",
                    type: "light",
                    color: "#dadada",
                    hoverColor: "white",
                    cursor: "pointer",
                    size: "32px"
                })
            })
        ]
    });
});
// src/Margin/Margin.tsx
import styled20 from "styled-components";
import { jsx as jsx23 } from "react/jsx-runtime";
var Wrapper11 = styled20.div(_templateObject95(), function(props) {
    var _props_$display;
    return (_props_$display = props.$display) !== null && _props_$display !== void 0 ? _props_$display : "block";
}, function(props) {
    return props.$all && "\n    margin-top: ".concat(props.$all, ";\n    margin-bottom: ").concat(props.$all, ";\n    margin-right: ").concat(props.$all, ";\n    margin-left: ").concat(props.$all, ";\n  ");
}, function(props) {
    return props.$vertical && "\n    margin-top: ".concat(props.$vertical, ";\n    margin-bottom: ").concat(props.$vertical, ";\n  ");
}, function(props) {
    return props.$horizontal && "\n    margin-right: ".concat(props.$horizontal, ";\n    margin-left: ").concat(props.$horizontal, ";\n  ");
}, function(props) {
    return props.$top && "margin-top: ".concat(props.$top, ";");
}, function(props) {
    return props.$right && "margin-right: ".concat(props.$right, ";");
}, function(props) {
    return props.$bottom && "margin-bottom: ".concat(props.$bottom, ";");
}, function(props) {
    return props.$left && "margin-left: ".concat(props.$left, ";");
});
var Margin = function(props) {
    return /* @__PURE__ */ jsx23(Wrapper11, _object_spread_props(_object_spread({}, props), {
        children: props.children
    }));
};
// src/Message/Message.tsx
import { AnimatePresence as AnimatePresence5, motion as motion4 } from "framer-motion";
import styled21 from "styled-components";
import { jsx as jsx24, jsxs as jsxs16 } from "react/jsx-runtime";
var Wrapper12 = styled21(motion4.div)(_templateObject96(), function(props) {
    return props.$width;
}, function(props) {
    return props.$maxWidth;
}, function(props) {
    return props.$padding;
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return props.$color;
}, function(props) {
    return props.$background;
}, getBorderStyle, function(props) {
    return props.$borderRadius;
});
var VARIANTS2 = {
    visible: {
        opacity: 1,
        y: 0
    },
    hidden: {
        opacity: 0,
        y: 20
    }
};
var Message = function(param) {
    var show = param.show, text = param.text, _param_iconProps = param.iconProps, iconProps = _param_iconProps === void 0 ? {} : _param_iconProps, _param_noAnimation = param.noAnimation, noAnimation = _param_noAnimation === void 0 ? false : _param_noAnimation, _param_noIcon = param.noIcon, noIcon = _param_noIcon === void 0 ? false : _param_noIcon, _param_width = param.width, width = _param_width === void 0 ? "auto" : _param_width, _param_maxWidth = param.maxWidth, maxWidth = _param_maxWidth === void 0 ? "none" : _param_maxWidth, _param_padding = param.padding, padding = _param_padding === void 0 ? "0" : _param_padding, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? "1em" : _param_fontSize, _param_color = param.color, color = _param_color === void 0 ? "inherit" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "inherit" : _param_background, border = param.$border, borderWidth = param.$borderWidth, borderStyle2 = param.$borderStyle, borderColor = param.$borderColor, borderRadius = param.borderRadius, _param_onAnimationRest = param.onAnimationRest, onAnimationRest = _param_onAnimationRest === void 0 ? function() {
        return void 0;
    } : _param_onAnimationRest, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick;
    return /* @__PURE__ */ jsx24(AnimatePresence5, {
        initial: false,
        children: show && /* @__PURE__ */ jsxs16(Wrapper12, {
            variants: VARIANTS2,
            initial: "hidden",
            animate: "visible",
            exit: "hidden",
            transition: noAnimation ? {
                duration: 0
            } : void 0,
            $width: width,
            $maxWidth: maxWidth,
            $padding: padding,
            $fontSize: fontSize,
            $color: color,
            $background: background,
            $border: border,
            $borderWidth: borderWidth,
            $borderStyle: borderStyle2,
            $borderColor: borderColor,
            $borderRadius: borderRadius,
            onAnimationComplete: function() {
                return onAnimationRest(show);
            },
            onClick: onClick,
            children: [
                !noIcon && /* @__PURE__ */ jsx24(Icon, _object_spread({
                    icon: "info-circle",
                    type: "solid",
                    color: "info",
                    margin: "0 6px 0 0",
                    translateY: "1px"
                }, iconProps)),
                /* @__PURE__ */ jsx24("span", {
                    children: text
                })
            ]
        })
    });
};
// src/Message/MessageError.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var MessageError = function(_param) {
    var rest = _extends({}, _object_destructuring_empty(_param));
    return /* @__PURE__ */ jsx25(Message, _object_spread({
        iconProps: {
            icon: "exclamation-circle",
            color: "error"
        }
    }, rest));
};
// src/Message/index.ts
var MessageWithVariants = Message;
MessageWithVariants.Error = MessageError;
// src/Modal/Modal.tsx
import { AnimatePresence as AnimatePresence6, motion as motion5 } from "framer-motion";
import { useEffect as useEffect8, useMemo as useMemo10, useRef as useRef10, useState as useState11 } from "react";
import ReactModal from "react-modal";
import styled22 from "styled-components";
import { jsx as jsx26, jsxs as jsxs17 } from "react/jsx-runtime";
var StyledReactModal = styled22(ReactModal)(_templateObject97(), function(props) {
    return !props.$open && "pointer-events: none;";
}, function(props) {
    return props.$zIndex;
});
var Shade = styled22(motion5.div)(_templateObject98(), function(props) {
    return props.$zIndex;
}, function(props) {
    return props.$background;
});
function getPosition(placement, offset) {
    var _placement_split = _sliced_to_array(placement.split("-"), 2), vertical = _placement_split[0], horizontal = _placement_split[1];
    var position = "";
    switch(vertical){
        case "top":
            position += "top: ".concat(offset, "px;");
            break;
        case "center":
            position += "top: 50%;";
            break;
        case "bottom":
            position += "bottom: ".concat(offset, "px;");
            break;
    }
    switch(horizontal){
        case "left":
            position += "left: ".concat(offset, "px;");
            break;
        case "center":
            position += "left: 50%;";
            break;
        case "right":
            position += "right: ".concat(offset, "px;");
            break;
    }
    return position;
}
function getTranslation(placement) {
    var _placement_split = _sliced_to_array(placement.split("-"), 2), vertical = _placement_split[0], horizontal = _placement_split[1];
    var transform = [
        "0px",
        "0px"
    ];
    if (horizontal === "center") transform[0] = "-50%";
    if (vertical === "center") transform[1] = "-50%";
    return transform;
}
var ModalWrapper = styled22(motion5.div)(_templateObject99(), function(props) {
    return props.$zIndex + 1;
}, function(props) {
    return getPosition(props.$placement, props.$offset);
});
var Modal = function(param) {
    var children = param.children, open = param.open, _param_appElementId = param.appElementId, appElementId = _param_appElementId === void 0 ? "root" : _param_appElementId, _param_closeOnEscape = param.closeOnEscape, closeOnEscape = _param_closeOnEscape === void 0 ? false : _param_closeOnEscape, _param_placement = param.placement, placement = _param_placement === void 0 ? "center-center" : _param_placement, _param_direction = param.direction, direction = _param_direction === void 0 ? "from-bottom" : _param_direction, _param_offset = param.offset, offset = _param_offset === void 0 ? 0 : _param_offset, _param_zIndex = param.zIndex, zIndex = _param_zIndex === void 0 ? 7e3 /* Modals */  : _param_zIndex, _param_shadeOpacity = param.shadeOpacity, shadeOpacity = _param_shadeOpacity === void 0 ? 0.3 : _param_shadeOpacity, _param_shadeBackground = param.shadeBackground, shadeBackground = _param_shadeBackground === void 0 ? "black" : _param_shadeBackground, _param_noShade = param.noShade, noShade = _param_noShade === void 0 ? false : _param_noShade, _param_shouldFocusAfterRender = param.shouldFocusAfterRender, shouldFocusAfterRender = _param_shouldFocusAfterRender === void 0 ? true : _param_shouldFocusAfterRender, _param_shouldReturnFocusAfterClose = param.shouldReturnFocusAfterClose, shouldReturnFocusAfterClose = _param_shouldReturnFocusAfterClose === void 0 ? true : _param_shouldReturnFocusAfterClose, onClose = param.onClose, onShadeClick = param.onShadeClick, onOpenFinished = param.onOpenFinished, onCloseFinished = param.onCloseFinished;
    if (typeof onShadeClick === "undefined") onShadeClick = onClose;
    var appElementRef = useRef10(document.getElementById(appElementId));
    var _useState11 = _sliced_to_array(useState11(open), 2), isOpen = _useState11[0], setIsOpen = _useState11[1];
    useEffect8(function() {
        open && setIsOpen(true);
    }, [
        open
    ]);
    var shadeVariants = useMemo10(function() {
        return {
            hidden: {
                opacity: 0
            },
            visible: {
                opacity: shadeOpacity
            }
        };
    }, [
        shadeOpacity
    ]);
    var modalVariants = useMemo10(function() {
        var _getTranslation = _sliced_to_array(getTranslation(placement), 2), tX = _getTranslation[0], tY = _getTranslation[1];
        var dir = direction === "from-bottom" ? 30 : -30;
        return {
            hidden: {
                opacity: 0,
                x: tX,
                y: "calc(".concat(tY, " + ").concat(dir, "px)")
            },
            visible: {
                opacity: 1,
                x: tX,
                y: tY
            }
        };
    }, [
        direction,
        placement
    ]);
    var _appElementRef_current;
    return /* @__PURE__ */ jsxs17(StyledReactModal, {
        appElement: (_appElementRef_current = appElementRef.current) !== null && _appElementRef_current !== void 0 ? _appElementRef_current : void 0,
        className: "modal",
        overlayClassName: "modal-overlay",
        isOpen: isOpen,
        $open: open,
        $zIndex: zIndex,
        shouldCloseOnEsc: closeOnEscape,
        shouldFocusAfterRender: shouldFocusAfterRender,
        shouldReturnFocusAfterClose: shouldReturnFocusAfterClose,
        onRequestClose: onClose,
        children: [
            /* @__PURE__ */ jsx26(AnimatePresence6, {
                children: !noShade && open && /* @__PURE__ */ jsx26(Shade, {
                    variants: shadeVariants,
                    initial: "hidden",
                    animate: open ? "visible" : "hidden",
                    exit: "hidden",
                    $zIndex: zIndex,
                    $background: shadeBackground,
                    onClick: onShadeClick
                })
            }),
            /* @__PURE__ */ jsx26(AnimatePresence6, {
                children: open && /* @__PURE__ */ jsx26(ModalWrapper, {
                    variants: modalVariants,
                    initial: "hidden",
                    animate: open ? "visible" : "hidden",
                    exit: "hidden",
                    $placement: placement,
                    $offset: offset,
                    $zIndex: zIndex,
                    onAnimationComplete: function(state) {
                        return state === "visible" ? onOpenFinished === null || onOpenFinished === void 0 ? void 0 : onOpenFinished() : onCloseFinished === null || onCloseFinished === void 0 ? void 0 : onCloseFinished();
                    },
                    children: children
                })
            })
        ]
    });
};
// src/Prompt/PromptProvider.tsx
import { pick } from "lodash";
import merge from "lodash/merge";
import uniqueId4 from "lodash/uniqueId";
import React20, { useCallback as useCallback13, useContext, useEffect as useEffect9, useRef as useRef11, useState as useState12 } from "react";
// src/Prompt/Prompt.tsx
import { useMemo as useMemo11 } from "react";
import styled23 from "styled-components";
import { jsx as jsx27, jsxs as jsxs18 } from "react/jsx-runtime";
var Wrapper13 = styled23.div(_templateObject100(), function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$padding;
}, function(props) {
    return props.$borderRadius;
});
var PromptButton = styled23(Button)(_templateObject101(), function(props) {
    return props.$padding;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$border;
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$cursor;
}, function(props) {
    return overloadColor(props.$hoverColor);
}, function(props) {
    return overloadColor(props.$hoverBackground);
});
var NormalPrompt = function(param) {
    var prompt = param.prompt, onResolve = param.onResolve;
    var _prompt_options = prompt.options, buttons = _prompt_options.buttons, style = _prompt_options.style;
    return /* @__PURE__ */ jsxs18(Wrapper13, _object_spread_props(_object_spread({}, style), {
        children: [
            prompt.content,
            /* @__PURE__ */ jsx27("div", {
                className: "buttons",
                children: buttons.map(function(button) {
                    return /* @__PURE__ */ jsx27(PromptButton, _object_spread_props(_object_spread({}, button.style), {
                        onClick: function() {
                            return onResolve(button.value);
                        },
                        children: button.label
                    }), button.label);
                })
            })
        ]
    }));
};
var Prompt = function(param) {
    var prompt = param.prompt;
    var content = useMemo11(function() {
        if (typeof prompt.content === "string") return /* @__PURE__ */ jsx27(NormalPrompt, {
            prompt: prompt,
            onResolve: prompt.resolve
        });
        return prompt.content(prompt.resolve, prompt.reject, {
            id: prompt.id
        });
    }, [
        prompt
    ]);
    var _prompt_options_modalProps = prompt.options.modalProps, closeOnClickOutside = _prompt_options_modalProps.closeOnClickOutside, closeOnEscape = _prompt_options_modalProps.closeOnEscape, modalProps = _object_without_properties(_prompt_options_modalProps, [
        "closeOnClickOutside",
        "closeOnEscape"
    ]);
    return /* @__PURE__ */ jsx27(Modal, _object_spread_props(_object_spread({}, modalProps), {
        closeOnEscape: closeOnEscape,
        open: prompt.open,
        onShadeClick: !!closeOnClickOutside ? function() {
            return prompt.reject(-1);
        } : function() {
            return void 0;
        },
        onClose: !!closeOnEscape ? function(evt) {
            return !!evt && "key" in evt && evt.key === "Escape" && prompt.reject(-1);
        } : function() {
            return void 0;
        },
        children: content
    }));
};
// src/Prompt/PromptContainer.tsx
import { Fragment as Fragment5, jsx as jsx28 } from "react/jsx-runtime";
var PromptContainer = function(param) {
    var prompts = param.prompts;
    return /* @__PURE__ */ jsx28(Fragment5, {
        children: prompts.map(function(prompt) {
            return /* @__PURE__ */ jsx28(Prompt, {
                prompt: prompt
            }, prompt.id);
        })
    });
};
// src/Prompt/PromptProvider.tsx
import { jsx as jsx29, jsxs as jsxs19 } from "react/jsx-runtime";
var PromptContext = React20.createContext(null);
function promptOptionDefaults(options) {
    var defaultButtons = [
        {
            value: false,
            label: "Cancel",
            style: {
                $hoverColor: "gray5",
                $cursor: "pointer",
                $background: "gray4"
            }
        },
        {
            value: true,
            label: "Confirm",
            style: {
                $hoverColor: "gray5",
                $cursor: "pointer"
            }
        }
    ];
    var defaultOptions = {
        modalProps: {
            placement: "center-center",
            direction: "from-bottom"
        },
        closeOnResolve: true,
        initialState: {},
        buttons: defaultButtons,
        style: {
            $background: "white",
            $padding: "1rem",
            $borderRadius: "4px"
        }
    };
    return merge({}, defaultOptions, options);
}
function useLocalPromptState(globalOptions) {
    var _useState12 = _sliced_to_array(useState12([]), 2), prompts = _useState12[0], setPrompts = _useState12[1];
    var _useState121 = _sliced_to_array(useState12({}), 2), promptState = _useState121[0], setPromptState = _useState121[1];
    return {
        prompts: prompts,
        setPrompts: setPrompts,
        promptState: promptState,
        setPromptState: setPromptState,
        globalOptions: globalOptions !== null && globalOptions !== void 0 ? globalOptions : {}
    };
}
function usePromptState(id) {
    var ctx = useContext(PromptContext);
    if (ctx === null) throw new Error("usePromptState can only be used within a PromptProvider.");
    if (!Object.prototype.hasOwnProperty.call(ctx.promptState, id)) throw new Error("Prompt state does not exist for this prompt");
    return ctx.promptState[id];
}
function usePrompt() {
    var defaultOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ctx = useContext(PromptContext);
    if (ctx === null) throw new Error("usePrompt can only be used within a PromptProvider.");
    var promptIds = useRef11([]);
    var cleanupPrompts = useCallback13(ctx.setPrompts, []);
    var cleanupState = useCallback13(ctx.setPromptState, []);
    useEffect9(function() {
        promptIds.current = ctx.prompts.map(function(p) {
            return p.id;
        });
    }, [
        ctx
    ]);
    useEffect9(function() {
        return function() {
            cleanupPrompts(function(ps) {
                return ps.filter(function(p) {
                    return !promptIds.current.includes(p.id);
                });
            });
            cleanupState(function(ps) {
                return pick(ps, promptIds.current);
            });
        };
    }, [
        cleanupPrompts,
        cleanupState
    ]);
    return function(content) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var mergedOptions = promptOptionDefaults(merge({}, ctx.globalOptions, defaultOptions, options));
        return new Promise(function(resolve, reject) {
            var id = uniqueId4("prompt");
            ctx.setPromptState(function(v) {
                return _object_spread_props(_object_spread({}, v), _define_property({}, id, mergedOptions.initialState));
            });
            var update = function(value) {
                ctx.setPromptState(function(v) {
                    return _object_spread_props(_object_spread({}, v), _define_property({}, id, _object_spread({}, v[id], value)));
                });
            };
            var closePrompt = function() {
                return ctx.setPrompts(function(ps) {
                    return ps.map(function(p) {
                        return p.id !== id ? p : _object_spread_props(_object_spread({}, p), {
                            open: false
                        });
                    });
                });
            };
            var newPrompt = {
                id: id,
                content: content,
                options: mergedOptions,
                open: true,
                resolve: function resolve1(data) {
                    resolve({
                        data: data,
                        close: closePrompt,
                        update: update
                    });
                    if (mergedOptions.closeOnResolve) closePrompt();
                },
                reject: function reject1(reason) {
                    reject(reason);
                    if (mergedOptions.closeOnResolve) closePrompt();
                }
            };
            ctx.setPrompts(function(ps) {
                return _to_consumable_array(ps).concat([
                    newPrompt
                ]);
            });
        });
    };
}
var PromptProvider = function(param) {
    var children = param.children, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
    var state = useLocalPromptState(options);
    return /* @__PURE__ */ jsxs19(PromptContext.Provider, {
        value: state,
        children: [
            /* @__PURE__ */ jsx29(PromptContainer, {
                prompts: state.prompts
            }),
            children
        ]
    });
};
// src/RadioGroup/RadioGroup.tsx
import { useCallback as useCallback14 } from "react";
// src/RadioGroup/components.ts
import styled24, { css as css9 } from "styled-components";
var flexLayout = function(layout) {
    return css9(_templateObject102(), layout.direction === "horizontal" ? "row" : "column", layout.gap, layout.direction === "horizontal" ? "0 ".concat(layout.gap, " 0 0") : "0 0 ".concat(layout.gap, " 0"));
};
var gridLayout = function(layout) {
    return css9(_templateObject103(), layout.direction === "horizontal" ? "column" : "row", layout.gap, layout.columns && "grid-template-columns: ".concat(layout.columns, ";"), layout.rows && "grid-template-rows: ".concat(layout.rows, ";"), layout.areas && "grid-template-areas: ".concat(layout.areas, ";"));
};
function getLayout(layout) {
    switch(layout.type){
        case "flex":
            return flexLayout(layout);
        case "grid":
            return gridLayout(layout);
    }
}
var Wrapper14 = styled24.div(_templateObject104(), function(props) {
    return getLayout(props.$layout);
});
var RadioWrapper = styled24.div(_templateObject105(), function(props) {
    return props.$gridArea && "grid-area: ".concat(props.$gridArea, ";");
}, function(props) {
    return props.$justifySelf && "justify-self: ".concat(props.$justifySelf, ";");
}, function(props) {
    return props.$alignSelf && "align-self: ".concat(props.$alignSelf, ";");
});
// src/RadioGroup/RadioGroup.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var RadioGroup = function(param) {
    var className = param.className, value = param.value, radios = param.radios, _param_layout = param.layout, layout = _param_layout === void 0 ? {
        type: "flex",
        direction: "vertical",
        gap: "6px"
    } : _param_layout, _param_checkboxProps = param.checkboxProps, checkboxProps = _param_checkboxProps === void 0 ? {} : _param_checkboxProps, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? "1em" : _param_fontSize, onChange = param.onChange;
    var handleRadioClicked = useCallback14(function(radio) {
        onChange(radio.value, radio);
    }, [
        onChange
    ]);
    return /* @__PURE__ */ jsx30(Wrapper14, {
        className: className,
        $layout: layout,
        children: radios.map(function(radio) {
            return /* @__PURE__ */ jsx30(RadioWrapper, {
                className: "--radio-wrapper",
                $gridArea: radio.gridArea,
                $justifySelf: radio.justifySelf,
                $alignSelf: radio.alignSelf,
                children: /* @__PURE__ */ jsx30(Checkbox, _object_spread_props(_object_spread({
                    checkedIconProps: {
                        color: "rgba(0, 0, 0, 0)"
                    },
                    className: "--radio-group-checkbox",
                    checked: radio.value === value,
                    label: radio.label,
                    boxBorderRadius: "999px",
                    fontSize: fontSize
                }, checkboxProps), {
                    onChange: function() {
                        return handleRadioClicked(radio);
                    }
                }))
            }, radio.value);
        })
    });
};
// src/Select/Select.tsx
import React22, { useCallback as useCallback15, useEffect as useEffect10, useImperativeHandle as useImperativeHandle3, useMemo as useMemo12, useRef as useRef12, useState as useState13 } from "react";
// src/Select/components.ts
import styled25, { css as css10 } from "styled-components";
var Wrapper15 = styled25.div(_templateObject106(), function(props) {
    return props.$inline ? "inline-block" : "block";
}, function(props) {
    return props.$width;
}, function(props) {
    return props.$minWidth;
}, function(props) {
    return props.$maxWidth;
}, function(props) {
    return props.$disabled && "\n    filter: grayscale(1) opacity(0.8);\n  ";
});
var Display3 = styled25.div(_templateObject110(), function(props) {
    return props.theme.layout.defaultBorder;
}, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$open && css10(_templateObject107(), function(props2) {
        return props2.theme.sizes.defaultBorderRadius;
    }, function(props2) {
        return props2.theme.sizes.defaultBorderRadius;
    });
}, function(props) {
    return props.$disabled && css10(_templateObject108());
}, function(props) {
    return props.theme.colors.placeholder;
}, function(props) {
    return !props.$open && !props.$disabled && css10(_templateObject109(), function(props2) {
        return props2.theme.colors.primary;
    });
});
var Clear = styled25.div.attrs({
    role: "button"
})(_templateObject111(), function(props) {
    return props.theme.colors.gray5;
}, function(props) {
    return props.theme.colors.gray9;
}, function(props) {
    return props.theme.colors.gray6;
}, function(props) {
    return props.theme.colors.gray8;
});
var SelectDisplay = styled25(Display3)(_templateObject112(), function(props) {
    return props.$height;
});
var SelectMultipleDisplay = styled25(Display3)(_templateObject113(), function(props) {
    return props.$minHeight;
});
var ArrowIcon = styled25(Icon)(_templateObject114());
var Curtain3 = styled25.div(_templateObject115(), function(props) {
    return props.theme.layout.defaultBorder;
}, function(props) {
    return "".concat(props.theme.sizes.defaultBorderRadius, " ").concat(props.theme.sizes.defaultBorderRadius);
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
});
var CurtainOption = styled25.div(_templateObject118(), function(props) {
    return !props.$disabled && css10(_templateObject117(), props.theme.colors.gray8, props.$active && css10(_templateObject116(), props.theme.colors.gray8));
});
var SelectedOption = styled25.div(_templateObject119(), function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return contrastColor(overloadColor(props.$color));
});
var SearchWrapper = styled25.div(_templateObject120());
// src/Select/Select.tsx
import { jsx as jsx31, jsxs as jsxs20 } from "react/jsx-runtime";
var BaseSelect = function(param, ref) {
    var className = param.className, id = param.id, role = param.role, value = param.value, options = param.options, error = param.error, errorTimeout = param.errorTimeout, _param_hideErrorMessage = param.hideErrorMessage, hideErrorMessage = _param_hideErrorMessage === void 0 ? false : _param_hideErrorMessage, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? "Select from list..." : _param_placeholder, _param_noOptionsText = param.noOptionsText, noOptionsText = _param_noOptionsText === void 0 ? "No more options" : _param_noOptionsText, _param_searchable = param.searchable, searchable = _param_searchable === void 0 ? false : _param_searchable, _param_nullable = param.nullable, nullable = _param_nullable === void 0 ? false : _param_nullable, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_inline = param.inline, inline = _param_inline === void 0 ? false : _param_inline, _param_width = param.width, width = _param_width === void 0 ? "332px" : _param_width, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, minWidth = param.minWidth, maxWidth = param.maxWidth, _param_height = param.height, height = _param_height === void 0 ? "32px" : _param_height, _param_color = param.color, color = _param_color === void 0 ? "text.dark" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background, iconProps = param.iconProps, _param_clickOutsideExclude = param.clickOutsideExclude, clickOutsideExclude = _param_clickOutsideExclude === void 0 ? [] : _param_clickOutsideExclude, _param_onErrorTimeout = param.onErrorTimeout, onErrorTimeout = _param_onErrorTimeout === void 0 ? function() {
        return void 0;
    } : _param_onErrorTimeout, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick, _param_onKeyDown = param.onKeyDown, onKeyDown = _param_onKeyDown === void 0 ? function() {
        return void 0;
    } : _param_onKeyDown, _param_onOpen = param.onOpen, onOpen = _param_onOpen === void 0 ? function() {
        return true;
    } : _param_onOpen, _param_onClose = param.onClose, onClose = _param_onClose === void 0 ? function() {
        return true;
    } : _param_onClose, _param_onFilterChange = param.onFilterChange, onFilterChange = _param_onFilterChange === void 0 ? function() {
        return void 0;
    } : _param_onFilterChange, onCurtainScroll = param.onCurtainScroll, onChange = param.onChange;
    var toggleOpen = function toggleOpen(doOpen) {
        if (disabled) return;
        var proceed = doOpen ? onOpen() : onClose();
        if (proceed !== false) setOpen(doOpen);
    };
    var cycleActive = function cycleActive(delta) {
        var clamp = function(n) {
            return Math.max(-1, Math.min(n, filteredOptions.length));
        };
        setActiveIndex(function(idx) {
            return clamp(idx + delta);
        });
    };
    var cycleSelected = function cycleSelected(delta) {
        var idx = filteredOptions.findIndex(function(opt) {
            return opt.value === value;
        });
        if (idx < 0) return;
        var newIdx = Math.max(0, Math.min(idx + delta, filteredOptions.length - 1));
        var newOption = filteredOptions[newIdx];
        onChange(newOption.value, newOption);
    };
    var handleSelect = function handleSelect(option) {
        var _option_value;
        onChange((_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null, option);
        toggleOpen(false);
    };
    var handleKeyDown = function handleKeyDown(evt) {
        onKeyDown(evt);
        if (evt.defaultPrevented) return;
        switch(evt.key){
            case "ArrowDown":
                open ? cycleActive(1) : cycleSelected(1);
                break;
            case "ArrowUp":
                open ? cycleActive(-1) : cycleSelected(-1);
                break;
            case "Enter":
                if (!open) toggleOpen(true);
                else if (activeIndex > -1 && activeIndex < filteredOptions.length) {
                    handleSelect(filteredOptions[activeIndex]);
                    setActiveIndex(function(i) {
                        return Math.max(i - 1, 0);
                    });
                }
                break;
        }
    };
    var handleClearClick = function handleClearClick(evt) {
        evt.stopPropagation();
        handleSelect(null);
    };
    var handleErrorTimeout = function handleErrorTimeout() {
        setInternalError(null);
        onErrorTimeout();
    };
    var wrapperRef = useRef12(null);
    var curtainRef = useRef12(null);
    var _useState13 = _sliced_to_array(useState13(false), 2), open = _useState13[0], setOpen = _useState13[1];
    var _useState131 = _sliced_to_array(useState13(-1), 2), activeIndex = _useState131[0], setActiveIndex = _useState131[1];
    var _useState132 = _sliced_to_array(useState13(""), 2), filter = _useState132[0], setFilter = _useState132[1];
    var _useState133 = _sliced_to_array(useState13(error), 2), internalError = _useState133[0], setInternalError = _useState133[1];
    useImperativeHandle3(ref, function() {
        return {
            toggleOpen: function toggleOpen(open2) {
                setOpen(function(v) {
                    return typeof open2 === "undefined" ? !v : open2;
                });
            }
        };
    });
    useEffect10(function() {
        setInternalError(error);
    }, [
        error
    ]);
    var updateFilter = useCallback15(function(filter2) {
        setFilter(filter2);
        onFilterChange(filter2);
    }, [
        onFilterChange
    ]);
    useEffect10(function() {
        if (!open) {
            setActiveIndex(-1);
            updateFilter("");
        }
    }, [
        open,
        updateFilter
    ]);
    useEffect10(function() {
        if (disabled && open) setOpen(false);
    }, [
        disabled,
        open
    ]);
    useEffect10(function() {
        var el = curtainRef.current;
        if (!el) return;
        try {
            var activeOption = el.querySelectorAll(".--select-curtain-option")[activeIndex];
            if (!activeOption) return;
            activeOption.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        } catch (e) {}
    }, [
        activeIndex
    ]);
    useClickOutside.apply(void 0, [
        wrapperRef,
        function() {
            return toggleOpen(false);
        },
        true
    ].concat(_to_consumable_array(clickOutsideExclude)));
    var filteredOptions = useMemo12(function() {
        return !searchable || filter === "" ? options : options.filter(typeof searchable === "boolean" ? function(option) {
            return typeof option.label === "string" ? option.label.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) : true;
        } : searchable === "custom" ? function() {
            return true;
        } : function(option) {
            return searchable(option, filter);
        });
    }, [
        options,
        filter,
        searchable
    ]);
    var selectedOption = useMemo12(function() {
        var _filteredOptions_find;
        return (_filteredOptions_find = filteredOptions.find(function(o) {
            return o.value === value;
        })) !== null && _filteredOptions_find !== void 0 ? _filteredOptions_find : null;
    }, [
        filteredOptions,
        value
    ]);
    return /* @__PURE__ */ jsxs20(Wrapper15, {
        className: className,
        id: id,
        role: role,
        ref: wrapperRef,
        $disabled: disabled,
        $width: fullWidth ? "100%" : width,
        $minWidth: minWidth,
        $maxWidth: maxWidth,
        $inline: inline,
        onKeyDown: handleKeyDown,
        onClick: onClick,
        children: [
            /* @__PURE__ */ jsx31(ComponentError, {
                className: "--select-error",
                error: internalError,
                hide: hideErrorMessage,
                timeout: errorTimeout,
                onTimeout: handleErrorTimeout
            }),
            /* @__PURE__ */ jsxs20(SelectDisplay, {
                className: "--select-display" + (disabled ? " --select-display-disabled" : ""),
                $open: open,
                tabIndex: tabIndex,
                $disabled: disabled,
                $height: height,
                $color: color,
                $background: background,
                onClick: function() {
                    return toggleOpen(!open);
                },
                children: [
                    /* @__PURE__ */ jsx31("div", {
                        className: "--select-display-inner",
                        children: selectedOption !== null ? /* @__PURE__ */ jsxs20("span", {
                            className: "--select-display-selected",
                            children: [
                                selectedOption.label,
                                nullable && /* @__PURE__ */ jsx31(Clear, {
                                    className: "--select-display-selected-clear",
                                    onClick: handleClearClick,
                                    children: /* @__PURE__ */ jsx31(Icon, {
                                        icon: "times"
                                    })
                                })
                            ]
                        }) : /* @__PURE__ */ jsx31("span", {
                            className: "--select-placeholder",
                            children: placeholder
                        })
                    }),
                    /* @__PURE__ */ jsx31(ArrowIcon, _object_spread({
                        className: "--select-arrow-icon",
                        icon: open ? "chevron-up" : "chevron-down",
                        type: "light",
                        color: "gray6"
                    }, iconProps))
                ]
            }),
            open && /* @__PURE__ */ jsx31(Curtain3, {
                ref: curtainRef,
                className: "--select-curtain",
                $color: color,
                $background: background,
                onScroll: onCurtainScroll,
                children: /* @__PURE__ */ jsxs20("div", {
                    className: "--select-curtain-inner",
                    children: [
                        !!searchable && /* @__PURE__ */ jsx31(SearchWrapper, {
                            className: "--select-curtain-search",
                            children: /* @__PURE__ */ jsx31("input", {
                                value: filter,
                                autoFocus: true,
                                onChange: function(e) {
                                    return updateFilter(e.target.value);
                                }
                            })
                        }),
                        filteredOptions.map(function(option, index) {
                            var classNames = [
                                "--select-curtain-option"
                            ];
                            activeIndex === index && classNames.push("--select-curtain-option-active");
                            value === option.value && classNames.push("--select-curtain-option-selected");
                            var className2 = classNames.join(" ");
                            return /* @__PURE__ */ jsx31(CurtainOption, {
                                className: className2,
                                $active: activeIndex === index,
                                onClick: function() {
                                    return handleSelect(option);
                                },
                                children: option.label
                            }, option.value);
                        }),
                        !filteredOptions.length && /* @__PURE__ */ jsx31(CurtainOption, {
                            className: "--select-curtain-option --select-curtain-option-disabled",
                            $disabled: true,
                            $active: false,
                            children: noOptionsText
                        })
                    ]
                })
            })
        ]
    });
};
var Select = React22.forwardRef(BaseSelect);
// src/Select/SelectMultiple.tsx
import React23, { useCallback as useCallback16, useEffect as useEffect11, useImperativeHandle as useImperativeHandle4, useMemo as useMemo13, useRef as useRef13, useState as useState14 } from "react";
import { jsx as jsx32, jsxs as jsxs21 } from "react/jsx-runtime";
var BaseSelectMultiple = function(param, ref) {
    var className = param.className, id = param.id, role = param.role, selected = param.selected, options = param.options, error = param.error, errorTimeout = param.errorTimeout, _param_hideErrorMessage = param.hideErrorMessage, hideErrorMessage = _param_hideErrorMessage === void 0 ? false : _param_hideErrorMessage, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? "Select from list..." : _param_placeholder, _param_noOptionsText = param.noOptionsText, noOptionsText = _param_noOptionsText === void 0 ? "No more options" : _param_noOptionsText, _param_searchable = param.searchable, searchable = _param_searchable === void 0 ? false : _param_searchable, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_inline = param.inline, inline = _param_inline === void 0 ? false : _param_inline, _param_width = param.width, width = _param_width === void 0 ? "332px" : _param_width, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, minWidth = param.minWidth, maxWidth = param.maxWidth, _param_minHeight = param.minHeight, minHeight = _param_minHeight === void 0 ? "32px" : _param_minHeight, _param_color = param.color, color = _param_color === void 0 ? "text.dark" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background, iconProps = param.iconProps, _param_clickOutsideExclude = param.clickOutsideExclude, clickOutsideExclude = _param_clickOutsideExclude === void 0 ? [] : _param_clickOutsideExclude, _param_onErrorTimeout = param.onErrorTimeout, onErrorTimeout = _param_onErrorTimeout === void 0 ? function() {
        return void 0;
    } : _param_onErrorTimeout, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick, _param_onKeyDown = param.onKeyDown, onKeyDown = _param_onKeyDown === void 0 ? function() {
        return void 0;
    } : _param_onKeyDown, _param_onOpen = param.onOpen, onOpen = _param_onOpen === void 0 ? function() {
        return true;
    } : _param_onOpen, _param_onClose = param.onClose, onClose = _param_onClose === void 0 ? function() {
        return true;
    } : _param_onClose, _param_onFilterChange = param.onFilterChange, onFilterChange = _param_onFilterChange === void 0 ? function() {
        return void 0;
    } : _param_onFilterChange, onCurtainScroll = param.onCurtainScroll, onChange = param.onChange;
    var toggleOpen = function toggleOpen(doOpen) {
        if (disabled) return;
        var proceed = doOpen ? onOpen() : onClose();
        if (proceed !== false) setOpen(doOpen);
    };
    var cycleActive = function cycleActive(delta) {
        var clamp = function(n) {
            return Math.max(-1, Math.min(n, options.length));
        };
        setActiveIndex(function(idx) {
            return clamp(idx + delta);
        });
    };
    var handleAdd = function handleAdd(option) {
        var newSelected = _to_consumable_array(selected).concat([
            option.value
        ]);
        onChange(newSelected, option.value, "add", option);
    };
    var handleRemove = function handleRemove(option) {
        var newSelected = selected.filter(function(v) {
            return v !== option.value;
        });
        onChange(newSelected, option.value, "remove", option);
    };
    var handleKeyDown = function handleKeyDown(evt) {
        onKeyDown(evt);
        if (evt.defaultPrevented) return;
        switch(evt.key){
            case "ArrowDown":
                open ? cycleActive(1) : toggleOpen(true);
                break;
            case "ArrowUp":
                open && cycleActive(-1);
                break;
            case "Enter":
                if (!open) toggleOpen(true);
                else if (activeIndex > -1 && activeIndex < filteredOptions.length) {
                    handleAdd(filteredOptions[activeIndex]);
                    setActiveIndex(function(i) {
                        return Math.max(i - 1, 0);
                    });
                }
                break;
        }
    };
    var handleErrorTimeout = function handleErrorTimeout() {
        setInternalError(null);
        onErrorTimeout();
    };
    var wrapperRef = useRef13(null);
    var curtainRef = useRef13(null);
    var _useState14 = _sliced_to_array(useState14(false), 2), open = _useState14[0], setOpen = _useState14[1];
    var _useState141 = _sliced_to_array(useState14(-1), 2), activeIndex = _useState141[0], setActiveIndex = _useState141[1];
    var _useState142 = _sliced_to_array(useState14(""), 2), filter = _useState142[0], setFilter = _useState142[1];
    var _useState143 = _sliced_to_array(useState14(error), 2), internalError = _useState143[0], setInternalError = _useState143[1];
    useImperativeHandle4(ref, function() {
        return {
            toggleOpen: function toggleOpen(open2) {
                setOpen(function(v) {
                    return typeof open2 === "undefined" ? !v : open2;
                });
            }
        };
    });
    useEffect11(function() {
        setInternalError(error);
    }, [
        error
    ]);
    var updateFilter = useCallback16(function(filter2) {
        setFilter(filter2);
        onFilterChange(filter2);
    }, [
        onFilterChange
    ]);
    useEffect11(function() {
        if (!open) {
            setActiveIndex(-1);
            updateFilter("");
        }
    }, [
        open,
        updateFilter
    ]);
    useEffect11(function() {
        if (disabled && open) setOpen(false);
    }, [
        disabled,
        open
    ]);
    useEffect11(function() {
        var el = curtainRef.current;
        if (!el) return;
        try {
            var activeOption = el.querySelectorAll(".--select-curtain-option")[activeIndex];
            if (!activeOption) return;
            activeOption.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        } catch (e) {}
    }, [
        activeIndex
    ]);
    var _useMemo13 = _sliced_to_array(useMemo13(function() {
        return options.reduce(function(param, o) {
            var _param = _sliced_to_array(param, 2), sel = _param[0], unSel = _param[1];
            if (selected.includes(o.value)) sel.push(o);
            else unSel.push(o);
            return [
                sel,
                unSel
            ];
        }, [
            [],
            []
        ]);
    }, [
        selected,
        options
    ]), 2), selectedOptions = _useMemo13[0], unSelectedOptions = _useMemo13[1];
    var filteredOptions = useMemo13(function() {
        return !searchable || filter === "" ? unSelectedOptions : unSelectedOptions.filter(typeof searchable === "boolean" ? function(option) {
            return typeof option.label == "string" ? option.label.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) : true;
        } : searchable === "custom" ? function() {
            return true;
        } : function(option) {
            return searchable(option, filter);
        });
    }, [
        unSelectedOptions,
        filter,
        searchable
    ]);
    useClickOutside.apply(void 0, [
        wrapperRef,
        function() {
            return toggleOpen(false);
        },
        true
    ].concat(_to_consumable_array(clickOutsideExclude)));
    return /* @__PURE__ */ jsxs21(Wrapper15, {
        className: className,
        id: id,
        role: role,
        ref: wrapperRef,
        $disabled: disabled,
        $width: fullWidth ? "100%" : width,
        $minWidth: minWidth,
        $maxWidth: maxWidth,
        $inline: inline,
        onKeyDown: handleKeyDown,
        onClick: onClick,
        children: [
            /* @__PURE__ */ jsx32(ComponentError, {
                className: "--select-multiple-error",
                error: internalError,
                hide: hideErrorMessage,
                timeout: errorTimeout,
                onTimeout: handleErrorTimeout
            }),
            /* @__PURE__ */ jsxs21(SelectMultipleDisplay, {
                className: "--select-display" + (disabled ? " --select-display-disabled" : ""),
                $open: open,
                tabIndex: tabIndex,
                $disabled: disabled,
                $minHeight: minHeight,
                $color: color,
                $background: background,
                onClick: function() {
                    return toggleOpen(!open);
                },
                children: [
                    /* @__PURE__ */ jsxs21("div", {
                        className: "--select-display-inner",
                        children: [
                            selectedOptions.map(function(option) {
                                var _option_color;
                                return /* @__PURE__ */ jsxs21(SelectedOption, {
                                    className: "--select-display-selected",
                                    $color: (_option_color = option.color) !== null && _option_color !== void 0 ? _option_color : "primary",
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    },
                                    children: [
                                        option.label,
                                        /* @__PURE__ */ jsx32(Icon, {
                                            icon: "times",
                                            type: "light",
                                            color: "gray6",
                                            hoverColor: "white",
                                            onClick: function() {
                                                return handleRemove(option);
                                            }
                                        })
                                    ]
                                }, option.value);
                            }),
                            !selectedOptions.length && /* @__PURE__ */ jsx32("span", {
                                className: "--select-placeholder",
                                children: placeholder
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx32(ArrowIcon, _object_spread({
                        className: "--select-arrow-icon",
                        icon: open ? "chevron-up" : "chevron-down",
                        type: "light",
                        color: "gray6"
                    }, iconProps))
                ]
            }),
            open && /* @__PURE__ */ jsx32(Curtain3, {
                ref: curtainRef,
                className: "--select-curtain",
                tabIndex: tabIndex,
                $color: color,
                $background: background,
                onScroll: onCurtainScroll,
                children: /* @__PURE__ */ jsxs21("div", {
                    className: "--select-curtain-inner",
                    children: [
                        !!searchable && /* @__PURE__ */ jsx32(SearchWrapper, {
                            className: "--select-curtain-search",
                            children: /* @__PURE__ */ jsx32("input", {
                                value: filter,
                                autoFocus: true,
                                onChange: function(e) {
                                    return updateFilter(e.target.value);
                                }
                            })
                        }),
                        filteredOptions.map(function(option, index) {
                            var classNames = [
                                "--select-curtain-option"
                            ];
                            activeIndex === index && classNames.push("--select-curtain-option-active");
                            var className2 = classNames.join(" ");
                            return /* @__PURE__ */ jsx32(CurtainOption, {
                                className: className2,
                                $active: activeIndex === index,
                                onClick: function() {
                                    return handleAdd(option);
                                },
                                children: option.label
                            }, option.value);
                        }),
                        !filteredOptions.length && /* @__PURE__ */ jsx32(CurtainOption, {
                            className: "--select-curtain-option --select-curtain-option-disabled",
                            $disabled: true,
                            $active: false,
                            children: noOptionsText
                        })
                    ]
                })
            })
        ]
    });
};
var SelectMultiple = React23.forwardRef(BaseSelectMultiple);
// src/TextArea/TextArea.tsx
import React24, { useCallback as useCallback17, useEffect as useEffect12, useMemo as useMemo14, useRef as useRef14, useState as useState15 } from "react";
import styled26, { useTheme as useTheme7 } from "styled-components";
import { jsx as jsx33, jsxs as jsxs22 } from "react/jsx-runtime";
var Wrapper16 = styled26.div(_templateObject121(), function(props) {
    return props.$width;
});
var StyledTextArea = styled26.textarea(_templateObject122(), function(props) {
    return props.$height;
}, function(props) {
    return props.$hasHint && "1rem";
}, function(props) {
    return props.$resize;
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle, function(props) {
    return props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.theme.colors.primary;
});
var Submit = styled26.div(_templateObject123(), function(props) {
    return props.theme.colors.gray5;
});
var TextArea = React24.forwardRef(function(param, ref) {
    var className = param.className, id = param.id, value = param.value, error = param.error, errorTimeout = param.errorTimeout, placeholder = param.placeholder, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_autoGrowing = param.autoGrowing, autoGrowing = _param_autoGrowing === void 0 ? false : _param_autoGrowing, _param_autoFocus = param.autoFocus, autoFocus = _param_autoFocus === void 0 ? false : _param_autoFocus, submitConfig = param.submitConfig, _param_height = param.height, height = _param_height === void 0 ? "122px" : _param_height, _param_width = param.width, width = _param_width === void 0 ? "300px" : _param_width, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, rows = param.rows, _param_resize = param.resize, resize = _param_resize === void 0 ? "vertical" : _param_resize, border = param.$border, borderWidth = param.$borderWidth, borderStyle2 = param.$borderStyle, borderColor = param.$borderColor, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? "1em" : _param_fontSize, _param_color = param.color, color = _param_color === void 0 ? "text.dark" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background, onErrorTimeout = param.onErrorTimeout, onClick = param.onClick, onFocus = param.onFocus, onBlur = param.onBlur, onKeyDown = param.onKeyDown, onCtrlEnter = param.onCtrlEnter, onSubmit = param.onSubmit, onChange = param.onChange;
    var handleKeyDown = function handleKeyDown(evt) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(evt);
        if (evt.defaultPrevented) return;
        if (evt.ctrlKey && evt.key === "Enter") {
            onCtrlEnter === null || onCtrlEnter === void 0 ? void 0 : onCtrlEnter(evt);
            if (evt.defaultPrevented) return;
            if ((submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.ctrlEnter) !== false) onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
        }
    };
    var handleErrorTimeout = function handleErrorTimeout() {
        setInternalError(null);
        onErrorTimeout === null || onErrorTimeout === void 0 ? void 0 : onErrorTimeout();
    };
    var handleSubmit = function handleSubmit(evt) {
        if ((typeof submitIcon === "undefined" ? "undefined" : _type_of(submitIcon)) === "object") {
            var _submitIcon_onClick;
            (_submitIcon_onClick = submitIcon.onClick) === null || _submitIcon_onClick === void 0 ? void 0 : _submitIcon_onClick.call(submitIcon, evt);
            if (evt.defaultPrevented) return;
        }
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
    };
    var handleChange = function handleChange(evt) {
        onChange(evt.target.value, evt);
        autoGrow();
    };
    var localRef = useRef14(null);
    var getElement = useCallback17(function() {
        return ref && "current" in ref ? ref.current : localRef === null || localRef === void 0 ? void 0 : localRef.current;
    }, [
        ref
    ]);
    var theme2 = useTheme7();
    var _useState15 = _sliced_to_array(useState15(null), 2), dynamicHeight = _useState15[0], setDynamicHeight = _useState15[1];
    var _useState151 = _sliced_to_array(useState15(error), 2), internalError = _useState151[0], setInternalError = _useState151[1];
    useEffect12(function() {
        setInternalError(error);
    }, [
        error
    ]);
    var autoGrow = useCallback17(function() {
        if (!autoGrowing) return;
        var el = getElement();
        if (!el) return;
        var height2 = el.clientHeight;
        var scrollHeight = el.scrollHeight;
        if (scrollHeight > height2) setDynamicHeight(scrollHeight + 6 + "px");
    }, [
        autoGrowing,
        getElement
    ]);
    var parsedBorder = useMemo14(function() {
        return border !== null && border !== void 0 ? border : theme2.layout.defaultBorder;
    }, [
        border,
        theme2.layout.defaultBorder
    ]);
    var submitIcon = useMemo14(function() {
        return !(submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.icon) ? {
            icon: "paper-plane",
            type: "solid",
            color: "primary",
            cursor: "pointer"
        } : typeof submitConfig.icon === "string" ? {
            icon: submitConfig.icon
        } : submitConfig.icon;
    }, [
        submitConfig
    ]);
    return /* @__PURE__ */ jsxs22(Wrapper16, {
        className: className,
        id: id,
        $width: fullWidth ? "100%" : width,
        children: [
            /* @__PURE__ */ jsx33(ComponentError, {
                className: "--text-area-error",
                error: internalError,
                timeout: errorTimeout,
                onTimeout: handleErrorTimeout
            }),
            /* @__PURE__ */ jsx33(StyledTextArea, {
                ref: ref !== null && ref !== void 0 ? ref : localRef,
                value: value,
                rows: rows,
                placeholder: placeholder,
                disabled: disabled,
                autoFocus: autoFocus,
                $height: dynamicHeight !== null && dynamicHeight !== void 0 ? dynamicHeight : height,
                $resize: resize,
                $fontSize: fontSize,
                $border: parsedBorder,
                $borderWidth: borderWidth,
                $borderStyle: borderStyle2,
                $borderColor: borderColor,
                $color: color,
                $background: background,
                $hasHint: !!(submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.hint),
                onClick: onClick,
                onFocus: onFocus,
                onBlur: onBlur,
                onKeyDown: handleKeyDown,
                onChange: handleChange
            }),
            typeof onSubmit !== "undefined" && (submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.hide) !== true && /* @__PURE__ */ jsxs22(Submit, {
                children: [
                    (submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.hint) && /* @__PURE__ */ jsx33("span", {
                        className: "--submit-hint",
                        children: submitConfig === null || submitConfig === void 0 ? void 0 : submitConfig.hint
                    }),
                    /* @__PURE__ */ jsx33(Icon, _object_spread_props(_object_spread({}, submitIcon), {
                        onClick: handleSubmit
                    }))
                ]
            })
        ]
    });
});
// src/themes/UrThemeProvider.tsx
import { ThemeProvider } from "styled-components";
import merge2 from "lodash/merge";
import { jsx as jsx34 } from "react/jsx-runtime";
var UrThemeProvider = function(param) {
    var children = param.children, theme2 = param.theme;
    var Provider = ThemeProvider;
    return /* @__PURE__ */ jsx34(Provider, {
        theme: _object_spread({}, merge2(light_theme_default, theme2 !== null && theme2 !== void 0 ? theme2 : {})),
        children: children
    });
};
// src/Thumbnail/Thumbnail.tsx
import { useNavigate as useNavigate4 } from "react-router";
import styled27 from "styled-components";
import { jsx as jsx35 } from "react/jsx-runtime";
var shapeClipPathLookups = {
    circle: "circle(50% at 50% 50%)",
    rectangle: "",
    // No clip-path equals a square
    rhombus: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)",
    pentagon: "polygon(50% 0%, 100% 40%, 80% 100%, 20% 100%, 0% 40%)",
    hexagon: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
    hexagonFlatTop: "polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%)",
    octagon: "polygon(30% 0, 70% 0, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0 70%, 0 30%)",
    kite: "polygon(50% 0%, 100% 30%, 50% 100%, 0% 30%)"
};
var Wrapper17 = styled27.div(_templateObject124(), function(props) {
    return props.$shadow && "\n    filter: drop-shadow(".concat(props.$shadow, ");\n  ");
});
var ThumbnailImage = styled27.img(_templateObject125(), function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
}, function(props) {
    return props.$objectFit;
}, function(props) {
    return shapeClipPathLookups[props.$shape];
}, getBorderStyle, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$cursor;
});
var Thumbnail = function(param) {
    var className = param.className, id = param.id, src = param.src, _param_alt = param.alt, alt = _param_alt === void 0 ? "thumnail" : _param_alt, href = param.href, _param_shape = param.shape, shape = _param_shape === void 0 ? "circle" : _param_shape, _param_size = param.size, size = _param_size === void 0 ? "38px" : _param_size, width = param.width, height = param.height, _param_objectFit = param.objectFit, objectFit = _param_objectFit === void 0 ? "cover" : _param_objectFit, border = param.$border, borderWidth = param.$borderWidth, borderStyle2 = param.$borderStyle, borderColor = param.$borderColor, _param_borderRadius = param.borderRadius, borderRadius = _param_borderRadius === void 0 ? "9999px" : _param_borderRadius, shadow = param.shadow, _param_cursor = param.cursor, cursor = _param_cursor === void 0 ? "auto" : _param_cursor, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick;
    var handleClick = function handleClick(evt) {
        onClick(evt);
        if (evt.defaultPrevented || isUndefined(href)) return;
        if (typeof href === "string") navigate(href);
        else navigate(href.pathname, {
            state: href.state
        });
    };
    var navigate = useNavigate4();
    return /* @__PURE__ */ jsx35(Wrapper17, {
        className: className,
        id: id,
        $shadow: shadow,
        children: /* @__PURE__ */ jsx35(ThumbnailImage, {
            src: src,
            alt: alt,
            $shape: shape,
            $width: width !== null && width !== void 0 ? width : size,
            $height: height !== null && height !== void 0 ? height : size,
            $objectFit: objectFit,
            $border: border,
            $borderWidth: borderWidth,
            $borderStyle: borderStyle2,
            $borderColor: borderColor,
            $borderRadius: borderRadius,
            $cursor: cursor,
            onClick: handleClick
        })
    });
};
// src/ThumbnailList/ThumbnailList.tsx
import { isEqual as isEqual2 } from "lodash";
import React25, { useEffect as useEffect13, useRef as useRef15, useState as useState16 } from "react";
import styled28, { css as css11 } from "styled-components";
import { jsx as jsx36 } from "react/jsx-runtime";
var Wrapper18 = styled28.div(_templateObject126(), function(props) {
    return props.$doWrap ? "wrap" : "nowrap";
});
var StyledThumbnail = styled28(Thumbnail)(_templateObject128(), function(props) {
    return props.$offset;
}, function(props) {
    return typeof props.$hoverScale !== "undefined" && css11(_templateObject127(), props.$hoverScale);
});
var ThumbnailList = function(param) {
    var className = param.className, id = param.id, srcList = param.srcList, _param_offset = param.offset, offset = _param_offset === void 0 ? "-10px" : _param_offset, _param_scaleOnHover = param.scaleOnHover, scaleOnHover = _param_scaleOnHover === void 0 ? false : _param_scaleOnHover, tmp = param.wrap, wrap2 = tmp === void 0 ? false : tmp, size = param.size, shadow = param.shadow, cursor = param.cursor, shape = param.shape, border = param.$border, borderColor = param.$borderColor, borderStyle2 = param.$borderStyle, borderWidth = param.$borderWidth, _param_onLoadError = param.onLoadError, onLoadError = _param_onLoadError === void 0 ? function() {
        return void 0;
    } : _param_onLoadError;
    var testImage = function testImage(src) {
        return new Promise(function(resolve) {
            var image = new Image();
            var successHandler = function() {
                image.removeEventListener("load", successHandler);
                resolve([
                    true,
                    src
                ]);
            };
            var errorHandler = function() {
                image.removeEventListener("error", errorHandler);
                resolve([
                    false,
                    src
                ]);
            };
            image.addEventListener("load", successHandler);
            image.addEventListener("error", errorHandler);
            image.src = src.src;
        });
    };
    var prevSrcList = useRef15(null);
    var hoverScale = scaleOnHover !== false ? scaleOnHover === true ? 1.14 : scaleOnHover : void 0;
    var _useState16 = _sliced_to_array(useState16([]), 2), verifiedImages = _useState16[0], setVerifiedImages = _useState16[1];
    useEffect13(function() {
        if (isEqual2(prevSrcList.current, srcList)) return;
        prevSrcList.current = srcList;
        var ret = [];
        var tests = srcList.map(function(src) {
            return testImage(src);
        });
        Promise.all(tests).then(function(results) {
            results.forEach(function(param) {
                var _param = _sliced_to_array(param, 2), success = _param[0], src = _param[1];
                if (!success) {
                    var _src_altRender;
                    ret.push(_object_spread_props(_object_spread({}, src), {
                        render: (_src_altRender = src.altRender) !== null && _src_altRender !== void 0 ? _src_altRender : function() {
                            return null;
                        }
                    }));
                    onLoadError(src);
                } else ret.push(_object_spread_props(_object_spread({}, src), {
                    render: src.src
                }));
            });
            setVerifiedImages(ret);
        });
    }, [
        srcList,
        onLoadError
    ]);
    return /* @__PURE__ */ jsx36(Wrapper18, {
        className: className,
        id: id,
        $doWrap: wrap2,
        children: verifiedImages.map(function(src, index) {
            return typeof src.render === "string" ? /* @__PURE__ */ jsx36(StyledThumbnail, _object_spread_props(_object_spread({
                className: "--thumbnail-list-thumb",
                $offset: offset,
                $hoverScale: hoverScale,
                size: size,
                shadow: shadow,
                cursor: cursor,
                shape: shape,
                $border: border,
                $borderColor: borderColor,
                $borderStyle: borderStyle2,
                $borderWidth: borderWidth
            }, src), {
                src: src.render
            }), src.render + index) : /* @__PURE__ */ jsx36(React25.Fragment, {
                children: src.render()
            }, index);
        })
    });
};
// src/TimePicker/TimePicker.tsx
import { useCallback as useCallback18, useEffect as useEffect14, useMemo as useMemo15, useRef as useRef16, useState as useState17 } from "react";
import styled29, { css as css12, useTheme as useTheme8 } from "styled-components";
import { Fragment as Fragment6, jsx as jsx37, jsxs as jsxs23 } from "react/jsx-runtime";
var NumberInput2 = styled29.input.attrs({
    size: 1
})(_templateObject129());
var Wrapper19 = styled29.div(_templateObject130(), function(props) {
    return props.$height;
}, NumberInput2, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return props.$fontSize;
}, function(props) {
    return overloadColor(props.$separatorColor);
}, function(props) {
    return props.$fontSize;
});
var InnerWrapper = styled29.div(_templateObject131(), function(props) {
    return props.$width;
}, function(props) {
    return props.$minWidth;
}, function(props) {
    return props.$maxWidth;
}, function(props) {
    return props.$padding;
}, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle, function(props) {
    var radius = props.$borderRadius;
    switch(props.$iconSide){
        case "left":
            return "0 ".concat(radius, " ").concat(radius, " 0;");
        case "right":
            return "".concat(radius, " 0 0 ").concat(radius, ";");
        case "both":
            return "0;";
        case "none":
        default:
            return "".concat(radius, ";");
    }
}, function(props) {
    return props.theme.colors.primary;
});
var ICON_WIDTH3 = 42;
var IconWrapper4 = styled29.div(_templateObject133(), ICON_WIDTH3, ICON_WIDTH3, ICON_WIDTH3, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle, function(props) {
    return props.$position === "left" ? "".concat(props.$borderRadius, " 0 0 ").concat(props.$borderRadius) : "0 ".concat(props.$borderRadius, " ").concat(props.$borderRadius, " 0");
}, function(props) {
    return props.$position === "left" ? "1px 0 1px 1px" : "1px 1px 1px 0";
}, function(props) {
    return contrastColor(overloadColor(props.$background), "#eef", "#557", "#557");
}, function(props) {
    return props.$cursor;
}, function(props) {
    return overloadColor(props.$hoverBackground);
}, function(props) {
    return props.$hoverIconColor && css12(_templateObject132(), overloadColor(props.$hoverIconColor));
});
var TimePicker = function(param) {
    var className = param.className, id = param.id, value = param.value, error = param.error, errorTimeout = param.errorTimeout, _param_includeSeconds = param.includeSeconds, includeSeconds = _param_includeSeconds === void 0 ? false : _param_includeSeconds, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_disableWheel = param.disableWheel, disableWheel = _param_disableWheel === void 0 ? false : _param_disableWheel, _param_separator = param.separator, separator = _param_separator === void 0 ? ":" : _param_separator, iconLeftProps = param.iconLeftProps, iconRightProps = param.iconRightProps, width = param.width, minWidth = param.minWidth, maxWidth = param.maxWidth, _param_height = param.height, height = _param_height === void 0 ? "32px" : _param_height, _param_padding = param.padding, padding = _param_padding === void 0 ? "6px" : _param_padding, _param_color = param.color, color = _param_color === void 0 ? "text.dark" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? "inherit" : _param_fontSize, _param_separatorColor = param.separatorColor, separatorColor = _param_separatorColor === void 0 ? "text.gray" : _param_separatorColor, border = param.$border, borderWidth = param.$borderWidth, borderStyle2 = param.$borderStyle, borderColor = param.$borderColor, borderRadius = param.borderRadius, _param_onErrorTimeout = param.onErrorTimeout, onErrorTimeout = _param_onErrorTimeout === void 0 ? function() {
        return void 0;
    } : _param_onErrorTimeout, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick, _param_onWheel = param.onWheel, onWheel = _param_onWheel === void 0 ? function() {
        return void 0;
    } : _param_onWheel, _param_onFocus = param.onFocus, onFocus = _param_onFocus === void 0 ? function() {
        return void 0;
    } : _param_onFocus, _param_onBlur = param.onBlur, onBlur = _param_onBlur === void 0 ? function() {
        return void 0;
    } : _param_onBlur, onChange = param.onChange;
    var hoursRef = useRef16(value.getHours());
    var minutesRef = useRef16(value.getMinutes());
    var secondsRef = useRef16(value.getSeconds());
    var hoursInputRef = useRef16(null);
    var minutesInputRef = useRef16(null);
    var secondsInputRef = useRef16(null);
    var theme2 = useTheme8();
    var pad = function(val) {
        return (val + "").padStart(2, "0");
    };
    var _useState17 = _sliced_to_array(useState17(function() {
        return pad(value.getHours());
    }), 2), internalHours = _useState17[0], setInternalHours = _useState17[1];
    var _useState171 = _sliced_to_array(useState17(function() {
        return pad(value.getMinutes());
    }), 2), internalMinutes = _useState171[0], setInternalMinutes = _useState171[1];
    var _useState172 = _sliced_to_array(useState17(function() {
        return pad(value.getSeconds());
    }), 2), internalSeconds = _useState172[0], setInternalSeconds = _useState172[1];
    var _useState173 = _sliced_to_array(useState17(error), 2), internalError = _useState173[0], setInternalError = _useState173[1];
    useEffect14(function() {
        setInternalError(error);
    }, [
        error
    ]);
    var emitChange = useCallback18(function(values) {
        var _values_hours;
        var h = (_values_hours = values.hours) !== null && _values_hours !== void 0 ? _values_hours : value.getHours();
        var _values_minutes;
        var m = (_values_minutes = values.minutes) !== null && _values_minutes !== void 0 ? _values_minutes : value.getMinutes();
        var _values_seconds;
        var s = (_values_seconds = values.seconds) !== null && _values_seconds !== void 0 ? _values_seconds : value.getSeconds();
        if (h < 0 || h > 23 || m < 0 || m > 59 || s < 0 || s > 59) return;
        hoursRef.current = h;
        minutesRef.current = m;
        secondsRef.current = s;
        var newDate = new Date(value.getTime());
        newDate.setHours(h, m, s);
        onChange(newDate);
    }, [
        value,
        onChange
    ]);
    var handleChange = useCallback18(function(type) {
        return function(evt) {
            var _evt_target = evt.target, value2 = _evt_target.value;
            if (value2.length > 2) value2 = value2.slice(-2);
            else if (value2 === "") value2 = "0";
            if (!/^[0-9]*$/.test(value2)) return;
            var numValue = parseInt(value2, 10);
            if (numValue < 0) return;
            switch(type){
                case "hours":
                    if (numValue > 23) return;
                    emitChange({
                        hours: numValue
                    });
                    setInternalHours(function() {
                        return numValue + "";
                    });
                    if (value2.length === 2 && minutesInputRef.current) minutesInputRef.current.select();
                    break;
                case "minutes":
                    if (numValue > 59) return;
                    emitChange({
                        minutes: numValue
                    });
                    setInternalMinutes(function() {
                        return numValue + "";
                    });
                    if (includeSeconds && value2.length === 2 && secondsInputRef.current) secondsInputRef.current.select();
                    break;
                case "seconds":
                    if (numValue > 59) return;
                    emitChange({
                        seconds: numValue
                    });
                    setInternalSeconds(function() {
                        return numValue + "";
                    });
                    break;
            }
        };
    }, [
        includeSeconds,
        emitChange
    ]);
    var handleClick = useCallback18(function(type) {
        return function(evt) {
            onClick(type, evt);
            if (evt.defaultPrevented) return;
            var target = evt.target;
            if ("select" in target) target.select();
        };
    }, [
        onClick
    ]);
    var handleWheel = useCallback18(function(type) {
        return function(evt) {
            onWheel(type, evt);
            if (evt.defaultPrevented || disableWheel) return;
            var delta = evt.deltaY < 0 ? 1 : -1;
            switch(type){
                case "hours":
                    var hours = (hoursRef.current + delta) % 24;
                    hours < 0 && (hours = 23);
                    emitChange({
                        hours: hours
                    });
                    setInternalHours(function() {
                        return pad(hoursRef.current);
                    });
                    break;
                case "minutes":
                    var minutes = (minutesRef.current + delta) % 59;
                    minutes < 0 && (minutes = 59);
                    emitChange({
                        minutes: minutes
                    });
                    setInternalMinutes(function() {
                        return pad(minutesRef.current);
                    });
                    break;
                case "seconds":
                    var seconds = (secondsRef.current + delta) % 59;
                    seconds < 0 && (seconds = 59);
                    emitChange({
                        seconds: seconds
                    });
                    setInternalSeconds(function() {
                        return pad(secondsRef.current);
                    });
                    break;
            }
        };
    }, [
        onWheel,
        disableWheel,
        emitChange
    ]);
    var handleFocus = useCallback18(function(type) {
        return function(evt) {
            onFocus(type, evt);
            if (evt.defaultPrevented) return;
            var target = evt.target;
            target.select();
        };
    }, [
        onFocus
    ]);
    var handleBlur = useCallback18(function(type) {
        return function(evt) {
            onBlur(type, evt);
            if (evt.defaultPrevented) return;
            switch(type){
                case "hours":
                    setInternalHours(function() {
                        return pad(hoursRef.current);
                    });
                    break;
                case "minutes":
                    setInternalMinutes(function() {
                        return pad(minutesRef.current);
                    });
                    break;
                case "seconds":
                    setInternalSeconds(function() {
                        return pad(secondsRef.current);
                    });
                    break;
            }
        };
    }, [
        onBlur
    ]);
    var handleErrorTimeout = useCallback18(function() {
        setInternalError(null);
        onErrorTimeout();
    }, [
        onErrorTimeout
    ]);
    var overrideIconClick = useCallback18(function(position, evt) {
        if (position === "left" && !isUndefined(iconLeftProps) && isFunction(iconLeftProps.onClick)) iconLeftProps.onClick(evt);
        else if (position === "right" && !isUndefined(iconRightProps) && isFunction(iconRightProps.onClick)) iconRightProps.onClick(evt);
    }, [
        iconLeftProps,
        iconRightProps
    ]);
    var parsedBorder = border !== null && border !== void 0 ? border : theme2.layout.defaultBorder;
    var parsedBorderRadius = borderRadius !== null && borderRadius !== void 0 ? borderRadius : theme2.sizes.defaultBorderRadius;
    var iconSide = useMemo15(function() {
        if (isUndefined(iconLeftProps) && isUndefined(iconRightProps)) return "none";
        else if (isUndefined(iconLeftProps) && !isUndefined(iconRightProps)) return "right";
        else if (!isUndefined(iconLeftProps) && isUndefined(iconRightProps)) return "left";
        else return "both";
    }, [
        iconLeftProps,
        iconRightProps
    ]);
    var _iconLeftProps_boxBackground, _iconRightProps_boxBackground;
    return /* @__PURE__ */ jsxs23(Wrapper19, {
        className: className,
        id: id,
        $height: height,
        $color: color,
        $fontSize: fontSize,
        $separatorColor: separatorColor,
        onClick: function(e) {
            return onClick(null, e);
        },
        children: [
            /* @__PURE__ */ jsx37(ComponentError, {
                className: "--time-picker-error-wrapper",
                error: internalError,
                timeout: errorTimeout,
                onTimeout: handleErrorTimeout
            }),
            iconLeftProps && /* @__PURE__ */ jsx37(IconWrapper4, {
                className: "--time-picker-left-icon-wrapper",
                $position: "left",
                color: color,
                $background: (_iconLeftProps_boxBackground = iconLeftProps.boxBackground) !== null && _iconLeftProps_boxBackground !== void 0 ? _iconLeftProps_boxBackground : background,
                $hoverBackground: iconLeftProps.boxHoverBackground,
                $hoverIconColor: iconLeftProps.boxHoverIconColor,
                $cursor: iconLeftProps.boxCursor,
                $border: parsedBorder,
                $borderWidth: borderWidth,
                $borderStyle: borderStyle2,
                $borderColor: borderColor,
                $borderRadius: parsedBorderRadius,
                onClick: function(e) {
                    return overrideIconClick("left", e);
                },
                children: /* @__PURE__ */ jsx37(Icon, _object_spread_props(_object_spread({}, iconLeftProps), {
                    onClick: void 0
                }))
            }),
            /* @__PURE__ */ jsxs23(InnerWrapper, {
                className: "--time-picker-inner-wrapper",
                $iconSide: iconSide,
                $width: width,
                $minWidth: minWidth,
                $maxWidth: maxWidth,
                $padding: padding,
                $border: parsedBorder,
                $borderWidth: borderWidth,
                $borderStyle: borderStyle2,
                $borderColor: borderColor,
                $borderRadius: parsedBorderRadius,
                $background: background,
                children: [
                    /* @__PURE__ */ jsx37(NumberInput2, {
                        className: "--time-picker-input-hour",
                        ref: hoursInputRef,
                        value: internalHours,
                        disabled: disabled,
                        tabIndex: 0,
                        onClick: handleClick("hours"),
                        onWheel: handleWheel("hours"),
                        onFocus: handleFocus("hours"),
                        onBlur: handleBlur("hours"),
                        onChange: handleChange("hours")
                    }),
                    /* @__PURE__ */ jsx37("span", {
                        className: "--time-picker-separator",
                        children: separator
                    }),
                    /* @__PURE__ */ jsx37(NumberInput2, {
                        className: "--time-picker-input-minute",
                        ref: minutesInputRef,
                        value: internalMinutes,
                        disabled: disabled,
                        tabIndex: 0,
                        onClick: handleClick("minutes"),
                        onWheel: handleWheel("minutes"),
                        onFocus: handleFocus("minutes"),
                        onBlur: handleBlur("minutes"),
                        onChange: handleChange("minutes")
                    }),
                    includeSeconds && /* @__PURE__ */ jsxs23(Fragment6, {
                        children: [
                            /* @__PURE__ */ jsx37("span", {
                                className: "--time-picker-separator",
                                children: separator
                            }),
                            /* @__PURE__ */ jsx37(NumberInput2, {
                                className: "--time-picker-input-second",
                                ref: secondsInputRef,
                                value: internalSeconds,
                                disabled: disabled,
                                tabIndex: 0,
                                onClick: handleClick("seconds"),
                                onWheel: handleWheel("seconds"),
                                onFocus: handleFocus("seconds"),
                                onBlur: handleBlur("seconds"),
                                onChange: handleChange("seconds")
                            })
                        ]
                    })
                ]
            }),
            iconRightProps && /* @__PURE__ */ jsx37(IconWrapper4, {
                className: "--time-picker-right-icon-wrapper",
                $position: "right",
                color: color,
                $background: (_iconRightProps_boxBackground = iconRightProps.boxBackground) !== null && _iconRightProps_boxBackground !== void 0 ? _iconRightProps_boxBackground : background,
                $hoverBackground: iconRightProps.boxHoverBackground,
                $hoverIconColor: iconRightProps.boxHoverIconColor,
                $cursor: iconRightProps.boxCursor,
                $border: parsedBorder,
                $borderWidth: borderWidth,
                $borderStyle: borderStyle2,
                $borderColor: borderColor,
                $borderRadius: parsedBorderRadius,
                onClick: function(e) {
                    return overrideIconClick("right", e);
                },
                children: /* @__PURE__ */ jsx37(Icon, _object_spread_props(_object_spread({}, iconRightProps), {
                    onClick: void 0
                }))
            })
        ]
    });
};
// src/Toast/ToastProvider.tsx
import merge3 from "lodash/merge";
import uniqueId5 from "lodash/uniqueId";
import React28, { useCallback as useCallback20, useContext as useContext2, useState as useState18 } from "react";
// src/Toast/ToastContainer.tsx
import { AnimatePresence as AnimatePresence7, motion as motion6 } from "framer-motion";
import { useMemo as useMemo16, useCallback as useCallback19 } from "react";
import styled30, { keyframes as keyframes6 } from "styled-components";
import { jsx as jsx38, jsxs as jsxs24 } from "react/jsx-runtime";
var ToastWrapper = styled30.div(_templateObject134(), function(props) {
    return props.$width;
}, function(props) {
    return props.$height ? "".concat(props.$height, "px") : "auto";
}, function(props) {
    return props.$showIcon && "auto";
}, function(props) {
    return props.$showCloseIcon && "auto";
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$boxShadow;
}, function(props) {
    return props.$iconWidth;
}, function(props) {
    return props.$height ? "".concat(props.$height, "px") : "".concat(props.$iconWidth, "px");
}, function(props) {
    return props.$alignHorizontal === "right" ? "flex-end" : props.$alignHorizontal === "center" ? "center" : "flex-start";
}, function(props) {
    return props.$alignVertical === "bottom" ? "flex-end" : props.$alignVertical === "center" ? "center" : "flex-start";
}, function(props) {
    return props.$height ? "".concat(props.$height, "px") : "auto";
}, function(props) {
    return props.$padding;
}, function(props) {
    return overloadColor(props.$color);
}, function(props) {
    return props.theme.media.mobile;
});
var AnimatedToast = motion6(ToastWrapper);
var progressBarAnimation = keyframes6(_templateObject135());
var ProgressBar = styled30.div(_templateObject136(), function(props) {
    return props.$height;
}, function(props) {
    return props.$color;
}, progressBarAnimation, function(props) {
    return props.$life;
});
var ToastContainer = function(param) {
    var toasts = param.toasts;
    var indexedToasts = useMemo16(function() {
        var newToasts = _to_consumable_array(toasts);
        var indexes = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newToasts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var toast = _step.value;
                var _indexes_toast_position;
                indexes[toast.position] = ((_indexes_toast_position = indexes[toast.position]) !== null && _indexes_toast_position !== void 0 ? _indexes_toast_position : -1) + 1;
                var _indexes_toast_position1;
                toast.index = (_indexes_toast_position1 = indexes[toast.position]) !== null && _indexes_toast_position1 !== void 0 ? _indexes_toast_position1 : 0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return newToasts;
    }, [
        toasts
    ]);
    var toastIcon = useCallback19(function(type, icons) {
        if (!(icons === null || icons === void 0 ? void 0 : icons[type])) return null;
        switch(type){
            case "success":
                return /* @__PURE__ */ jsx38(Icon, _object_spread({
                    icon: "check",
                    color: "success",
                    fixedWidth: true
                }, icons.success));
            case "error":
                return /* @__PURE__ */ jsx38(Icon, _object_spread({
                    icon: "times",
                    color: "error",
                    fixedWidth: true
                }, icons.error));
            case "warning":
                return /* @__PURE__ */ jsx38(Icon, _object_spread({
                    type: "solid",
                    icon: "exclamation",
                    color: "warning",
                    fixedWidth: true
                }, icons.warning));
            case "info":
                return /* @__PURE__ */ jsx38(Icon, _object_spread({
                    type: "solid",
                    icon: "info",
                    color: "info",
                    fixedWidth: true
                }, icons.info));
        }
    }, []);
    var getToastColor = useCallback19(function(type, colors) {
        if (typeof colors === "string") return colors;
        return colors[type];
    }, []);
    var toastPosition = useCallback19(function(position) {
        var margin = "1rem";
        var pos = function(top, right, bottom, left) {
            return {
                top: top,
                right: right,
                bottom: bottom,
                left: left
            };
        };
        switch(position){
            case "top-left":
                return pos(margin, null, null, margin);
            case "top-center":
                return pos(margin, null, null, "50%");
            case "top-right":
                return pos(margin, margin, null, null);
            case "center-left":
                return pos("50%", null, null, margin);
            case "center-center":
                return pos("50%", null, null, "50%");
            case "center-right":
                return pos("50%", margin, null, null);
            case "bottom-left":
                return pos(null, null, margin, margin);
            case "bottom-center":
                return pos(null, null, margin, "50%");
            case "bottom-right":
                return pos(null, margin, margin, null);
        }
    }, []);
    var toastInitial = useCallback19(function(position, height) {
        switch(position){
            case "top-left":
                return [
                    "0%",
                    -height + "px"
                ];
            case "top-center":
                return [
                    "50%",
                    -height + "px"
                ];
            case "top-right":
                return [
                    "100%",
                    -height + "px"
                ];
            case "center-left":
                return [
                    "0%",
                    "calc(50% - ".concat(height / 2, "px)")
                ];
            case "center-center":
                return [
                    "50%",
                    "calc(50% - ".concat(height / 2, "px)")
                ];
            case "center-right":
                return [
                    "100%",
                    "calc(50% - ".concat(height / 2, "px)")
                ];
            case "bottom-left":
                return [
                    "0%",
                    "calc(100% + ".concat(height, "px)")
                ];
            case "bottom-center":
                return [
                    "50%",
                    "calc(100% + ".concat(height, "px)")
                ];
            case "bottom-right":
                return [
                    "100%",
                    "calc(100% + ".concat(height, "px)")
                ];
        }
    }, []);
    var toastTarget = useCallback19(function(position, height, index) {
        var values = [
            0,
            "0%",
            "0",
            "0"
        ];
        var offset = function(n, off) {
            return "calc(".concat(n, "% + ").concat(off, "px)");
        };
        var calc = function(y, up) {
            return "calc(".concat(y, "% + ").concat((index * height + index * 12) * (up ? -1 : 1), "px)");
        };
        switch(position){
            case "top-left":
                values = [
                    0,
                    calc(0, false),
                    offset(0, 12),
                    offset(0, 12)
                ];
                break;
            case "top-center":
                values = [
                    50,
                    calc(0, false),
                    offset(-50, 0),
                    offset(0, 12)
                ];
                break;
            case "top-right":
                values = [
                    100,
                    calc(0, false),
                    offset(-100, -12),
                    offset(0, 12)
                ];
                break;
            case "center-left":
                values = [
                    0,
                    calc(50, false),
                    offset(0, 12),
                    offset(-50, 0)
                ];
                break;
            case "center-center":
                values = [
                    50,
                    calc(50, false),
                    offset(-50, 0),
                    offset(-50, 0)
                ];
                break;
            case "center-right":
                values = [
                    100,
                    calc(50, false),
                    offset(-100, -12),
                    offset(-50, 0)
                ];
                break;
            case "bottom-left":
                values = [
                    0,
                    calc(100, true),
                    offset(0, 12),
                    offset(-100, -12)
                ];
                break;
            case "bottom-center":
                values = [
                    50,
                    calc(100, true),
                    offset(-50, 0),
                    offset(-100, -12)
                ];
                break;
            case "bottom-right":
                values = [
                    100,
                    calc(100, true),
                    offset(-100, -12),
                    offset(-100, -12)
                ];
                break;
        }
        return {
            x: values[0] + "%",
            y: values[1],
            tx: values[2],
            ty: values[3]
        };
    }, []);
    return /* @__PURE__ */ jsx38(AnimatePresence7, {
        children: indexedToasts.map(function(item) {
            var _toastPosition = toastPosition(item.position), top = _toastPosition.top, right = _toastPosition.right, bottom = _toastPosition.bottom, left = _toastPosition.left;
            var _toastInitial = _sliced_to_array(toastInitial(item.position, item.height), 2), ix = _toastInitial[0], iy = _toastInitial[1];
            var _toastTarget = toastTarget(item.position, item.height, item.index), x = _toastTarget.x, y = _toastTarget.y, tx = _toastTarget.tx, ty = _toastTarget.ty;
            var initial = {
                left: ix,
                top: iy,
                opacity: 0
            };
            var animate = {
                left: x,
                top: y,
                opacity: 1
            };
            var color = getToastColor(item.type, item.color);
            var background = getToastColor(item.type, item.background);
            var progressBarColor = getToastColor(item.type, item.progressBarColor);
            var icon = toastIcon(item.type, item.icons);
            return /* @__PURE__ */ jsxs24(AnimatedToast, {
                initial: initial,
                animate: animate,
                exit: initial,
                style: {
                    top: top !== null && top !== void 0 ? top : void 0,
                    right: right !== null && right !== void 0 ? right : void 0,
                    bottom: bottom !== null && bottom !== void 0 ? bottom : void 0,
                    left: left !== null && left !== void 0 ? left : void 0,
                    transform: "translate(".concat(tx, ", ").concat(ty, ")")
                },
                $width: item.width,
                $height: item.height,
                $padding: item.contentPadding,
                $alignHorizontal: item.contentAlignHorizontal,
                $alignVertical: item.contentAlignVertical,
                $iconWidth: item.iconWidth,
                $color: color,
                $background: background,
                $borderRadius: item.borderRadius,
                $boxShadow: item.boxShadow,
                $showIcon: !!icon,
                $showCloseIcon: item.showCloseIcon,
                children: [
                    !!icon && /* @__PURE__ */ jsx38("div", {
                        className: "icon",
                        children: toastIcon(item.type, item.icons)
                    }),
                    /* @__PURE__ */ jsx38("div", {
                        className: "content",
                        children: item.content
                    }),
                    item.showCloseIcon && /* @__PURE__ */ jsx38("div", {
                        className: "close-icon",
                        children: /* @__PURE__ */ jsx38(Icon, {
                            type: "light",
                            icon: "times",
                            size: "1rem",
                            color: color,
                            hoverColor: "gray6",
                            onClick: item.close
                        })
                    }),
                    item.showProgressBar && /* @__PURE__ */ jsx38(ProgressBar, {
                        $life: item.life,
                        $color: progressBarColor,
                        $height: item.progressBarHeight
                    })
                ]
            }, item.id);
        })
    });
};
var ToastContainer_default = ToastContainer;
// src/Toast/ToastProvider.tsx
import { Fragment as Fragment7, jsx as jsx39, jsxs as jsxs25 } from "react/jsx-runtime";
var ToastContext = React28.createContext(null);
function toastOptionDefaults(options) {
    var _options_icons, _options_icons1, _options_icons2, _options_icons3, _options_icons4, _options_icons5, _options_icons6, _options_icons7;
    var _options_icons8;
    return _object_spread_props(_object_spread({
        life: 4200,
        position: "bottom-right",
        width: 320,
        height: 72,
        contentPadding: "1rem 1.5rem 1rem 1rem",
        contentAlignHorizontal: "left",
        contentAlignVertical: "center",
        color: "text.light",
        background: "gray1",
        borderRadius: "4px",
        boxShadow: "0 2px 6px 1px rgba(0, 0, 0, 0.2)",
        iconWidth: 56,
        progressBarColor: "#d17117",
        progressBarHeight: "4px",
        showCloseIcon: true,
        showProgressBar: true
    }, options), {
        icons: options.icons === null ? null : _object_spread({
            success: ((_options_icons = options.icons) === null || _options_icons === void 0 ? void 0 : _options_icons.success) === null ? null : _object_spread({
                icon: "check",
                color: "success"
            }, (_options_icons1 = options.icons) === null || _options_icons1 === void 0 ? void 0 : _options_icons1.all),
            error: ((_options_icons2 = options.icons) === null || _options_icons2 === void 0 ? void 0 : _options_icons2.error) === null ? null : _object_spread({
                icon: "times",
                color: "error"
            }, (_options_icons3 = options.icons) === null || _options_icons3 === void 0 ? void 0 : _options_icons3.all),
            warning: ((_options_icons4 = options.icons) === null || _options_icons4 === void 0 ? void 0 : _options_icons4.warning) === null ? null : _object_spread({
                icon: "exclamation",
                type: "solid",
                color: "warning"
            }, (_options_icons5 = options.icons) === null || _options_icons5 === void 0 ? void 0 : _options_icons5.all),
            info: ((_options_icons6 = options.icons) === null || _options_icons6 === void 0 ? void 0 : _options_icons6.info) === null ? null : _object_spread({
                icon: "info",
                type: "solid",
                color: "info"
            }, (_options_icons7 = options.icons) === null || _options_icons7 === void 0 ? void 0 : _options_icons7.all)
        }, (_options_icons8 = options.icons) !== null && _options_icons8 !== void 0 ? _options_icons8 : {})
    });
}
function useToast(defaultOptions) {
    var ctx = useContext2(ToastContext);
    if (ctx === null) throw new Error("useToast can only be used within a ToastProvider.");
    var callback = function(type, content, options) {
        return ctx.addToast(type, content, merge3(defaultOptions, options));
    };
    return callback;
}
function useToastState(defaultOptions) {
    var sleep = useSleep();
    var _useState18 = _sliced_to_array(useState18([]), 2), toasts = _useState18[0], setToasts = _useState18[1];
    var addToast = useCallback20(function(type, content, options) {
        return _async_to_generator(function() {
            var _toastOptionDefaults, life, position, width, height, contentPadding, contentAlignHorizontal, contentAlignVertical, color, background, borderRadius, boxShadow, icons, iconWidth, showCloseIcon, showProgressBar, progressBarColor, progressBarHeight, id, newToast;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _toastOptionDefaults = toastOptionDefaults(merge3(defaultOptions !== null && defaultOptions !== void 0 ? defaultOptions : {}, options !== null && options !== void 0 ? options : {})), life = _toastOptionDefaults.life, position = _toastOptionDefaults.position, width = _toastOptionDefaults.width, height = _toastOptionDefaults.height, contentPadding = _toastOptionDefaults.contentPadding, contentAlignHorizontal = _toastOptionDefaults.contentAlignHorizontal, contentAlignVertical = _toastOptionDefaults.contentAlignVertical, color = _toastOptionDefaults.color, background = _toastOptionDefaults.background, borderRadius = _toastOptionDefaults.borderRadius, boxShadow = _toastOptionDefaults.boxShadow, icons = _toastOptionDefaults.icons, iconWidth = _toastOptionDefaults.iconWidth, showCloseIcon = _toastOptionDefaults.showCloseIcon, showProgressBar = _toastOptionDefaults.showProgressBar, progressBarColor = _toastOptionDefaults.progressBarColor, progressBarHeight = _toastOptionDefaults.progressBarHeight;
                        id = uniqueId5("toast");
                        newToast = {
                            id: id,
                            type: type,
                            content: typeof content === "string" ? /* @__PURE__ */ jsx39(Fragment7, {
                                children: content
                            }) : content,
                            life: life,
                            position: position,
                            width: width,
                            height: height,
                            contentPadding: contentPadding,
                            contentAlignHorizontal: contentAlignHorizontal,
                            contentAlignVertical: contentAlignVertical,
                            color: color,
                            background: background,
                            borderRadius: borderRadius,
                            boxShadow: boxShadow,
                            icons: icons,
                            iconWidth: iconWidth,
                            showCloseIcon: showCloseIcon,
                            showProgressBar: showProgressBar,
                            progressBarColor: progressBarColor,
                            progressBarHeight: progressBarHeight,
                            persistent: life === 0,
                            close: function() {
                                return setToasts(function(d) {
                                    return d.filter(function(t) {
                                        return t.id !== id;
                                    });
                                });
                            }
                        };
                        setToasts(function(t) {
                            return _to_consumable_array(t).concat([
                                newToast
                            ]);
                        });
                        if (!!newToast.persistent) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            sleep(newToast.life)
                        ];
                    case 1:
                        _state.sent();
                        newToast.close();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        defaultOptions,
        sleep
    ]);
    return {
        toasts: toasts,
        addToast: addToast
    };
}
var ToastProvider = function(param) {
    var children = param.children, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
    var state = useToastState(options);
    return /* @__PURE__ */ jsxs25(ToastContext.Provider, {
        value: state,
        children: [
            /* @__PURE__ */ jsx39(ToastContainer_default, {
                toasts: state.toasts
            }),
            children
        ]
    });
};
// src/Toggle/Toggle.tsx
import { motion as motion7 } from "framer-motion";
import { useCallback as useCallback21, useMemo as useMemo17, useRef as useRef17 } from "react";
import styled31, { css as css13 } from "styled-components";
import { jsx as jsx40 } from "react/jsx-runtime";
var Wrapper20 = styled31.div(_templateObject139(), function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
}, function(props) {
    return overloadColor(props.$background);
}, getBorderStyle, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$shadow;
}, function(props) {
    return props.$cursor;
}, function(props) {
    return !props.$noBackgroundTransition && css13(_templateObject137(), props.$backgroundTransitionDuration);
}, function(props) {
    return props.$disabled && css13(_templateObject138());
});
var Thumb = styled31(motion7.div)(_templateObject140(), function(props) {
    return props.$width ? "".concat(props.$width, "px") : "calc(50% - ".concat(props.$margin, "px)");
}, function(props) {
    return props.$margin * 2;
}, function(props) {
    return props.$margin;
}, function(props) {
    return overloadColor(props.$background);
}, function(props) {
    return props.$borderRadius;
}, function(props) {
    return props.$shadow;
}, function(props) {
    return props.$disabled ? "not-allowed" : props.$cursor;
});
var Toggle = function(param) {
    var className = param.className, id = param.id, value = param.value, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, _param_width = param.width, width = _param_width === void 0 ? 92 : _param_width, _param_height = param.height, height = _param_height === void 0 ? "32px" : _param_height, _param_background = param.background, background = _param_background === void 0 ? "primary" : _param_background, onBackground = param.onBackground, offBackground = param.offBackground, _param_disabledBackground = param.disabledBackground, disabledBackground = _param_disabledBackground === void 0 ? "gray7" : _param_disabledBackground, border = param.$border, borderStyle2 = param.$borderStyle, borderWidth = param.$borderWidth, borderColor = param.$borderColor, _param_borderRadius = param.borderRadius, borderRadius = _param_borderRadius === void 0 ? "999px" : _param_borderRadius, _param_shadow = param.shadow, shadow = _param_shadow === void 0 ? "inset 1px 1px 2px rgba(0, 0, 0, 0.2)" : _param_shadow, _param_cursor = param.cursor, cursor = _param_cursor === void 0 ? "pointer" : _param_cursor, thumbWidth = param.thumbWidth, _param_thumbMargin = param.thumbMargin, thumbMargin = _param_thumbMargin === void 0 ? 4 : _param_thumbMargin, _param_thumbColor = param.thumbColor, thumbColor = _param_thumbColor === void 0 ? "white" : _param_thumbColor, thumbBorderRadius = param.thumbBorderRadius, _param_thumbShadow = param.thumbShadow, thumbShadow = _param_thumbShadow === void 0 ? "1px 1px 2px rgba(0, 0, 0, 0.2)" : _param_thumbShadow, thumbCursor = param.thumbCursor, _param_noBackgroundTransition = param.noBackgroundTransition, noBackgroundTransition = _param_noBackgroundTransition === void 0 ? false : _param_noBackgroundTransition, backgroundTransitionDuration = param.backgroundTransitionDuration, _param_noThumbAnimation = param.noThumbAnimation, noThumbAnimation = _param_noThumbAnimation === void 0 ? false : _param_noThumbAnimation, _param_thumbAnimationDuration = param.thumbAnimationDuration, thumbAnimationDuration = _param_thumbAnimationDuration === void 0 ? 200 : _param_thumbAnimationDuration, _param_thumbAnimationEasing = param.// ease-in-out-quad function
    thumbAnimationEasing, thumbAnimationEasing = _param_thumbAnimationEasing === void 0 ? function(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    } : _param_thumbAnimationEasing, onChange = param.onChange, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {
        return void 0;
    } : _param_onClick, _param_onKeyDown = param.onKeyDown, onKeyDown = _param_onKeyDown === void 0 ? function() {
        return void 0;
    } : _param_onKeyDown;
    var thumbRef = useRef17(null);
    var draggingRef = useRef17(false);
    var parsedThumbWidth = useMemo17(function() {
        if (!isUndefined(thumbWidth)) return thumbWidth;
        if (!thumbRef.current) return width / 2 - thumbMargin;
        return thumbRef.current.offsetWidth;
    }, [
        thumbMargin,
        thumbWidth,
        width
    ]);
    var emitChange = useCallback21(function(val) {
        onChange(val);
    }, [
        onChange
    ]);
    var handleClick = useCallback21(function(evt) {
        if (draggingRef.current || disabled) return;
        onClick(evt);
        if (evt.defaultPrevented) return;
        emitChange(!value);
    }, [
        onClick,
        emitChange,
        value,
        disabled
    ]);
    var handleKeyDown = useCallback21(function(evt) {
        if (disabled) return;
        onKeyDown(evt);
        if (evt.defaultPrevented) return;
        var key = evt.key;
        if (key === "ArrowRight" && !value) emitChange(true);
        else if (key === "ArrowLeft" && value) emitChange(false);
        else if (key === "Enter" || key === " ") emitChange(!value);
    }, [
        value,
        disabled,
        emitChange,
        onKeyDown
    ]);
    var variants = useMemo17(function() {
        return {
            on: {
                left: width - thumbMargin - parsedThumbWidth,
                translateX: 0
            },
            off: {
                left: thumbMargin,
                translateX: 0
            }
        };
    }, [
        parsedThumbWidth,
        thumbMargin,
        width
    ]);
    var wrapperBackground = useMemo17(function() {
        if (disabled) return disabledBackground !== null && disabledBackground !== void 0 ? disabledBackground : background;
        if (value) return onBackground !== null && onBackground !== void 0 ? onBackground : background;
        else return offBackground !== null && offBackground !== void 0 ? offBackground : background;
    }, [
        value,
        disabled,
        background,
        onBackground,
        offBackground,
        disabledBackground
    ]);
    return /* @__PURE__ */ jsx40(Wrapper20, {
        className: className,
        id: id,
        $disabled: disabled,
        tabIndex: tabIndex,
        $width: width,
        $height: height,
        $background: wrapperBackground,
        $border: border,
        $borderWidth: borderWidth,
        $borderStyle: borderStyle2,
        $borderColor: borderColor,
        $borderRadius: borderRadius,
        $shadow: shadow,
        $cursor: cursor,
        $noBackgroundTransition: noBackgroundTransition,
        $backgroundTransitionDuration: backgroundTransitionDuration !== null && backgroundTransitionDuration !== void 0 ? backgroundTransitionDuration : thumbAnimationDuration * 0.75,
        onKeyDown: handleKeyDown,
        onClick: handleClick,
        children: /* @__PURE__ */ jsx40(Thumb, {
            className: "--toggle-thumb",
            variants: variants,
            initial: false,
            animate: value ? "on" : "off",
            transition: noThumbAnimation ? {
                duration: 0
            } : {
                duration: thumbAnimationDuration / 1e3,
                ease: thumbAnimationEasing
            },
            $disabled: disabled,
            $width: thumbWidth,
            $margin: thumbMargin,
            $background: thumbColor,
            $borderRadius: thumbBorderRadius !== null && thumbBorderRadius !== void 0 ? thumbBorderRadius : borderRadius,
            $shadow: thumbShadow,
            $cursor: thumbCursor !== null && thumbCursor !== void 0 ? thumbCursor : cursor
        })
    });
};
// src/Tooltip/Tooltip.tsx
import { useLayoutEffect as useLayoutEffect3, useRef as useRef18, useState as useState19 } from "react";
import styled32 from "styled-components";
import { jsx as jsx41 } from "react/jsx-runtime";
function getTooltipPlacement(placement) {
    switch(placement){
        case "top-left":
            return "transform: translate(0%, 0%);";
        case "top-center":
            return "transform: translate(-50%, 0%);";
        case "top-right":
            return "transform: translate(-100%, 0%);";
        case "middle-left":
            return "transform: translate(0%, -50%);";
        case "middle-center":
            return "transform: translate(-50%, -50%);";
        case "middle-right":
            return "transform: translate(-100%, -50%);";
        case "bottom-left":
            return "transform: translate(0%, -100%);";
        case "bottom-center":
            return "transform: translate(-50%, -100%);";
        case "bottom-right":
            return "transform: translate(-100%, -100%);";
    }
}
var Wrapper21 = styled32.aside(_templateObject141(), function(props) {
    return props.$show ? "visible" : "hidden";
}, function(props) {
    return "".concat(props.$position.x, "px");
}, function(props) {
    return "".concat(props.$position.y, "px");
}, function(props) {
    return getTooltipPlacement(props.$placement);
}, function(props) {
    return props.$width;
}, function(props) {
    return props.$height;
}, function(props) {
    return props.$padding;
}, function(props) {
    return props.$border;
}, function(props) {
    var _props_$borderRadius;
    return (_props_$borderRadius = props.$borderRadius) !== null && _props_$borderRadius !== void 0 ? _props_$borderRadius : props.theme.sizes.defaultBorderRadius;
}, function(props) {
    return props.theme.layout.defaultShadow;
}, function(props) {
    return props.$color;
}, function(props) {
    return props.$background;
});
var Tooltip = function(param) {
    var children = param.children, className = param.className, id = param.id, _param_placement = param.placement, placement = _param_placement === void 0 ? "top-left" : _param_placement, width = param.width, height = param.height, _param_padding = param.padding, padding = _param_padding === void 0 ? "0.5rem" : _param_padding, border = param.border, borderRadius = param.borderRadius, shadow = param.shadow, _param_color = param.color, color = _param_color === void 0 ? "currentColor" : _param_color, _param_background = param.background, background = _param_background === void 0 ? "white" : _param_background;
    var wrapperRef = useRef18(null);
    var _useState19 = _sliced_to_array(useState19(false), 2), show = _useState19[0], setShow = _useState19[1];
    var _useState191 = _sliced_to_array(useState19({
        x: 0,
        y: 0
    }), 2), pos = _useState191[0], setPos = _useState191[1];
    useLayoutEffect3(function() {
        var update = function update(evt) {
            setPos({
                x: evt.offsetX,
                y: evt.offsetY
            });
        };
        var el = wrapperRef.current;
        if (!el) return;
        var parent = el.parentElement;
        if (!parent) return;
        var show2 = function() {
            return setShow(true);
        };
        var hide = function() {
            return setShow(false);
        };
        parent.addEventListener("mouseenter", show2);
        parent.addEventListener("mouseleave", hide);
        parent.addEventListener("mousemove", update);
        return function() {
            parent.removeEventListener("mouseenter", show2);
            parent.removeEventListener("mouseleave", hide);
            parent.removeEventListener("mousemove", update);
        };
    }, []);
    return /* @__PURE__ */ jsx41(Wrapper21, {
        ref: wrapperRef,
        className: className,
        id: id,
        $show: show,
        $position: pos,
        $placement: placement,
        $width: width,
        $height: height,
        $padding: padding,
        $border: border,
        $borderRadius: borderRadius,
        $shadow: shadow,
        $color: color,
        $background: background,
        children: children
    });
};
// src/VippsLoginButton/VippsLoginButton.tsx
import { useEffect as useEffect16, useRef as useRef19 } from "react";
import styled33 from "styled-components";
// src/VippsLoginButton/useVippsLogin.ts
import { useCallback as useCallback22, useEffect as useEffect15, useState as useState20 } from "react";
// src/util/text.ts
function randomString() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21, characters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_";
    return Array(n).fill("").map(function() {
        return characters[Math.floor(Math.random() * characters.length)];
    }).join("");
}
// src/VippsLoginButton/useVippsLogin.ts
function useVippsLogin(options) {
    var _useState20 = _sliced_to_array(useState20(null), 2), authUri = _useState20[0], setAuthUri = _useState20[1];
    var handleVippsLogin = useCallback22(function() {
        if (!authUri) throw new Error("Auth URI is not ready");
        var state = randomString();
        var spaceSeparatedScope = options.scope.join(" ");
        var vippsAuthUri = window.encodeURI("".concat(authUri, "?response_type=code&client_id=").concat(options.clientId, "&scope=").concat(spaceSeparatedScope, "&state=").concat(state, "&redirect_uri=").concat(options.redirectUri));
        window.open(vippsAuthUri, "_self");
    }, [
        options,
        authUri
    ]);
    useEffect15(function() {
        var abortController = new AbortController();
        window.fetch(options.wellKnownUri, {
            signal: abortController.signal
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (!data.authorization_endpoint) throw new Error("No authorization endpoint in response");
            setAuthUri(data.authorization_endpoint);
        });
        return function() {
            abortController.abort();
        };
    }, [
        options.wellKnownUri
    ]);
    return {
        handleVippsLogin: handleVippsLogin,
        ready: authUri !== null
    };
}
// src/VippsLoginButton/VippsLoginButtonSVG.tsx
import { jsx as jsx42, jsxs as jsxs26 } from "react/jsx-runtime";
var VippsLoginButtonSVG = function(props) {
    return /* @__PURE__ */ jsxs26("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: "44",
        viewBox: "0 0 210 44",
        width: "210",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /* @__PURE__ */ jsx42("path", {
                d: "m0 8c0-2.80026 0-4.20039.544967-5.26995.479363-.94081 1.244273-1.70572 2.185083-2.185083 1.06956-.544967 2.46969-.544967 5.26995-.544967h194c2.8 0 4.2 0 5.27.544967.941.479363 1.706 1.244273 2.185 2.185083.545 1.06956.545 2.46969.545 5.26995v28c0 2.8003 0 4.2004-.545 5.27-.479.9408-1.244 1.7057-2.185 2.185-1.07.545-2.47.545-5.27.545h-194c-2.80026 0-4.20039 0-5.26995-.545-.94081-.4793-1.70572-1.2442-2.185083-2.185-.544967-1.0696-.544967-2.4697-.544967-5.27z",
                fill: "#ff5b24"
            }),
            /* @__PURE__ */ jsxs26("g", {
                fill: "#fff",
                children: [
                    /* @__PURE__ */ jsx42("path", {
                        d: "m20.2401 26.2537h-5.9799v-11.0386h-2.3306v13.0349h8.3105zm5.8884 2.195c2.9539 0 4.7515-1.9331 4.7515-5.1399 0-3.1887-1.8067-5.1218-4.7515-5.1218-2.9358 0-4.7515 1.9422-4.7515 5.1218 0 3.2068 1.7886 5.1399 4.7515 5.1399zm0-1.8337c-1.5627 0-2.457-1.2105-2.457-3.2971 0-2.0867.8943-3.2971 2.457-3.2971 1.5537 0 2.448 1.2104 2.448 3.2971 0 2.0866-.8852 3.2971-2.448 3.2971zm11.0554 5.3928c2.8816 0 4.7063-1.4363 4.7063-3.7036v-9.9275h-2.159v1.5808h-.1535c-.542-1.0749-1.7163-1.7434-3.0623-1.7434-2.5202 0-4.083 1.9692-4.083 4.9954 0 2.9629 1.5537 4.896 4.0469 4.896 1.373 0 2.448-.5782 3.0171-1.6441h.1536v1.8789c0 1.2556-.8943 1.9964-2.43 1.9964-1.2285 0-2.0234-.4427-2.168-1.1382h-2.2492c.1806 1.6982 1.8428 2.8093 4.3811 2.8093zm0-5.6819c-1.5628 0-2.448-1.2104-2.448-3.1255 0-1.906.8852-3.1164 2.448-3.1164 1.5537 0 2.5022 1.2104 2.5022 3.1255 0 1.906-.9395 3.1164-2.5022 3.1164zm11.507 5.6819c2.8816 0 4.7063-1.4363 4.7063-3.7036v-9.9275h-2.1589v1.5808h-.1536c-.542-1.0749-1.7163-1.7434-3.0622-1.7434-2.5203 0-4.083 1.9692-4.083 4.9954 0 2.9629 1.5537 4.896 4.0468 4.896 1.3731 0 2.448-.5782 3.0171-1.6441h.1536v1.8789c0 1.2556-.8943 1.9964-2.4299 1.9964-1.2286 0-2.0235-.4427-2.168-1.1382h-2.2493c.1807 1.6982 1.8428 2.8093 4.3811 2.8093zm0-5.6819c-1.5627 0-2.448-1.2104-2.448-3.1255 0-1.906.8853-3.1164 2.448-3.1164 1.5537 0 2.5022 1.2104 2.5022 3.1255 0 1.906-.9394 3.1164-2.5022 3.1164zm13.1318-9.6023c.7407 0 1.3459-.5871 1.3459-1.3278 0-.7317-.6052-1.3279-1.3459-1.3279-.7317 0-1.337.5962-1.337 1.3279 0 .7407.6053 1.3278 1.337 1.3278zm-1.1111 11.5264h2.2312v-9.8733h-2.2312zm4.8134 0h2.2402v-5.7542c0-1.4814.8401-2.4118 2.177-2.4118 1.364 0 1.9964.7678 1.9964 2.3035v5.8625h2.2402v-6.3865c0-2.3486-1.2014-3.6765-3.4055-3.6765-1.4724 0-2.4661.6685-2.9358 1.7705h-.1536v-1.5808h-2.1589zm11.1096 0h2.2402v-5.7542c0-1.4814.8401-2.4118 2.177-2.4118 1.364 0 1.9963.7678 1.9963 2.3035v5.8625h2.2403v-6.3865c0-2.3486-1.2014-3.6765-3.4055-3.6765-1.4725 0-2.4661.6685-2.9358 1.7705h-.1536v-1.5808h-2.1589zm15.8417 0h2.2402v-6.0071c0-1.2285.822-2.1589 1.9331-2.1589 1.1021 0 1.7886.6684 1.7886 1.7615v6.4045h2.1768v-6.1697c0-1.1291.768-1.9963 1.933-1.9963 1.202 0 1.807.6413 1.807 1.9241v6.2419h2.231v-6.793c0-2.0505-1.192-3.27-3.171-3.27-1.373 0-2.511.7046-2.999 1.7796h-.153c-.4156-1.0931-1.3641-1.7796-2.7281-1.7796-1.3099 0-2.3216.6685-2.7461 1.7796h-.1536v-1.5899h-2.1589zm23.0067-2.7009c-.326.7407-1.093 1.1562-2.205 1.1562-1.472 0-2.42-1.0478-2.475-2.719v-.1174h6.902v-.7136c0-3.0984-1.689-4.9683-4.508-4.9683-2.863 0-4.643 1.9963-4.643 5.167 0 3.1616 1.753 5.0947 4.661 5.0947 2.331 0 3.984-1.1201 4.39-2.8996zm-2.295-5.6187c1.346 0 2.231.9485 2.277 2.448h-4.653c.1-1.4814 1.039-2.448 2.376-2.448zm10.143 8.4822c1.373 0 2.511-.6414 3.071-1.7253h.154v1.5627h2.168v-13.6943h-2.24v5.3928h-.154c-.524-1.084-1.644-1.7344-2.999-1.7344-2.493 0-4.065 1.9692-4.065 5.0947 0 3.1346 1.563 5.1038 4.065 5.1038zm.696-8.3286c1.535 0 2.484 1.2375 2.484 3.2339 0 2.0053-.94 3.2339-2.484 3.2339-1.536 0-2.466-1.2105-2.466-3.2339 0-2.0144.939-3.2339 2.466-3.2339z"
                    }),
                    /* @__PURE__ */ jsx42("path", {
                        clipRule: "evenodd",
                        d: "m199.75 20.0884c-.72-2.7477-2.469-3.8384-4.855-3.8384-1.934 0-4.361 1.0907-4.361 3.7172 0 1.6968 1.173 3.0304 3.085 3.374l1.811.323c1.234.2221 1.584.6869 1.584 1.3132 0 .7071-.761 1.111-1.893 1.111-1.481 0-2.406-.5252-2.551-2.0001l-2.612.4042c.411 2.8483 2.962 4.0204 5.266 4.0204 2.181 0 4.505-1.2528 4.505-3.778 0-1.7174-1.049-2.9696-3.003-3.3337l-1.996-.3633c-1.111-.202-1.481-.7475-1.481-1.2727 0-.6668.72-1.0907 1.708-1.0907 1.255 0 2.139.4239 2.18 1.8179zm-58.075 4.3229 2.715-7.8584h3.188l-4.731 11.6565h-2.366l-4.731-11.6563h3.188zm16.683-4.5249c0 .9292-.74 1.5756-1.604 1.5756s-1.605-.6464-1.605-1.5756c0-.9294.741-1.5756 1.605-1.5756s1.605.6462 1.605 1.5756zm.494 4.1213c-1.07 1.3734-2.201 2.3229-4.197 2.323-2.036 0-3.62-1.2121-4.854-2.9897-.494-.7275-1.255-.889-1.811-.5051-.514.3637-.637 1.1314-.164 1.7982 1.707 2.5656 4.073 4.0602 6.829 4.0602 2.531 0 4.506-1.2119 6.048-3.2322.576-.7473.556-1.515 0-1.9393-.514-.4044-1.275-.2624-1.851.4849zm7.098-1.6568c0 2.384 1.399 3.6367 2.962 3.6367 1.481 0 3.004-1.1719 3.004-3.6367 0-2.4244-1.523-3.5959-2.983-3.5959-1.584 0-2.983 1.1111-2.983 3.5959zm0-4.1815v-1.5964h-2.9v15.677h2.9v-5.576c.967 1.2932 2.222 1.8389 3.641 1.8389 2.654 0 5.246-2.0608 5.246-6.3031 0-4.061-2.695-5.9596-4.999-5.9596-1.831 0-3.086.8281-3.888 1.9192zm13.928 4.1815c0 2.384 1.398 3.6367 2.962 3.6367 1.481 0 3.003-1.1719 3.003-3.6367 0-2.4244-1.522-3.5959-2.983-3.5959-1.584 0-2.983 1.1111-2.983 3.5959zm0-4.1815v-1.5964h-.001-2.9v15.677h2.9v-5.576c.967 1.2932 2.222 1.8389 3.641 1.8389 2.654 0 5.246-2.0608 5.246-6.3031 0-4.061-2.695-5.9596-4.999-5.9596-1.831 0-3.085.8281-3.887 1.9192z",
                        fillRule: "evenodd"
                    })
                ]
            })
        ]
    }));
};
// src/VippsLoginButton/VippsLoginButton.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var Button2 = styled33.button(_templateObject142());
var VippsLoginButton = function(param) {
    var className = param.className, options = param.options, _param_width = param.width, width = _param_width === void 0 ? 210 : _param_width, height = param.height, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, onClick = param.onClick, onVippsLoginResponse = param.onVippsLoginResponse;
    var handleClick = function handleClick(evt) {
        onClick === null || onClick === void 0 ? void 0 : onClick(evt);
        if (evt.defaultPrevented) return;
        handleVippsLogin();
    };
    var hasFiredVippsLoginResponse = useRef19(false);
    var _useVippsLogin = useVippsLogin(options), handleVippsLogin = _useVippsLogin.handleVippsLogin, ready = _useVippsLogin.ready;
    useEffect16(function() {
        if (hasFiredVippsLoginResponse.current) return;
        var queryParameters = new URLSearchParams(window.location.search);
        var code = queryParameters.get("code");
        if (!code) return;
        onVippsLoginResponse(code, options.redirectUri);
        hasFiredVippsLoginResponse.current = true;
    }, [
        onVippsLoginResponse,
        options.redirectUri
    ]);
    return /* @__PURE__ */ jsx43(Button2, {
        className: className,
        disabled: disabled || !ready,
        onClick: handleClick,
        children: /* @__PURE__ */ jsx43(VippsLoginButtonSVG, {
            width: width,
            height: height
        })
    });
};
export { ActionButton, Badge, Breadcrumbs2 as Breadcrumbs, Button, Card, Checkbox, ColorPicker, ComponentSwitchWithCase as ComponentSwitch, ComponentSwitchCase, DatePicker, DateRangePicker, DotsLoader, DropdownMenu, Icon, ImageViewer, Input, Loader, Margin, MessageWithVariants as Message, MessageError, Modal, NumberInput, PromptContext, PromptProvider, RadioGroup, RouteBreadcrumbs, Select, SelectMultiple, SpinnerLoader, TextArea, Thumbnail, ThumbnailList, TimePicker, ToastProvider, Toggle, Tooltip, UrThemeProvider, VippsLoginButton, usePrompt, usePromptState, useToast };
